(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('SampleSubmitController', SampleSubmitController);

    SampleSubmitController.$inject = ['$state', '$rootScope', '$scope', '$localStorage',
                                        'Customer', 'Auth', 'Principal', 'ProfileService',
                                        'LoginService', 'CustomerOrder', 'Contact2ForUser',
                                        'CustomerOrderPdfService', 'AddressList', 'CityList', 'ZipList',
                                        'ProductCategory', 'ProductTypeByCategory', 'StrainNameSearch',
                                        'Assay', 'CustomerByUser', 'CustomPanel', 'ProductType', 'Panel', '$filter', 'SampleFilter', 'SweetAlert', 'AlertService','DataUtils', 'GraphQLService', '$translate', 'BRAND', '$timeout'
                                    ];

    function SampleSubmitController($state, $rootScope, $scope, $localStorage,
                                    Customer, Auth, Principal, ProfileService,
                                    LoginService, CustomerOrder, Contact2ForUser,
                                    CustomerOrderPdfService, AddressList, CityList, ZipList,
                                    ProductCategory, ProductTypeByCategory, StrainNameSearch, Assay,
                                    CustomerByUser, CustomPanel, ProductType, Panel, $filter, SampleFilter, SweetAlert, AlertService, DataUtils, GraphQLService, $translate, BRAND, $timeout
                                    ) {

        var vm = this;
        vm.brand = BRAND || {};
        vm.branding = vm.brand.branding || {};
        vm.contact = vm.brand.contact || {};
        vm.address = vm.brand.address || {};
        vm.companyName = (vm.brand.legal && vm.brand.legal.company_name) || vm.branding.display_name || 'Client Portal';
        vm.pickupLabel = (vm.branding.display_name || 'Lab') + ' Pick-Up';
        vm.getDeliveryPreferenceDisplay = function(deliveryPreference) {
            return deliveryPreference === 'Anresco Pick-Up' ? vm.pickupLabel : deliveryPreference;
        };
        vm.supportEmail = vm.contact.support_email || vm.contact.info_email || '';
        vm.statusEmail = vm.contact.status_email || vm.supportEmail;
        vm.currentLanguage = $translate.proposedLanguage();

        vm.rd = {};
        var rd = {};

        vm.comp = {};
        var comp = {};

        vm.food = {};
        var food = {};

        vm.submitData = false;

        vm.company_discount = $rootScope.customer ? ($rootScope.customer.company_discount ? $rootScope.customer.company_discount : null) :  null;
        vm.show_tab = {
            comp: false,
            rd: false,
            analysis: false,
            fda: false
        };

        vm.active_tab = {
            comp: false,
            rd: false,
            analysis: false,
            fda: false
        }

        // GraphQL query for assays - lightweight payload (13 fields vs 30+ from REST)
        var ASSAYS_LIST_QUERY = `
            query AssaysList($enabled: Boolean) {
                assaysList(enabled: $enabled) {
                    id
                    title
                    reporting_title
                    portalIdentifier
                    portal_client_type
                    portal_client_type_list
                    basePrice
                    analysis_description
                    duration
                    method
                    instrument
                    minimum_quantity_required
                    optimum_quantity_required
                }
            }
        `;


        CustomerByUser.get({}, onSuccess, onError);
        function onSuccess(data, headers) {
            // Update rootScope with fresh data to ensure consistency
            if (!$rootScope.customer) {
                $rootScope.customer = {};
            }
            $rootScope.customer.customer_type = data.businessType ? data.businessType.name : 'Cannabis';
            vm.customer_type = data.businessType ? data.businessType.name.toLowerCase() : 'cannabis';
            
            // Also update the customer type for the RD section
            if (vm.rd) {
                vm.rd.customer_type = $rootScope.customer.customer_type;
            }
            
            setAvailableTabs(vm.customer_type);
        }
        function onError(e) {
            // Fallback to cached data if available
            if ($rootScope.customer && $rootScope.customer.customer_type) {
                vm.customer_type = $rootScope.customer.customer_type.toLowerCase();
                setAvailableTabs(vm.customer_type);
            }
        }


        // Event listeners for file uploads from vanilla JS
        $scope.$on('compFileSelected', function(event, files) {
            if (vm.comp && vm.comp.handleFileSelect) {
                vm.comp.handleFileSelect(files);
            }
        });

        $scope.$on('rdFileSelected', function(event, files) {
            if (vm.rd && vm.rd.handleFileSelect) {
                vm.rd.handleFileSelect(files);
            }
        });

        $scope.$on('foodFileSelected', function(event, files) {
            if (vm.food && vm.food.handleFileSelect) {
                vm.food.handleFileSelect(files);
            }
        });

        $scope.$on('fdaFileSelected', function(event, files) {
            if (vm.fda && vm.fda.handleFileSelect) {
                vm.fda.handleFileSelect(files);
            }
        });

        // Helper function to format file size
        vm.formatFileSize = function(bytes) {
            if (bytes < 1024) {
                return bytes + ' bytes';
            } else if (bytes < 1024 * 1024) {
                return (bytes / 1024).toFixed(2) + ' KB';
            } else {
                return (bytes / (1024 * 1024)).toFixed(2) + ' MB';
            }
        };

        var MAX_ORDER_ATTACHMENT_SIZE = 10 * 1024 * 1024;

        function getTotalFileSize(files) {
            var totalSize = 0;
            angular.forEach(files || [], function(file) {
                totalSize += file && file.size ? file.size : 0;
            });
            return totalSize;
        }

        function readFileForOrderAttachment(file) {
            return new Promise(function(resolve, reject) {
                var reader = new FileReader();
                reader.onload = function(event) {
                    var dataUrl = event.target.result || '';
                    var separatorIndex = dataUrl.indexOf(',');
                    if (separatorIndex === -1) {
                        reject(new Error('The selected file could not be encoded.'));
                        return;
                    }
                    resolve({
                        name: file.name,
                        size: file.size,
                        type: file.type || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                        base64: dataUrl.substring(separatorIndex + 1)
                    });
                };
                reader.onerror = function() {
                    reject(new Error('The selected file could not be read.'));
                };
                reader.readAsDataURL(file);
            });
        }

        function handleExcelImport(orderState, fileInputSelector, extractWorkbook) {
            var fileInput = $(fileInputSelector)[0];
            var file = fileInput && fileInput.files ? fileInput.files[0] : null;
            if (!file) return Promise.reject("You must select a file.");

            if (orderState.processingExcelUpload) {
                return Promise.resolve(false);
            }

            if (!/\.xlsx$/i.test(file.name || '')) {
                AlertService.error('Upload failed. Please select an XLSX file.');
                fileInput.value = '';
                return Promise.resolve(false);
            }

            var proposedTotalSize = getTotalFileSize(orderState.uploadedFiles) +
                getTotalFileSize(orderState.importedExcelFiles) + file.size;
            if (proposedTotalSize > MAX_ORDER_ATTACHMENT_SIZE) {
                AlertService.error('Upload failed. The Excel file and document attachments cannot exceed 10MB total.');
                fileInput.value = '';
                return Promise.resolve(false);
            }

            orderState.importedExcelFiles = orderState.importedExcelFiles || [];
            var samplesBeforeImport = (orderState.samples || []).slice();
            var sampleArrayBeforeImport = (orderState.sampleArray || []).slice();
            var assayIndexMapBeforeImport = orderState.excel_assay_index_map;

            function restoreImportState() {
                orderState.samples = samplesBeforeImport;
                orderState.sampleArray = sampleArrayBeforeImport;
                orderState.excel_assay_index_map = assayIndexMapBeforeImport;
                if (typeof orderState.checkPageOne === 'function') {
                    orderState.checkPageOne();
                }
            }

            orderState.processingExcelUpload = true;

            return Promise.all([
                XlsxPopulate.fromDataAsync(file),
                readFileForOrderAttachment(file)
            ])
            .then(function(results) {
                var importSucceeded = false;
                $scope.$apply(function() {
                    importSucceeded = extractWorkbook(results[0]);
                    if (importSucceeded) {
                        // Keep the source workbook separate from documents shown in the UI.
                        // The backend uploads it to QBench without exposing it as a portal document.
                        orderState.importedExcelFiles.push(results[1]);
                    } else {
                        restoreImportState();
                    }
                });
                return importSucceeded;
            })
            .then(function(importSucceeded) {
                fileInput.value = '';
                orderState.processingExcelUpload = false;
                $scope.$apply();
                return importSucceeded;
            })
            .catch(function(error) {
                restoreImportState();
                fileInput.value = '';
                orderState.processingExcelUpload = false;
                $scope.$apply();
                AlertService.error('Upload failed. The Excel file could not be read.');
                return false;
            });
        }

        // $('#submittingModal').modal('show'); ======================

        vm.isExcelImportProcessing = function() {
            return !!(
                (vm.food && vm.food.processingExcelUpload) ||
                (vm.comp && vm.comp.processingExcelUpload) ||
                (vm.rd && vm.rd.processingExcelUpload)
            );
        };

        vm.switch_tab = function(tab, event) {
            if (vm.isExcelImportProcessing()) {
                if (event) {
                    event.preventDefault();
                    event.stopImmediatePropagation();
                }
                return false;
            }

            angular.forEach(vm.active_tab, function(value, key) {
                vm.active_tab[key] = false;
            });

            vm.active_tab[tab] = true;
            return true;
        };

        function setAvailableTabs(customer_type) {
                        switch(customer_type) {
                case 'cannabis' :
                    vm.show_tab.comp = true;
                    vm.show_tab.rd = true
                    // vm.show_tab.fda = true
                    // vm.active_tab.comp = true;
                    vm.active_tab.rd = true;
                    break;
                case 'hemp':
                    vm.show_tab.rd = true;
                    vm.active_tab.rd = true;
                    // vm.show_tab.fda = true
                    break;
                case 'food service':
                    vm.show_tab.analysis = true;
                    vm.active_tab.analysis = true;
                    break;
                case 'kratom':
                    vm.show_tab.analysis = true;
                    vm.active_tab.analysis = true;
                    vm.food.turnaround_time = '5 day (standard)';
                    break;
                case 'other':
                    vm.show_tab.analysis = true;
                    vm.active_tab.analysis = true;
                    break;
                case 'fda':
                    vm.show_tab.analysis = true;
                    vm.active_tab.analysis = true;
                    vm.show_tab.fda = true;
                    break;
                default:
                    vm.show_tab.analysis = true;
                    vm.active_tab.analysis = true;
                    break;
            }

            getUserEmails();
        }

        vm.give_focus = function(sample, attribute) {
            sample.focus[attribute] = true;
        }

        vm.lose_focus = function(sample, attribute) {
            sample.focus[attribute] = false;
        }

        var QB_VALID_CHARS = /[^A-Za-z0-9,.\?@&!#'~* _\-;+\/:]/g;
        function stripInvalidQBChars(val) {
            if (val === null || val === undefined) return val;
            // Excel can return numeric sample descriptions; normalize before cleaning.
            return String(val).replace(QB_VALID_CHARS, '');
        }

        vm.set_sample_lot_batch_number = function(sample, lot_batch_number) {
            sample.sample_lot_batch_number = stripInvalidQBChars(lot_batch_number);
            sample.options.lot_batch_number = false;
            sample.focus.lot_batch_number = false;
        }

        vm.set_sample_name = function(sample, name) {
            sample.sample_name = stripInvalidQBChars(name);
            sample.options.name = false;
            sample.focus.name = false;
        }

        var ingredientDebounce = null;
        vm.query_ingredients = function(sample) {
            if(ingredientDebounce) { $timeout.cancel(ingredientDebounce); }
            if(sample.ingredient_input.length > 2) {
                ingredientDebounce = $timeout(function() {
                    SampleFilter.ingredients({keyword: sample.ingredient_input},
                        function(data) {
                            sample.options.ingredients = data.length > 0 ? data : [];
                        },
                        function(e) {
                            console.log(e);
                            sample.options.ingredients = [];
                    });
                }, 250);
            } else {
                sample.options.ingredients = [];
            }
        }

        vm.add_ingredient = function(sample, value) {
            if(!sample.sample_product_ingredients_tags) { sample.sample_product_ingredients_tags = []; }
            var val = (value || '').trim();
            var lowerVal = val.toLowerCase();
            var exists = sample.sample_product_ingredients_tags.some(function(t) { return t.toLowerCase() === lowerVal; });
            if(val && !exists) {
                sample.sample_product_ingredients_tags.push(val);
                sample.sample_product_ingredients = sample.sample_product_ingredients_tags.join(', ');
            }
            sample.ingredient_input = '';
            sample.options.ingredients = [];
        }

        vm.remove_ingredient = function(sample, index) {
            if(!sample.sample_product_ingredients_tags) { sample.sample_product_ingredients_tags = []; }
            sample.sample_product_ingredients_tags.splice(index, 1);
            sample.sample_product_ingredients = sample.sample_product_ingredients_tags.length > 0 ? sample.sample_product_ingredients_tags.join(', ') : null;
        }

        vm.ingredient_keydown = function(sample, $event) {
            if($event.keyCode === 13 || $event.keyCode === 188) {
                $event.preventDefault();
                vm.add_ingredient(sample, sample.ingredient_input);
            }
            if($event.keyCode === 8 && !sample.ingredient_input && sample.sample_product_ingredients_tags && sample.sample_product_ingredients_tags.length > 0) {
                vm.remove_ingredient(sample, sample.sample_product_ingredients_tags.length - 1);
            }
        }

        vm.orderFieldOptions = { specialInstructions: [], customerComments: [] };
        vm.orderFieldFocus = {};

        var orderFieldDebounce = null;
        vm.query_order_field = function(orderType, field, dbField) {
            if(orderFieldDebounce) { $timeout.cancel(orderFieldDebounce); }
            var val = vm[orderType][field];
            if(val && val.length > 2) {
                orderFieldDebounce = $timeout(function() {
                    SampleFilter.orderField({field: dbField, keyword: val},
                        function(data) { vm.orderFieldOptions[field] = data; },
                        function(e) { console.log(e); vm.orderFieldOptions[field] = []; });
                }, 250);
            } else { vm.orderFieldOptions[field] = []; }
        }

        vm.set_order_field = function(orderType, field, value) {
            vm[orderType][field] = value;
            vm.orderFieldOptions[field] = [];
        }

        vm.set_sample_autofill = function(sample, option) {
            if(option.name) {
                sample.sample_name = stripInvalidQBChars(option.name);
            }

            if(option.product_category_id) {
                var category_index = findWithAttr(vm[sample.sample_order_type].categories, 'id', option.product_category_id)
                if(category_index != -1) {
                    sample.sample_category = vm[sample.sample_order_type].categories[category_index]
                    vm[sample.sample_order_type].populateTypes(sample)
                }
            }
            else {
                sample.sample_category = null;
            }

            if(option.product_type_id) {
                var type_index = findWithAttr(sample.sample_types, 'id', option.product_type_id)
                if(type_index != -1) {
                    sample.sample_type = sample.sample_types[type_index]
                }
            }
            else {
                sample.sample_type = null;
            }

            if(option.inhalable_edible) {
                var type_index = findWithAttr(vm.inhalable_edible_array , 'name', option.inhalable_edible)
                if(type_index != -1) {
                    sample.sample_inhalable = vm.inhalable_edible_array [type_index]
                }
            }
            else {
                sample.sample_inhalable = null;
            }

            sample.sample_product_ingredients = option.product_ingredients ? option.product_ingredients : null;
            sample.sample_product_ingredients_tags = option.product_ingredients ? option.product_ingredients.split(',').map(function(s) { return s.trim(); }).filter(Boolean) : [];

            sample.focus.autofill = false;
            checkPage(sample.sample_order_type);
        }

        vm.query_autofill = function(sample) {
            sample.sample_name = stripInvalidQBChars(sample.sample_name);
            if(sample.sample_name.length > 2) {
                SampleFilter.autofill({attribute: 'name', keyword: sample.sample_name},
                    function(data) {
                        if(data.length == 0) {
                            sample.options.autofillSampleInfo = [];
                        }
                        else {
                            sample.options.autofill = data;
                        }
                    },
                    function(e) {
                        console.log(e);
                });
            }

            checkPage(sample.sample_order_type);
        }
        vm.query_sample_lot_batch_number = function(sample) {
            sample.sample_lot_batch_number = stripInvalidQBChars(sample.sample_lot_batch_number);
            if(sample.sample_lot_batch_number.length > 2) {
                SampleFilter.attribute({attribute: 'lot_batch_number', keyword: sample.sample_lot_batch_number},
                    function(data) {
                        if(data.length == 0) {
                            sample.options.lot_batch_number = [];
                        }
                        else {
                            sample.options.lot_batch_number = data;
                        }
                    },
                    function(e) {
                        console.log(e);
                });
            }

            checkPage(sample.sample_order_type);
        }

        vm.query_sample_name = function(sample) {
            sample.sample_name = stripInvalidQBChars(sample.sample_name);
            if(sample.sample_name.length > 2) {
                SampleFilter.attribute({attribute: 'name', keyword: sample.sample_name},
                    function(data) {
                        if(data.length == 0) {
                            sample.options.name = [];
                        }
                        else {
                            sample.options.name = data;
                        }
                    },
                    function(e) {
                        console.log(e);
                });
            }

            checkPage(sample.sample_order_type);
        }

        function checkPage(order_type) {
            switch(order_type) {
                case 'rd':
                    vm.rd.checkPageOne();
                    break;
                case 'comp':
                    vm.comp.checkPageOne();
                    break;
                case 'food':
                    vm.food.checkPageOne();
                    break;
            }
        }

        vm.const = {
            PLANT : 'POTENCY_PLANT',
            NON_PLANT: 'POTENCY_LCDAD_NON_PLANT'
        }

        vm.inhalable_edible_array  = [
            {
                'id': 1,
                'name': 'Inhalable',
                'value':'INHALABLE'
            },
            {
                'id': 2,
                'name': 'Non-Inhalable',
                'value':'NONINHALABLE'
            }
        ];

        function getCustomerData() {
            CustomerByUser.get({}, onSuccess, onError);
            function onSuccess(data, headers) {
                 vm.customerData = data;
                 vm.company_discount = data.company_discount;
                 vm.order_type = vm.comp.customer_type == 'Cannabis' ? 'Compliance' : 'RnD';
                 // not currently being used
                //  vm.customerData.added_assays = JSON.parse(data.added_assays);

                 if (vm.customerData != null && vm.customerData.address != null) {
                     var partsOfStr = vm.customerData.address.split('\n');

                     vm.customerData.contact = partsOfStr[0];
                     vm.customerData.street = partsOfStr[1];
                     vm.customerData.city_state_zip = partsOfStr[2];
                 }

                 if(vm.customerData.qbAddress) {
                     vm.customerData.qbAddressArray = vm.customerData.qbAddress.split('\n');
                 }

                 if (vm.customerData.privateSampleByDefault == null) {
                	 vm.customerData.privateSampleByDefault = false;
                 }
                 vm.customerData.default_addresses = vm.customerData.default_addresses && JSON.parse(vm.customerData.default_addresses);
                 if(vm.customerData.default_addresses){
                    var addresses = vm.customerData.default_addresses
                    $scope.records.forEach(function(element){
                        if(element.id == addresses.distributionLocation){
                            vm.samplingAddress = createAddress(element.address, element.city, element.zipCode, element.distributorName, element.medicalLicence, element.licenceList);
                        }

                        if(element.id == addresses.manufacturingLocation){
                            vm.manufacturingAddress = createAddress(element.address, element.city, element.zipCode, element.distributorName, element.medicalLicence, element.licenceList);                            
                        }

                        if(element.id == addresses.pickupLocation){
                            vm.pickup_address = createInvoicingAddress(element.address, element.city, element.zipCode, element.distributorName, element.medicalLicence);                            
                        }

                        if(element.id == addresses.samplingLocation){
                            vm.pickup_address = createInvoicingAddress(element.address, element.city, element.zipCode, element.distributorName, element.medicalLicence);                            
                        }

                        if(element.id == addresses.cultivationLocation){
                            vm.manufacturingAddress = createAddress(element.address, element.city, element.zipCode, element.distributorName, element.medicalLicence, element.licenceList);
                            vm.samplingAddress = createAddress(element.address, element.city, element.zipCode, element.distributorName, element.medicalLicence, element.licenceList);
                        }
                    })
                    var distribution = $scope.records.find(function(record){
                        return record.id == addresses.distributionLocation
                    })
                    if (distribution) {
                      vm.fullLocationComp = distribution.fullLocation;
                    }
                    var manufacture = $scope.records.find(function(record){
                      return record.id == addresses.manufacturingLocation
                    })
                    if (manufacture) {
                      vm.fullLocationManufactur = manufacture.fullLocation;
                    }

                    var pickup = $scope.records.find(function(record){
                        return record.id == addresses.pickupLocation
                    })
                    if (pickup) {
                      vm.fullLocationPickup = pickup.fullLocation;
                    }

                    var sampling = $scope.records.find(function(record){
                        return record.id == addresses.samplingLocation
                    })
                    if (sampling) {
                      vm.fullLocationSampling = sampling.fullLocation;
                    }

                    var reporting = $scope.records.find(function(record){
                        return record.id == addresses.cultivationLocation
                    })
                    if (reporting) {
                      vm.fullLocationreporting = reporting.fullLocation;
                      vm.fullLocationManufactur = reporting.fullLocation;
                    }
                  }
                 if(vm.show_tab.rd) {
                     rd.getAssayData();
                     rd.getCategories();
                     // getQbenchPanels is now called at the end of rd.getAssayData() after showTestsArray is populated
                 }
                 else if(vm.show_tab.analysis) {
                     food.getAssayData();
                     // Both QBench panels and customer panels are now loaded at the end of food.getAssayData()
                }
                getCurrentContact();
            }
            function onError(e) {
                console.log(e);
            }
        }

        rd.getCustomerData = function() {
            CustomerByUser.get({}, onSuccess, onError);
            function onSuccess(data, headers) {
                 vm.customerData = data;
                 vm.company_discount = data.company_discount;
                 vm.order_type = vm.comp.customer_type == 'Cannabis' ? 'Compliance' : 'RnD';
                 // not currently being used
                //  vm.customerData.added_assays = JSON.parse(data.added_assays);

                 if (vm.customerData != null && vm.customerData.address != null) {
                     var partsOfStr = vm.customerData.address.split('\n');
                     vm.customerData.contact = partsOfStr[0];
                     vm.customerData.street = partsOfStr[1];
                     vm.customerData.city_state_zip = partsOfStr[2];
                 }

                 if (vm.customerData.privateSampleByDefault == null) {
                	 vm.customerData.privateSampleByDefault = false;
                 }

                rd.getAssayData();
            }
            function onError(e) {
                console.log(e);
            }
        }

        rd.getCategories = function() {
            ProductCategory.query({}, onSuccess, onError);

            function onSuccess(data, headers) {
                 // Filter out Environmental category if language is Japanese
                 if ($localStorage.language === 'Japanese') {
                    vm.rd.categories = data.filter(function(category) {
                        return category.name !== 'Environmental';
                    });
                } else {
                    vm.rd.categories = data;
                }
                rd.getTypes();
                return;
            }

            function onError(e) {
                console.log(e);
                return;
            }
        }

        food.getCustomerData = function() {
            CustomerByUser.get({}, onSuccess, onError);
            function onSuccess(data, headers) {
                 vm.customerData = data;
                 vm.company_discount = data.company_discount;
                 vm.order_type = vm.comp.customer_type == 'Cannabis' ? 'Compliance' : 'RnD';

                 if (vm.customerData != null && vm.customerData.address != null) {
                     var partsOfStr = vm.customerData.address.split('\n');
                     vm.customerData.contact = partsOfStr[0];
                     vm.customerData.street = partsOfStr[1];
                     vm.customerData.city_state_zip = partsOfStr[2];
                 }

                 if (vm.customerData.privateSampleByDefault == null) {
                     vm.customerData.privateSampleByDefault = false;
                 }

                food.getAssayData();
                
                // Load customer-specific panels
                food.getCustomerPanels();
            }
            function onError(error) {

            }
        }

// **************************** START FOOD FUNCTIONS ****************************

        vm.food.step = 1;
        vm.food.pageOneValid = false;
        vm.food.pageTwoValid = false;
        vm.food.pageThreeValid = false;
        vm.food.customer_type = $rootScope.customer ? ($rootScope.customer.customer_type ? $rootScope.customer.customer_type : 'Cannabis') : 'Cannabis';
        vm.food.company_discount = $rootScope.customer ? ($rootScope.customer.company_discount ? $rootScope.customer.company_discount : null) :  null;
        vm.food.file = null;
        vm.food.specialInstructions = null;
        vm.food.customerComments = null;
        // vm.food.turnaroundTime = null;
        vm.food.turnaroundTime  = vm.food.turnaroundTimeOptions ? null : '10 Days (standard)';
        vm.food.estimated_report_date = null;
        vm.food.categories = null;
        vm.food.sampleArray = [];
        vm.food.all_types = null;
        vm.food.existing_user_added_assays = [];
        vm.food.manufacturing_address = null;
        vm.food.deliveryPreference = null;
        vm.food.orderPO = null;
        vm.food.pickup_arrival_date = null;
        vm.food.emails = '';
        vm.food.samples = [];
        vm.food.tests = [];
        vm.food.testsRequested = [];
        vm.food.testsRequestedCount = [];
        vm.food.total = 0;
        vm.food.mainCollapse = false;
        vm.food.subtotal = null;
        vm.food.total_discount = 0;
        vm.food.excel_assay_header = null;
        vm.food.processingExcelUpload = false;
        vm.food.assay_map = {};
        vm.food.assay_map_by_index = {};
        vm.food.all_assay_map_by_id = {};
        vm.food.all_tests = [];
        vm.food.showTests = {};
        vm.food.showTestsArray = [];
        vm.food.showTestResults = null;
        vm.food.panels = {};
        vm.food.panels.current_panel_index = null;
        vm.food.panels.new_panel_name = null;
        vm.food.panel_by_id_map = {}
        vm.food.current_sample_name = null;
        vm.food.customPanels = [];
        vm.food.qbenchPanels = [];
        vm.food.test_to_search = '';
        vm.food.other_analyses = [];
        vm.food.user_added_assays = [];
        vm.food.existing_user_added_assays = [];
        vm.food.number_of_freq_assays = 0;
        vm.food.submitting = false;
        vm.food_sample_matrix = null;
        vm.food.uploadedFiles = [];
        vm.food.importedExcelFiles = [];

        vm.food.handleFileSelect = function(files) {
            if (files && files.length > 0) {
                var allowedTypes = ['application/pdf', 'image/png', 'image/jpeg'];
                
                var currentSize = getTotalFileSize(vm.food.uploadedFiles);
                currentSize += getTotalFileSize(vm.food.importedExcelFiles);
                
                var newFilesSize = 0;
                for (var i = 0; i < files.length; i++) {
                    newFilesSize += files[i].size;
                }
                
                if (currentSize + newFilesSize > MAX_ORDER_ATTACHMENT_SIZE) {
                    var totalMB = ((currentSize + newFilesSize) / (1024 * 1024)).toFixed(2);
                    alert('Total file size (' + totalMB + 'MB) exceeds 10MB limit.');
                    document.getElementById('food-file-upload').value = '';
                    return;
                }
                
                for (var i = 0; i < files.length; i++) {
                    var file = files[i];
                    
                    if (allowedTypes.indexOf(file.type) === -1) {
                        alert('File type not allowed: ' + file.name + '. Only PDF, PNG, and JPEG files are accepted.');
                        continue;
                    }
                    
                    (function(f) {
                        var reader = new FileReader();
                        reader.onload = function(e) {
                            vm.food.uploadedFiles.push({
                                name: f.name,
                                size: f.size,
                                type: f.type,
                                base64: e.target.result.split(',')[1]
                            });
                            $scope.$apply();
                        };
                        reader.readAsDataURL(f);
                    })(file);
                }
                
                document.getElementById('food-file-upload').value = '';
            }
        };

        vm.food.removeFile = function(index) {
            vm.food.uploadedFiles.splice(index, 1);
        };

        function parseInstrument(instrument) {
            var matching_string = '';
            if(instrument) {
                if(instrument.length > 10) {
                    matching_string = instrument.match(/\(([^)]+)\)/);
                    if(matching_string) {
                        return matching_string[1];
                    }
                    else {
                        return '';
                    }
                }
                else {
                    return instrument;
                }
            }
            else {
                return '';
            }
        }

        function splitString(string) {
            var string_array = null;
            if(string) {
                if(string.includes('|')) {
                    string_array = string.split('|').map( function(item) {
                        return item.trim();
                    });
                }
                else {
                    string_array = string.split(',').map( function(item) {
                        return item.trim();
                    });
                }
                return string_array;
            }
            else {
                return [];
            }
        }

        function addCommasToList(list) {
            if(list) {
                if(list.length > 1) {
                    for(var i = 0; i < list.length - 1; i++) {
                        list[i] += ','
                    }
                }
            }
        }

            // Function to get Japanese description based on assay ID
            function getJapaneseDescription(assayId) {
                // Map of assay IDs to Japanese descriptions from the CSV file
                var japaneseDescriptions = {
                    '930': '日本厚生労働省の基準に対応した、LC-MS/MSを用いた高感度のカンナビノイド検査（13種）を実施します。',
                    '978': '日本厚生労働省の基準に対応した、LC-MS/MSを用いた高感度のカンナビノイド検査（D8-THC, THCV, THCVAを除く10種）を実施します。',
                    '931': '日本厚生労働省の基準に対応した、LC-MS/MSを用いた高感度のカンナビノイド検査（追加分析パッケージ含む30種）を実施します。',
                    '5': 'GC-MSを使用し、カリフォルニア州法で定められている20種類の残留溶媒のスクリーニングを実施します。',
                    '6': 'ICP-MSを用いたヒ素、カドミウム、鉛、水銀のスクリーニング試験（重金属検査）を実施します。',
                    '797': 'アピゲニン｜ケルセチン｜ルテオリン｜ミリセチン｜ケンフェロール｜ルチン｜ビテキシン｜イソビテキシン｜ビテキシン｜オリエンチン｜イソビテキシン｜ルチン｜イソビテキシン｜カテキン｜エピカテキンガレート（EGCG）｜ビテキシン',
                    '780': 'アメリカの各州が定めるヘンプ製品の重金属基準を統一的にクリアするための検査基準です。国内外の最高水準の安全基準をクリアした製品として、消費者に対し圧倒的な安心感と信頼性を提供できます。',
                    '37': 'カンナビノイド含有量の比較分析を実施（同一ロット内の複数検体における成分濃度の均質性評価）します。',
                    '12': '米国薬局法（USP）のガイドラインに準拠したカンナビノイドの含有量の比較分析を実施（同一ロット内の複数検体における成分濃度の均質性評価）します。',
                    '14': '標準平板菌数、酵母およびカビ、大腸菌群、一般大腸菌の定量試験を含む品質管理を目的とした微生物分析パネル。',
                    '4': '吸入製品を対象に、カリフォルニア州大麻取締局ガイドラインに準拠した志賀毒素産生性大腸菌、サルモネラ菌およびアスペルギルスのパネル分析を実施します。',
                    '17': '非吸入製品を対象に、カリフォルニア州大麻取締局ガイドラインに準拠した志賀毒素産生性大腸菌およびサルモネラ菌のパネル分析を実施します。',
                    '951': 'アメリカの各州が定めるヘンプ製品の微生物基準を統一的にクリアするための検査基準です。国内外の最高水準の安全基準をクリアした製品として、消費者に対し圧倒的な安心感と信頼性を提供できます。',
                    '16': 'アフラトキシン B1、B2、G1、G2、およびオクラトキシンAの検査を含みます。',
                    '764': 'カリフォルニア州大麻取締局の要件に準拠した21種類のカテゴリーI農薬、45種類のカテゴリーII農薬、アフラトキシン、およびオクラトキシンが含まれます。',
                    '8': 'LC-MS/MSおよびGC-MS/MSを使用し、カリフォルニア州大麻取締局の基準に基づいた66種類の農薬スクリーニングを実施します。',
                    '779': 'アメリカの各州が定めるヘンプ製品の農薬基準を統一的にクリアするための検査基準です。国内外の最高水準の安全基準をクリアした製品として、消費者に対し圧倒的な安心感と信頼性を提供できます。',
                    '86': '「志賀毒素産生性大腸菌（Shiga toxin-producing E. coli: STEC）」検査は、特に重篤な食中毒を引き起こす可能性のある志賀毒素（Stx、またはベロ毒素: VT）を産生する大腸菌の存在を確認するための検査です。別名「腸管出血性大腸菌（Enterohemorrhagic E. coli: EHEC）」とも呼ばれます。',
                    '315': 'サルモネラ菌検査は、食中毒の原因菌として知られるサルモネラ属菌が存在するかどうかを確認するための検査です。',
                    '75': '「標準平板菌数（Standard Plate Count: SPC）」とは、食品や環境中の衛生状態を評価するための指標となる菌数を測定する検査です。別名「一般生菌数」とも呼ばれます。',
                    '7': 'GC-MSを使用し、大麻の花や製品に最も一般的に含まれる27種類のテルペノイドのプロファイリングを実施します。',
                    '60': '',
                    '18': '「水分活性（water activity: Aw）」とは、食品や化粧品、医薬品などの製品中に含まれる水分の中で、微生物が利用できる自由水の割合を示す指標であり、その製品の保存性や安定性を評価するための重要な検査です。',
                    '1023': '酵母とカビ（これらを総称して「真菌」と呼ぶこともあります）の存在とその量を調べる検査です。これらの微生物は、製品の変質、劣化、または健康被害の原因となることがあるため、品質管理や衛生管理において非常に重要です。',
                    '19': '製品の中に、本来含まれるべきではない物質が混入していないかを確認するための検査全般を指します。顧客からのクレーム対応や、製造工程における品質管理、そして最終的には消費者の安全を確保するために不可欠な検査です。'
                };
                
                return japaneseDescriptions[assayId] || null;
            }


        function parseAssayInfoModalData(assay) {
            var base_price = null;
            var discount = null;
            var display_price = null;
            var method = null
            var instrument = null;
            var description = null;
            var duration = null;
            var minimum_quantity_required = null;
            var optimum_quantity_required = null;

            if(assay.basePrice) {
                base_price = assay.basePrice
            }

            if(vm.company_discount) {
                discount = vm.company_discount;
            }

            if(assay.duration) {
                duration = assay.duration;
            }

            if(assay.minimum_quantity_required) {
                minimum_quantity_required = assay.minimum_quantity_required;
            }

            if(assay.optimum_quantity_required) {
                optimum_quantity_required = assay.optimum_quantity_required;
            }

            if(assay.assay_customer) {
                if(assay.assay_customer.active) {
                    if(assay.assay_customer.basePrice) {
                        base_price = assay.assay_customer.basePrice;
                    }
                    if(assay.assay_customer.discount) {
                        discount = assay.assay_customer.discount;
                    }
                }
            }

            if(assay.instrument) {
                instrument = splitString(assay.instrument)
                instrument.forEach( function(item, index) {
                    if(parseInstrument(item) != ""){
                        instrument[index] = parseInstrument(item);
                    }
                });
                instrument = null
                addCommasToList(method);
            }

            if(assay.method) {
                method = splitString(assay.method);
                // addCommasToList(method);
            }

            if(assay.analysis_description) {
                description = assay.analysis_description;
            }

            if($localStorage.language === 'Japanese') {
                var japaneseDesc = getJapaneseDescription(assay.id);
                if(japaneseDesc) {
                    description = japaneseDesc;
                }
            }


            if(base_price) {
                if(discount) {
                    display_price = base_price * (1 - (discount / 100));
                }
                else {
                    display_price = base_price;
                }
            }

            if(base_price == display_price) {
                display_price = null;
            }

            if(base_price) {
                base_price = $filter('currency')(base_price);
            }

            if(display_price) {
                display_price = $filter('currency')(display_price);
            }

            if(base_price || method || instrument || description || duration || minimum_quantity_required || optimum_quantity_required) {
                return({
                    base_price: base_price,
                    discount: discount,
                    display_price: display_price,
                    method: method,
                    instrument: instrument,
                    description: description,
                    duration: duration,
                    minimum_quantity_required: minimum_quantity_required,
                    optimum_quantity_required: optimum_quantity_required
                });
            }
            else {
                return null;
            }
        }

        food.serializeSamples = function(samples) {
            var serializedSamples = [];
            if (samples) {
                samples.forEach( function(sample){
                    serializedSamples.push({
                        description: sample.sample_name,
                        lotBatchNumber: sample.sample_lot_batch_number ? sample.sample_lot_batch_number : null,
                        timeOfCollection: sample.sample_time_of_collection_backend ? sample.sample_time_of_collection_backend : null,
                        comments: sample.sample_comments ? sample.sample_comments : null,
                        otherAnalysis: sample.sample_other_analyses ? formatOtherAnalyses(sample.sample_other_analyses) : null,
                        sampleTests: formatSampleTests(sample, 'food'),
                        expirationDate: formatDate(sample.sample_expiration_date),
                        production_date: formatDate(sample.sample_production_date),  // ADD THIS 
                        upc_number: sample.sample_upc_number ? sample.sample_upc_number : null,
                        number_of_units_submitted: sample.sample_number_of_units_submitted ? sample.sample_number_of_units_submitted : null,
                        sample_condition: sample.sample_condition ? sample.sample_condition : null,
                        sample_matrix: sample.food_sample_matrix ? sample.food_sample_matrix : null,
                        supplier_name: sample.sample_supplier_name ? sample.sample_supplier_name : null,     // ADD THIS 
                        supplier_lot_code: sample.sample_supplier_lot_code ? sample.sample_supplier_lot_code : null, // ADD THIS 
                        expected_potency: sample.sample_expected_potency ? sample.sample_expected_potency : null
                    });
                });
            }
            return serializedSamples;
        }

        food.serializePayload = function() {
            vm.food.submitting = true;
            var payload = {
                orderType: "FOOD",
                collection_type: null,
                customer_account_id: $localStorage.customerId,
                dateCreated: null,
                dateReceived: null,
                date_submitted: null,
                delivery_preference: formatDeliveryPreference(vm.food.deliveryPreference),
                estimated_arrival_date: formatDate(vm.food.pickup_arrival_date),
                partially_complete: null,
                poNumber: vm.food.orderPO,
                reporting_preference: null,
                sample_condition: null,
                sampledDate: formatDate(vm.food.pickup_arrival_date),
                samplingAddress: vm.manufacturingAddress ? vm.manufacturingAddress : null,
                invoicing_address: vm.invoicing_address ? vm.invoicing_address : vm.customerData.qbAddress,
                shipping_carrier: null,
                specialInstructions: vm.food.specialInstructions,
                customerComments: vm.food.customerComments,
                state: null,
                pickup_address: vm.pickup_address ? vm.pickup_address : null,
                phone_number: vm.contact.phone ? vm.contact.phone : null,
                submitted_by: vm.food.emailsArray.join(),
                dynamic_turnaround_time: vm.food.turnaroundTime,
                id: null,
                samples: food.serializeSamples(vm.food.samples),
                tracking_number: vm.food.tracking_number,
                uploaded_files: vm.food.uploadedFiles,
                source_workbooks: vm.food.importedExcelFiles
            }

            return payload;
        }
        function formatOtherAnalyses(other_analyses) {
            var requested_tests = [];
            angular.forEach(other_analyses, function(value, key) {
                    requested_tests.push(key);
            });

            return requested_tests;
        }       

        vm.food.submitOrder = function() {
            $rootScope.type = 'FOOD';
            CustomerOrder.save(food.serializePayload(), onSaveSuccess, onSaveError);
        }


        vm.food.cancelOrder = function() {
            location.reload();
        }

        vm.food.sampleConditionOptions = ['Ambient', 'Refrigerated', 'Frozen'];

        vm.food.addSample = function() {
            vm.food.samples.push({
                sample_expanded: vm.food.mainCollapse,
                sample_order_type: 'food',
                sample_checked: null,
                sample_delete: false,
                sample_name: null,
                sample_lot_batch_number: null,
                sample_time_of_collection: null,
                sample_time_of_collection_frontend: null,
                sample_time_of_collection_backend: null,
                sample_expiration_date: null,
                sample_expiration_date_open: false,
                sample_production_date: null,
                sample_production_date_open: false,
                sample_time_of_collection_open: false,
                sample_calendar_open: false,
                sample_tests: [],
                sample_other_analyses: {},
                sample_has_tests: null,
                sample_panel_by_id: null,
                sample_panel_type: null,
                sample_current_panel_title: null,
                sample_upc_number: null,
                sample_number_of_units_submitted: null,
                sample_condition: null,
                focus: {
                    name: false,
                    lot_batch_number: false
                },
                options: {
                    name: [],
                    lot_batch_number: []
                }
            });
            vm.food.checkPageOne();
        }

        function formatDateTimeForOrder(date, useUTC) {
            var dateObj = new Date(date);
            if (isNaN(dateObj.getTime())) return null;

            var months, days, year, hours, minutes;
            if (useUTC) {
                months = dateObj.getUTCMonth() + 1;
                days = dateObj.getUTCDate();
                year = dateObj.getUTCFullYear();
                hours = dateObj.getUTCHours();
                minutes = dateObj.getUTCMinutes();
            } else {
                months = dateObj.getMonth() + 1;
                days = dateObj.getDate();
                year = dateObj.getFullYear();
                hours = dateObj.getHours();
                minutes = dateObj.getMinutes();
            }

            var ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12;
            hours = hours ? hours : 12;

            var formattedDate = `${months.toString().padStart(2, '0')}/${days.toString().padStart(2, '0')}/${year}`;
            var formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')} ${ampm}`;

            return `${formattedDate} ${formattedTime}`;
        }


        food.formatSampleDateTime = function(sample) {
            // Frontend: local timezone for display
            sample.sample_time_of_collection_frontend = formatDateTimeForOrder(sample.sample_time_of_collection, false);
            // Backend: UTC for QBench submission
            sample.sample_time_of_collection_backend = formatDateTimeForOrder(sample.sample_time_of_collection, true);

            return;
        }

        vm.food.checkPageOne = function() {
            var date = null;
            if (vm.food.samples.length < 1) {
                vm.food.pageOneValid = false;
                return;
            }
            for(var i = 0; i < vm.food.samples.length; i++) {
                date = vm.food.samples[i].sample_time_of_collection;
                if (!vm.food.samples[i].sample_name || !vm.food.samples[i].sample_condition) {
                    vm.food.pageOneValid = false;
                    return;
                }
            }
            vm.food.pageOneValid = true;
            return;
        }

        vm.food.checkPageTwo = function() {
            var other_analysis_is_empty = null;
            var sample_array_is_empty = null;

            for(var i = 0; i < vm.food.samples.length; i++) {
                if(vm.food.samples[i].sample_time_of_collection) {
                    food.formatSampleDateTime(vm.food.samples[i]);
                }

                other_analysis_is_empty = Object.keys(vm.food.samples[i].sample_other_analyses).length == 0;
                sample_array_is_empty = vm.food.sampleArray[i] ? Object.keys(vm.food.sampleArray[i]).length == 0 : true;

                if (sample_array_is_empty && other_analysis_is_empty){
                    vm.food.pageTwoValid = false;
                    return;
                }
                else {
                    if (sample_array_is_empty) {
                        if (Object.values(vm.food.samples[i].sample_other_analyses).indexOf(true) == -1) {
                            vm.food.pageTwoValid = false;
                            return
                        }
                    }
                    else if (other_analysis_is_empty) {
                        if (Object.values(vm.food.sampleArray[i]).indexOf(true) == -1) {
                            vm.food.pageTwoValid = false;
                            return;
                        }
                    }
                    else {
                        if ((Object.values(vm.food.samples[i].sample_other_analyses).indexOf(true) == -1) && (Object.values(vm.food.sampleArray[i]).indexOf(true) == -1)) {
                            vm.food.pageTwoValid = false;
                            return;
                        }
                    }
                }
            }
            vm.food.pageTwoValid = true;
            return;
        }

        vm.food.checkPageThree = function() {
            if (
                !vm.food.pickup_arrival_date ||
                !vm.food.deliveryPreference ||
                !($('#foodEmailRecepients').val().length > 0) ||
                (vm.food.deliveryPreference==='Anresco Pick-Up' && !vm.fullLocationPickup) ||
                (vm.fullLocationPickup && !vm.contact.phone) ||
                vm.pickupOutOfStateError 

            ) {
                vm.food.pageThreeValid = false;
                return;
            }
            vm.food.pageThreeValid = true;
            return;
        }

        vm.food.removeSample = function(index) {
            vm.food.samples.splice(index, 1);
            vm.food.sampleArray.splice(index, 1);
            food.resetDeleteCheckboxes();
            vm.food.checkPageOne();
        }

        vm.food.openCalendar = function(sample, key) {
            sample[key] = true;
        }

        vm.food.estimateReportDate = function(turnaround_time) {
            var days_length = turnaround_time.split(' days')[0];
            var days = null;

            if(days_length.includes('-')) {
                days = days_length.split('-')[1];
            }
            else {
                days = days_length;
            }

            days = parseInt(days);

            if (days && turnaround_time && vm.food.pickup_arrival_date) {
                var tomorrow = new Date(vm.food.pickup_arrival_date.getTime());
                for (var i = 0; i < days; i++) {
                    tomorrow.setDate(tomorrow.getDate() + 1)
                    if (tomorrow.getDay() == 0) {
                        tomorrow.setDate(tomorrow.getDate() + 1)
                    }
                    else if (tomorrow.getDay() == 6) {
                        tomorrow.setDate(tomorrow.getDate() + 2)
                    }
                }

                vm.food.estimated_report_date = tomorrow;
            }

            if (tomorrow) {
                var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
                vm.food.estimated_report_date.day = days[tomorrow.getDay()]
                vm.food.estimated_report_date.month_day_year = tomorrow.toDateString().substring(4);
            }
            vm.food.checkPageThree();
        }

        vm.food.deleteChecked = function() {
            for(var i = vm.food.samples.length-1; i >= 0; i--) {
                if (vm.food.samples[i].sample_delete) {
                    vm.food.samples.splice(i, 1);
                }
            }
            food.resetDeleteCheckboxes();
            vm.food.checkPageOne();
        }

        food.resetDeleteCheckboxes = function() {
            $(':checkbox.food-delete-checkbox-header')[0].checked = false;
            vm.food.samples.forEach( function(sample) {
                sample.sample_delete = false;
            });
        }

        vm.food.clickCheckAllTest = function(col) {
            var testToAdd = vm.food.assay_map_by_index[col];
            var found = false;
            var selector = ':checkbox.assay-col-header-' + col;
            var test = {};

            vm.food.samples.forEach( function(sample, sample_index) {
                sample.sample_tests.forEach( function(test, test_index) {
                    if (test.id == testToAdd.id) {
                        found = true;
                        sample.sample_tests[test_index].checked = $(selector)[0].checked;
                        vm.food.sampleArray[sample_index][col] = $(selector)[0].checked;
                        
                        // Check if this sample has a panel selected and update panel status if needed
                        if (sample.sample_panel_selected && !$(selector)[0].checked) {
                            vm.food.checkPanelTestsSelection(sample_index);
                        }
                    }
                });
                if (!found) {
                    if (!vm.food.sampleArray[sample_index]) {
                        vm.food.sampleArray[sample_index] = {};
                        vm.food.sampleArray[sample_index][col] = $(selector)[0].checked;
                    }
                    test = Object.assign({}, testToAdd)
                    vm.food.sampleArray[sample_index][col] = $(selector)[0].checked;
                    test.checked = $(selector)[0].checked;
                    
                    // Check if this sample has a panel selected and update panel status if needed
                    if (sample.sample_panel_selected && !$(selector)[0].checked) {
                        vm.food.checkPanelTestsSelection(sample_index);
                    }
                    sample.sample_tests.push(test);
                }
                found = false;
               food.checkSampleContainsTrueTests(sample_index);
            });
            vm.food.checkPageTwo();
        }


        vm.food.clickCheckAllDelete = function() {
            vm.food.samples.forEach( function(sample) {
                sample.sample_delete = $(':checkbox.food-delete-checkbox-header')[0].checked;
            });
        }

        vm.food.clickDelete = function(index) {
            vm.food.samples[index].sample_delete = !vm.food.samples[index].sample_delete;
            $(':checkbox.comp-delete-checkbox-header')[0].checked = false;
        }

        vm.food.checkClick = function (sample, testToAdd, row, col) {
            
            
            var found = false;
            var test = null;
            $(':checkbox.assay-col-header-' + col)[0].checked = false;
            // check if test exists, if yes then checked = !checked
            for(var i = 0; i < sample.sample_tests.length; i++) {
                if (sample.sample_tests[i].id == testToAdd.id) {
                    found = true;
                    sample.sample_tests[i].checked = vm.food.sampleArray[row][col];
                    // If a test is unchecked and it's part of a panel, check if we need to remove panel association
                    if (!sample.sample_tests[i].checked && sample.sample_panel_selected) {
                        // Call checkPanelTestsSelection to update panel association
                        vm.food.checkPanelTestsSelection(row);
                    }
                    break;
                }
            }
            // if no, add that test
            if (!found) {
                test = Object.assign({}, testToAdd);
                test.checked = true;
                
                
                // Ensure manually added tests have panel_id and panel_name set to null
                test.panel_id = null;
                test.panel_name = null;
                
                // Handle source_uid vs source_id mapping as mentioned in memories
                if (test.source_id && !test.source_uid) {
                    test.source_uid = test.source_id;
                }
                
                sample.sample_tests.push(test);
            }

            food.checkSampleContainsTrueTests(row);
            vm.food.checkPageTwo();
            
            // Always check panel tests selection to ensure UI is updated
            if (sample.sample_panel_selected) {
                vm.food.checkPanelTestsSelection(row);
            } else {
                // Only call organizeTests directly if we didn't call checkPanelTestsSelection
                // (which already calls organizeTests)
                // Organize tests for display
                vm.food.organizeTests(sample);
            }
        }

        vm.food.incrementPage = function() {
            vm.food.step = vm.food.step + 1;

            if(vm.food.step == 2) {
                vm.food.checkPageTwo();
                setTimeout( function() {
                    // food.setInfoBoxCoordinates();
                }, 100);
            }
            else if (vm.food.step == 3) {
                vm.generateTurnaroundTimes(vm.food);
                
                // Figure out which tests will be submitted for step 4 display
                vm.food.samples.forEach(function(sample) {
                    var rawTests = formatSampleTests(sample, 'food');
                    
                    // Reorganize: individual tests first, then grouped by panel
                    var individualTests = [];
                    var panelTests = {};
                    
                    rawTests.forEach(function(test) {
                        if (test.panel && test.panel.id) {
                            // Group by panel ID
                            if (!panelTests[test.panel.id]) {
                                panelTests[test.panel.id] = {
                                    panelName: vm.getPanelDisplayNameById(test.panel.id, 'food'),
                                    tests: []
                                };
                            }
                            panelTests[test.panel.id].tests.push(test);
                        } else {
                            // Individual test
                            individualTests.push(test);
                        }
                    });
                    
                    // Build final organized array
                    sample.actualFormattedTests = individualTests;
                    
                    // Add each panel group
                    Object.keys(panelTests).forEach(function(panelId) {
                        var panel = panelTests[panelId];
                        // Add a panel header marker
                        sample.actualFormattedTests.push({
                            isPanelHeader: true,
                            panelName: panel.panelName
                        });
                        // Add all tests for this panel
                        panel.tests.forEach(function(test) {
                            sample.actualFormattedTests.push(test);
                        });
                    });
                });
            }
            else if(vm.food.step == 4) {
                vm.food.emailsArray = vm.food.emails.split(',');
                // Organize tests for each sample to populate nonPanelTests and panelTests arrays
                vm.food.samples.forEach(function(sample) {
                    vm.food.organizeTests(sample);
                });
            }
            food.cleanUncheckedTests();
        }

        vm.food.decrementPage = function() {
            vm.food.step = vm.food.step - 1;

            if(vm.food.step == 2) {
                vm.food.checkPageTwo();
                setTimeout( function() {
                    // food.setInfoBoxCoordinates();
                }, 100);
            }
        }

        vm.food.removeSample = function(index) {
            vm.food.samples.splice(index, 1);
            vm.food.sampleArray.splice(index, 1);
            food.resetDeleteCheckboxes();
            vm.food.checkPageOne();
        }

        vm.food.cloneSample = function(index) {
            var clonedSample = angular.copy(vm.food.samples[index]);
            vm.food.samples.splice(index + 1, 0, clonedSample);
            if (vm.food.sampleArray && vm.food.sampleArray.length > index) {
                var clonedSampleArray = angular.copy(vm.food.sampleArray[index]);
                vm.food.sampleArray.splice(index + 1, 0, clonedSampleArray);
            }
            food.resetDeleteCheckboxes();
            vm.food.checkPageOne();
        };

        function shouldShowAssayForLanguage(assay) {
            if ($localStorage.language !== 'Japanese') {
                return true;
            }

            var clientTypeList = assay && assay.portal_client_type_list;
            if (typeof clientTypeList === 'string') {
                try {
                    clientTypeList = JSON.parse(clientTypeList);
                } catch (e) {
                    return false;
                }
            }

            return Array.isArray(clientTypeList) && clientTypeList.indexOf('Japanese') !== -1;
        }

        food.addAssay = function(test) {
            if (!shouldShowAssayForLanguage(test)) {
                return;
            }
            if(test.id != 13) {
                // Prevent duplicates in showTestsArray
                if (vm.food.showTestsArray.indexOf(test.display_name) === -1) {
                    vm.food.showTests[test.display_name] = true;
                    vm.food.showTestsArray.push(test.display_name);
                    
                    // Set the index for the new test
                    test.index = vm.food.tests.length;
                    vm.food.tests.push(test);
                    
                    // CRITICAL: Update assay_map so setPanel can find this assay
                    vm.food.assay_map[test.display_name] = [test.index, test];
                    vm.food.assay_map_by_index[test.index] = test;
                }
            }
        }

        food.createAssayMaps = function() {
            vm.food.tests.forEach( function(test, index) {
                test.index = index;
                vm.food.assay_map[test.display_name] = [index, test]
                vm.food.assay_map_by_index[index] = test;
            });
        }

        food.getAssaysAddedByAnrescoBillingTab = function() {
            vm.customerData.assay_customer.forEach( function(assay_customer) {
                vm.food.all_tests.forEach( function(assay) {
                    if (assay.id == assay_customer.assay_id) {
                        // Check if this assay is already in vm.food.tests (added via portal_client_type_list or portal_client_type)
                        var existingTestIndex = findWithAttr(vm.food.tests, 'id', assay.id);
                        
                        if (existingTestIndex != -1) {
                            // Assay already exists in tests (added via precedence 1 or 2)
                            // Update its assay_customer data to include count for frequent tests
                            vm.food.tests[existingTestIndex].assay_customer = assay_customer;
                        } else if (assay_customer.active) {
                            // Only add new assays if they're active
                            food.addAssay(assay);
                        }
                    }
                });
            });
        }

        food.getAssayData = function() {
            // Use GraphQL for lightweight payload (~150KB vs 1.6MB from REST)
            GraphQLService.query(ASSAYS_LIST_QUERY, { enabled: true }).then(function(result) {
                var data = result.assaysList;
                if (data) {
                    var index = 0;
                    var test = null;
                    var add_assay = true;

                    // Build HashMap for O(1) lookup instead of O(n) search per assay
                    var assayCustomerMap = {};
                    if (vm.customerData && vm.customerData.assay_customer) {
                        vm.customerData.assay_customer.forEach(function(ac) {
                            assayCustomerMap[ac.assay_id] = ac;
                        });
                    }
                    data.forEach( function(assay) {
                        // Language eligibility must be checked before business-type or legacy matching.
                        if (!shouldShowAssayForLanguage(assay)) {
                            return;
                        }
                        if (add_assay) {
                            assay.assay_customer = assayCustomerMap[assay.id] || null;

                            test = {
                                info_modal: parseAssayInfoModalData(assay),
                                portal_identifier: assay.portalIdentifier ? assay.portalIdentifier : null,
                                portal_client_type: assay.portal_client_type ? assay.portal_client_type : null,
                                portal_client_type_list: assay.portal_client_type_list ? assay.portal_client_type_list : null,
                                display_name: assay.title,
                                reporting_title: assay.reporting_title ? assay.reporting_title : assay.title,
                                base_price: assay.basePrice,
                                assay_customer: assay.assay_customer ? assay.assay_customer : null,
                                analysis_description: assay.analysis_description ? assay.analysis_description : null,
                                id: assay.id,
                                index: index
                            }
                            // Initialize a flag to track if the assay has been added
                            let assayAdded = false;

                            if(assay.portal_client_type) {
                               if(assay.portal_client_type == 'General') {
                                    food.addAssay(test);
                                    index++;
                                    assayAdded = true;
                                }
                                else if ((vm.customer_type.includes('food') && assay.portal_client_type.toLowerCase().includes('food'))) {
                                    food.addAssay(test);
                                    index++;
                                    assayAdded = true;
                                }
                                else if ((vm.customer_type.includes('kratom') && assay.portal_client_type.toLowerCase().includes('kratom'))) {
                                    food.addAssay(test);
                                    index++;
                                    assayAdded = true;
                                }
                                else if ((vm.customer_type.includes('other') && assay.portal_client_type.toLowerCase().includes('other'))) {
                                    food.addAssay(test);
                                    index++;
                                    assayAdded = true;
                                }
                                else if(assay.portal_client_type.toLowerCase().includes('non-cannabis')) {
                                    food.addAssay(test);
                                    index++;
                                    assayAdded = true;
                                }
                                else if (vm.customer_type.toLowerCase() === assay.portal_client_type.toLowerCase()) {
                                    food.addAssay(test);
                                    index++;
                                    assayAdded = true;
                                }
                            }

                            // Add new condition to check portal_client_type_list
                            if(assay.portal_client_type_list && !assayAdded) {
                                // Parse the portal_client_type_list if it's a string
                                let clientTypeList = assay.portal_client_type_list;
                                if (typeof clientTypeList === 'string') {
                                    try {
                                        clientTypeList = JSON.parse(clientTypeList);
                                    } catch (e) {
                                        console.error('Error parsing portal_client_type_list for assay', assay.id, e);
                                        clientTypeList = [];
                                    }
                                }
                                
                                if(Array.isArray(clientTypeList)) {
                                    // Check for 'General' type in the list
                                    if(clientTypeList.includes('General')) {
                                        food.addAssay(test);
                                        index++;
                                        assayAdded = true;
                                    } else {
                                        // Convert customer type to lowercase for case-insensitive comparison
                                        var customerTypeLower = vm.customer_type.toLowerCase();
                                        
                                        // Check if any client type in the list matches the customer type
                                        for(let clientType of clientTypeList) {
                                            var lowerClientType = clientType.toLowerCase();
                                            
                                            // Check if customer type contains any of the keywords
                                            if(customerTypeLower.includes('food') && lowerClientType.includes('food') ||
                                               customerTypeLower.includes('kratom') && lowerClientType.includes('kratom') ||
                                               customerTypeLower.includes('other') && lowerClientType.includes('other') ||
                                               lowerClientType.includes('non-cannabis') ||
                                               customerTypeLower === lowerClientType) {
                                                
                                                food.addAssay(test);
                                                index++;
                                                assayAdded = true;
                                                break;
                                            }
                                        }
                                    }
                                    // Special handling for Japanese language and Japanese assays
                                        if ($localStorage.language === 'Japanese') {
                                            // If customer language is Japanese, only show Japanese assays
                                            if (clientTypeList.includes('Japanese')) {
                                                food.addAssay(test);
                                                index++;
                                                assayAdded = true;
                                            }
                                        } else {
                                            // For non-Japanese customers, don't show Japanese-only assays
                                            if (clientTypeList.includes('Japanese') && !clientTypeList.includes('General') && !assayAdded) {
                                                assayAdded = false; // Skip this assay for non-Japanese customers
                                            }
                                        }
                                }
                            }

                            vm.food.all_assay_map_by_id[assay.id] = test;
                            vm.food.all_tests.push(test)
                        }
                        add_assay = true;
                    });

                }
                // getExistingAssays()
                food.getAssaysAddedByAnrescoBillingTab();

                // sorts tests arrray by how many times each test has been ordered
                vm.food.tests.sort( function(test_a ,test_b) {
                    // Get counts, defaulting to 0 if not present
                    var count_a = (test_a.assay_customer && test_a.assay_customer.count) ? test_a.assay_customer.count : 0;
                    var count_b = (test_b.assay_customer && test_b.assay_customer.count) ? test_b.assay_customer.count : 0;
                    
                    // Sort by count descending (highest first)
                    return count_b - count_a;
                });
                
                // Calculate number of frequent assays (up to 5 tests with counts > 0)
                vm.food.number_of_freq_assays = 0;
                for (var i = 0; i < Math.min(5, vm.food.tests.length); i++) {
                    if (vm.food.tests[i]) {
                        // Count tests that have a positive count
                        if (vm.food.tests[i].assay_customer && vm.food.tests[i].assay_customer.count > 0) {
                            vm.food.number_of_freq_assays++;
                        }
                    }
                }

                if (vm.food.number_of_freq_assays != vm.food.tests.length) {
                    var tests_sorted_by_name = vm.food.tests.splice(vm.food.number_of_freq_assays, vm.food.tests.length).sort( function(name_a, name_b) {
                        var comparison = 0;
                        name_a = name_a.display_name ? name_a.display_name : name_a.reporting_title;
                        name_b = name_b.display_name ? name_b.display_name : name_b.reporting_title;
                        if(name_a > name_b) {
                            comparison = 1
                        }
                        else if(name_b > name_a) {
                            comparison = -1
                        }
                        return comparison
                    });
                    vm.food.tests = vm.food.tests.concat(tests_sorted_by_name);
                }
                food.createAssayMaps();

                // Load QBench panels after assay data is ready
                food.getQbenchPanels();
                // Load customer-specific panels after assay data is ready
                food.getCustomerPanels();
            }).catch(function(error) {
                console.error('Failed to load assays via GraphQL:', error);
                AlertService.error('Failed to load available tests. Please refresh the page.');
            });

            // food.setInfoBoxCoordinates();
        }

        food.checkSampleContainsTrueTests = function(index) {
            if (Object.values(vm.food.sampleArray[index]).indexOf(true) == -1) {
                vm.food.samples[index].sample_has_tests = false;
                vm.food.samples[index].sample_panel_selected = false;
                vm.food.samples[index].sample_panel_type = false;
                vm.food.samples[index].sample_panel_by_id = false;
                vm.food.samples[index].sample_current_panel_title = false;

                return;
            }
            vm.food.samples[index].sample_has_tests = true;
            return;
        }

        // removes tests with checked: false, necessary for table on page 4
        food.cleanUncheckedTests = function() {
            if (vm.food.samples.length > 0) {
                vm.food.samples.forEach (function(sample) {
                    if (sample.sample_tests.length > 0) {
                        for(var i = sample.sample_tests.length - 1; i >= 0; i--){
                            if (!sample.sample_tests[i].checked){
                                sample.sample_tests.splice(i, 1);
                            }
                        }
                    }
                    angular.forEach(sample.sample_other_analyses, function(value, key) {
                        if (!value) {
                            delete sample.sample_other_analyses[key];
                        }
                    });
                });
            }
        }

        vm.food.filterAssays = function() {
            vm.food.showTestsArray = Object.keys(vm.food.showTests);
            vm.food.showTestResults = $filter('filter')(vm.food.showTestsArray, vm.food.test_to_search);
            angular.forEach(vm.food.showTests, function(value, key) {
                vm.food.showTests[key] = false;
            });
            vm.food.showTestResults.forEach( function(test) {
                vm.food.showTests[test] = true;
            });
            // food.setInfoBoxCoordinates();
        }

        //filtertering with the ID
        vm.food.customFilter = function(item) {
            var searchText = vm.food.test_to_search;
            if (/^\d+$/.test(searchText)) {
                var idMatches = (item.id.toString().indexOf(searchText) !== -1);
                var assayIdMatches = (item.assay_id && item.assay_id.toString().indexOf(searchText) !== -1);
                return idMatches || assayIdMatches;
            } else {
                return item.display_name.toLowerCase().includes(searchText.toLowerCase());
            }
        };

        vm.food.clear_test_to_search = function() {
            vm.food.test_to_search = '';
            vm.food.filterAssays();
        }

        vm.food.select_test_to_search = function(name) {
            vm.food.test_to_search = name;
            vm.food.filterAssays();
        }

        vm.food.clickCheckAllAddedTest = function(test, index) {
            var selector = ':checkbox.added-assay-col-header-' + index;
            vm.food.samples.forEach( function(sample) {
                sample.sample_other_analyses[test] = $(selector)[0].checked
            });

            vm.food.checkPageTwo();
        }

        food.showAllTests = function() {
            angular.forEach(vm.food.showTests, function(value, key) {
                vm.food.showTests[key] = true;
            });
            return;
        }

        vm.food.addOtherAnalysis = function() {
            vm.food.other_analyses.push(vm.food.test_to_search);
            vm.food.test_to_search = '';
            food.showAllTests()

            return;
        }

        vm.food.clearOtherAnalysis = function() {
            food.showAllTests();
            vm.food.other_analyses = [];
            vm.food.test_to_search = '';

            return;
        }

        food.getPanels = function(panel) {
            var assays_dict = [];
            var accessibleAssays = [];
            var inaccessibleAssays = [];

            if (panel) {
                // Keep panels intact: do not offer a partial panel when an assay is ineligible.
                if (panel.assays.some(function(assay) {
                    return !shouldShowAssayForLanguage(vm.food.all_assay_map_by_id[assay.id] || assay);
                })) {
                    return assays_dict;
                }
                panel.assays.forEach(function(assay) {
                    // Create a more comprehensive assay object
                    var assayObj = {
                        display_name: assay.title,
                        id: assay.id,
                        customer_has_access: assay.customer_has_access || false,
                        in_customer_tests: vm.food.showTestsArray.indexOf(assay.title) !== -1
                    };
                    
                    // Always include all assays in the panel, but track which ones are accessible
                    assays_dict.push(assayObj);
                    
                    if (assayObj.in_customer_tests) {
                        accessibleAssays.push(assayObj);
                    } else {
                        inaccessibleAssays.push(assayObj);
                    }
                });
                
                // Track information about inaccessible assays
                if (inaccessibleAssays.length > 0) {                    
                    // Add a flag to the panel to indicate it has inaccessible assays
                    panel.has_inaccessible_assays = true;
                    panel.inaccessible_assay_count = inaccessibleAssays.length;
                }
            }

            return assays_dict;
        }

        food.setPanelsByIdMap = function() {
            vm.food.qbenchPanels.forEach( function(panel) {
                vm.food.panel_by_id_map[panel.id] = [panel.title, panel.assays];
            });
            vm.food.customPanels.forEach( function(panel) {
                vm.food.panel_by_id_map[panel.id] = [panel.title, panel.assays];
            });
        }

        // Internal helper to standardize pushing a panel with assays
        food._processPanel = function(panel, panelType) {
            var assays_dict = food.getPanels(panel);

            // Add ALL assays from the panel to the accessible tests
            // This grants access to panel assays even if customer doesn't normally have them
            assays_dict.forEach(function(assay) {
                if (!assay.in_customer_tests) {
                    // FIRST check if this assay is already in vm.food.tests
                    var existingTestIndex = findWithAttr(vm.food.tests, 'id', assay.id);
                    
                    if (existingTestIndex !== -1) {
                        // Test already exists with proper info_modal from getAssayData()
                        // Just mark it as from_panel, don't replace it
                        vm.food.tests[existingTestIndex].from_panel = true;
                        return; // Skip to next assay
                    }
                    
                    // Now check if we have full assay data
                    var fullAssay = vm.food.all_assay_map_by_id[assay.id];
                    
                    if (fullAssay) {
                        // Assay exists in our system with full data
                        if (vm.food.showTestsArray.indexOf(fullAssay.display_name) === -1) {
                            food.addAssay(fullAssay);
                            fullAssay.from_panel = true;
                        }
                    } 
                    else {
                        // Assay not in all_assay_map_by_id - fetch it individually
                        // Fetch the specific assay data
                        Assay.get({id: assay.id}, function(assayData) {
                            if (assayData) {
                                // Filter assay_customer data for current customer if it exists
                                if (assayData.assay_customer && Array.isArray(assayData.assay_customer)) {
                                    for (var i = 0; i < assayData.assay_customer.length; i++) {
                                        if (assayData.assay_customer[i].customer_id === vm.customerData.id) {
                                            assayData.assay_customer = assayData.assay_customer[i];
                                            break;
                                        }
                                    }
                                    // If no match found, set to null
                                    if (Array.isArray(assayData.assay_customer)) {
                                        assayData.assay_customer = null;
                                    }
                                }
                                
                                // Create a proper test object with full data
                                var test = {
                                    info_modal: parseAssayInfoModalData(assayData),
                                    portal_identifier: assayData.portalIdentifier ? assayData.portalIdentifier : null,
                                    portal_client_type: assayData.portal_client_type ? assayData.portal_client_type : null,
                                    portal_client_type_list: assayData.portal_client_type_list ? assayData.portal_client_type_list : null,
                                    display_name: assayData.title,
                                    reporting_title: assayData.reporting_title ? assayData.reporting_title : assayData.title,
                                    base_price: assayData.basePrice,
                                    assay_customer: assayData.assay_customer,
                                    analysis_description: assayData.analysis_description ? assayData.analysis_description : null,
                                    id: assayData.id,
                                    index: vm.food.tests.length,
                                    from_panel: true
                                };
                                
                                // Add to cache for future use
                                vm.food.all_assay_map_by_id[assayData.id] = test;
                                vm.food.all_tests.push(test);
                                
                                // Add to accessible tests if not already there
                                if (vm.food.showTestsArray.indexOf(test.display_name) === -1) {
                                    food.addAssay(test);
                                }
                            }
                        }, function(error) {
                            console.error('Failed to fetch assay', assay.id, error);
                        });
                    }
                }
            });

            // Re-create the assay dict now that all panel assays are accessible
            assays_dict = food.getPanels(panel);

            // Only add panel if it has assays after processing
            if (assays_dict.length > 0) {
                vm.food.qbenchPanels.push({
                    title: panel.title,
                    assays: assays_dict,
                    id: panel.id,
                    type: panelType || 'qbench_panel',
                    description: panel.description,
                    duration: panel.duration,
                    minimum_quantity_required: panel.minimum_quantity_required,
                    turnaround_time: panel.turnaround_time,
                    min_sample_size: panel.min_sample_size,
                    price: panel.price
                });
            }
        };

        food.pushPanel = function(panel, panelType) {
            // If the list endpoint did not include assays, fetch the full panel as a fallback
            if (!panel || !panel.assays || panel.assays.length === 0) {
                if (!panel || !panel.id) {
                    console.warn('Panel missing id or assays:', panel);
                    return;
                }
                Panel.get({ id: panel.id }, function(fullPanel) {
                    if (fullPanel && fullPanel.assays && fullPanel.assays.length) {
                        food._processPanel(fullPanel, panelType);
                    } else {
                        console.warn('Panel has no assays after fetch:', panel.id);
                    }
                }, function(e) {
                    console.error('Error fetching panel details', e);
                });
                return;
            }

            // Normal path when assays are present on the list payload
            food._processPanel(panel, panelType);
        }

        food.allPanelAssaysPresent = function(assays_dict) {
            var all_assays_present = true;
            assays_dict.forEach( function(assay) {
                if (vm.food.showTestsArray.indexOf(assay.display_name) == -1) {
                    all_assays_present = false;
                }
           });
           return all_assays_present;
        }

        // Helper function to check if panel should be shown based on portal_client_type_list
        function shouldShowPanel(panel, customerType, customerLanguage) {
            var shouldShow = false;
                        
            // PRIMARY METHOD: Check portal_client_type_list first
            if (panel.portal_client_type_list) {
                var clientTypeList = panel.portal_client_type_list;
                
                // Parse if it's a JSON string, otherwise use as-is if already an array
                if (typeof clientTypeList === 'string') {
                    try {
                        clientTypeList = JSON.parse(clientTypeList);
                    } catch (e) {
                        console.error('Error parsing portal_client_type_list for panel', panel.id, e);
                        clientTypeList = [];
                    }
                } else if (!Array.isArray(clientTypeList)) {
                    // If it's neither a string nor an array, treat as empty
                    clientTypeList = [];
                }
                
                
                // Check if list contains matching criteria
                if (Array.isArray(clientTypeList)) {
                    // SPECIAL CASE: Japanese language customers
                    if (customerLanguage === 'Japanese') {
                        // Japanese customers only see panels with 'Japanese' in the list
                        if (clientTypeList.indexOf('Japanese') !== -1) {
                            shouldShow = true;
                        }
                    } 
                    // NORMAL CASE: Non-Japanese customers
                    else {
                        // Check if list contains 'General' or customer's type
                        if (clientTypeList.indexOf('General') !== -1) {
                            shouldShow = true;
                        } else if (clientTypeList.indexOf(customerType) !== -1) {
                            shouldShow = true;
                        } else {
                            // Support flexible matching (e.g., 'Cannabis/Hemp' matches 'Cannabis')
                            for (var i = 0; i < clientTypeList.length; i++) {
                                if (clientTypeList[i].toLowerCase().indexOf(customerType.toLowerCase()) !== -1) {
                                    shouldShow = true;
                                    break;
                                }
                            }
                        }
                    }
                }
            }
            // FALLBACK: Use panel_type if portal_client_type_list not set (only for non-Japanese)
            else if (customerLanguage !== 'Japanese' && panel.panel_type) {
                if (panel.panel_type == 'General') {
                    shouldShow = true;
                } else if (panel.panel_type.toLowerCase().indexOf(customerType.toLowerCase()) !== -1) {
                    shouldShow = true;
                }
            }
            
            return shouldShow;
        }

        food.getQbenchPanels = function() {
            Panel.query({},
                function(data) {
                    data.forEach( function(panel) {
                        if (panel.portalIdentifier) {
                            if (shouldShowPanel(panel, 'Food', $localStorage.language)) {
                                food.pushPanel(panel, 'qbench_panel');
                            }
                        }
                    });
                    food.getPanelsByCustomer();

                    return;
                },
                function(e) {
                    console.log(e);
                    return;
                }
            );
        }

        food.getPanelsByCustomer = function() {
            CustomPanel.query({},
                function(data) {
                    vm.food.customPanels = [];
                    data.forEach( function(panel) {
                        var panelAssays = food.getPanels(panel);
                        if ($localStorage.language === 'Japanese' && panelAssays.length === 0) {
                            return;
                        }
                        vm.food.customPanels.push({
                            title: panel.title,
                            assays: panelAssays,
                            id: panel.id,
                            type: 'custom_panel'
                        });
                    });
                    food.setPanelsByIdMap();
                    
                    // After loading custom panels, also load customer-specific panels
                    food.getCustomerPanels();
                },
                function(e){
                    console.log(e);
                }
            );
        }
        
        // Flag to track if food customer panels have been loaded
        var foodCustomerPanelsLoaded = false;
        
        food.getCustomerPanels = function() {
            // If customer panels have already been loaded, don't load them again
            if (foodCustomerPanelsLoaded) {
                return;
            }
            
            // Get the customer ID from the customerData object
            var customerId = vm.customerData && vm.customerData.id ? vm.customerData.id : null;
            
            if (!customerId) {
                return;
            }
            
            Customer.getPanels({id: customerId},
                function(data) {                    
                    // Set the flag to indicate customer panels have been loaded
                    foodCustomerPanelsLoaded = true;
                    
                    // Process each panel
                    data.forEach(function(panel) {
                        // For food customers, include all panels EXCEPT those that are explicitly Cannabis-only
                        // This ensures we don't miss any panels with null types or other non-cannabis types
                        var isCannabisOnly = panel.panel_type && 
                                           panel.panel_type === 'Cannabis' && 
                                           !panel.panel_type.toLowerCase().includes('food') && 
                                           panel.panel_type !== 'General';
                        
                        if (!isCannabisOnly) {
                            food.pushPanel(panel, 'customer_panel');
                        }
                    });
                    
                    // Update the panel_by_id_map to include the customer panels
                    food.setPanelsByIdMap();
                },
                function(error) {
                    console.error('Error fetching food customer panels:', error);
                }
            );
        }
        
        vm.food.removePanelFromSample = function(sampleIndex) {

            Object.keys(vm.food.sampleArray[sampleIndex]).forEach( function(key) {
                vm.food.sampleArray[sampleIndex][key] = false;
            });

            vm.food.tests.forEach( function(test, index) {
                $(':checkbox.assay-col-header-' + index)[0].checked = false;
            })

            vm.food.current_sample_name = false;
            vm.food.samples[sampleIndex].sample_current_panel_title = null;
            vm.food.samples[sampleIndex].sample_panel_selected = null;
            vm.food.samples[sampleIndex].sample_panel_by_id = null;
            vm.food.samples[sampleIndex].sample_panel_type = null;
            vm.food.samples[sampleIndex].sample_has_tests = null;
            vm.food.samples[sampleIndex].sample_tests = [];

            vm.food.checkPageTwo();
        }

        
        vm.food.organizeTests = function(sample) {
            if (!sample) return;
            
            // Create arrays to hold panel and non-panel tests
            sample.nonPanelTests = [];
            sample.panelTests = [];
            
            
            // Get the current panel ID if one is selected
            var currentPanelId = sample.sample_panel_selected;
                        
            // Sort tests into panel and non-panel arrays
            for (var i = 0; i < sample.sample_tests.length; i++) {
                var test = sample.sample_tests[i];
                if (test.checked) {                    
                    // Check if panel_id is undefined, null, or empty string
                    var hasPanelId = test.panel_id !== undefined && test.panel_id !== null && test.panel_id !== '';
                    
                    // A test is part of the panel if:
                    // 1. It has a panel_id property AND
                    // 2. That panel_id matches the currently selected panel AND
                    // 3. A panel is actually selected
                    if (hasPanelId && currentPanelId && test.panel_id == currentPanelId) {
                        sample.panelTests.push(test);
                    } else {
                        // If the test has a panel_id but it doesn't match the current panel,
                        // or if it has no panel_id, it should be treated as a non-panel test
                        sample.nonPanelTests.push(test);
                    }
                }
            }
        };
        
        vm.food.setPanel = function(sample, panelId, panel_type) {            
            // Find the actual sample index by object reference, not by name
            var sampleIndex = vm.food.samples.indexOf(sample);
            
            if (sampleIndex === -1) {
                console.error('Sample not found in samples array');
                return;
            }
            
            vm.food.current_sample_name = sample.sample_name;

            var temp = null;
            if (vm.food.sampleArray[sampleIndex]) {
                delete vm.food.sampleArray[sampleIndex];
            }
            vm.food.sampleArray[sampleIndex] = {};

            // Store existing tests that are not part of the panel
            var existingTests = [];
            if (vm.food.samples[sampleIndex].sample_tests) {
                // Save any manually added tests that are checked
                existingTests = vm.food.samples[sampleIndex].sample_tests.filter(function(test) {
                    return test.checked && !test.panel_id;
                });
                                
                // Clear the tests array to rebuild it
                vm.food.samples[sampleIndex].sample_tests = [];
                
                // Add back the preserved tests first
                existingTests.forEach(function(test) {
                    // Ensure these tests are marked as non-panel tests
                    if (test.panel_id) {
                        delete test.panel_id;
                        delete test.panel_name;
                    }
                    vm.food.samples[sampleIndex].sample_tests.push(test);
                });
            }
            
            // Track assays that customer doesn't have access to
            var inaccessibleAssays = [];
            var accessibleAssays = [];
                        
            vm.food.panel_by_id_map[panelId][1].forEach(function(assay) {
                // IMPORTANT: For panels, we grant access to ALL assays in the panel
                // regardless of customer's normal access rights
                
                // First ensure the assay is in showTests/showTestsArray if it's from a panel
                if (vm.food.showTestsArray.indexOf(assay.display_name) === -1) {
                    // This is a panel assay the customer doesn't normally have access to
                    // Add it to the accessible lists
                    vm.food.showTests[assay.display_name] = true;
                    vm.food.showTestsArray.push(assay.display_name);
                    // Granting access to panel assay
                }
                
                // Check if the assay exists in the assay map
                if (vm.food.assay_map[assay.display_name]) {
                    // Now the customer has access (we just granted it above if needed)
                    // Add accessible assays to the sample
                    temp = Object.assign({}, vm.food.assay_map[assay.display_name][1]);
                    temp.checked = true;
                    
                    // Set panel association on the test
                    temp.panel_id = panelId;
                    temp.panel_name = vm.food.panel_by_id_map[panelId][0];
                    
                    // Handle source_uid vs source_id mapping as mentioned in memories
                    if (temp.source_id && !temp.source_uid) {
                        temp.source_uid = temp.source_id;
                    }
                    
                    vm.food.samples[sampleIndex].sample_tests.push(temp);
                    vm.food.sampleArray[sampleIndex][vm.food.assay_map[assay.display_name][1].index] = true;
                    accessibleAssays.push(assay.display_name);
                } else {
                    // Assay not in assay_map - this shouldn't happen with our previous fixes
                    console.warn('Panel assay not in assay_map:', assay.display_name);
                    inaccessibleAssays.push(assay.display_name);
                }
            });
            
            vm.food.samples[sampleIndex].sample_panel_selected = panelId;
            vm.food.samples[sampleIndex].sample_panel_type = panel_type;
            vm.food.samples[sampleIndex].sample_current_panel_title = vm.food.panel_by_id_map[panelId][0];
            vm.food.current_sample_name = null;
            vm.food.checkPageTwo();
            
            
            // This might be overriding our panel settings
            vm.food.checkPanelTestsSelection(sampleIndex);
                        
            // Organize tests for display
            vm.food.organizeTests(vm.food.samples[sampleIndex]);
            return;
        }

        vm.food.applyPanelToAll = function(panelId, panelType) {
            vm.food.samples.forEach(function(sample) {
                vm.food.setPanel(sample, panelId, panelType);
                sample.sample_panel_by_id = panelId;
            });
        };

        vm.food.clearPanelFromAll = function() {
            vm.food.samples.forEach(function(sample, index) {
                vm.food.removePanelFromSample(index);
            });
        };
        
        // Check if all tests in a panel are selected for a sample

        vm.food.checkPanelTestsSelection = function(sampleIndex) {
            var sample = vm.food.samples[sampleIndex];
            if (!sample.sample_panel_selected) {
                return;
            }
            var panelId = sample.sample_panel_selected;
            
            var panelAssays = vm.food.panel_by_id_map[panelId][1];
            var allAssaysSelected = true;
            var accessibleAssaysInPanel = [];
            var inaccessibleAssaysInPanel = [];
            var selectedAssays = [];
            
            // Get all accessible assays in the panel
            panelAssays.forEach(function(assay) {
                if (vm.food.assay_map[assay.display_name]) {
                    var assayId = vm.food.assay_map[assay.display_name][1].id;
                    var customerHasAccess = vm.food.showTestsArray.indexOf(assay.display_name) !== -1;
                    if (customerHasAccess) {
                        accessibleAssaysInPanel.push(assayId);
                    } else {
                        inaccessibleAssaysInPanel.push(assay.display_name);
                    }
                }
            });
            
            
            // Get all selected assays
            for (var i = 0; i < sample.sample_tests.length; i++) {
                if (sample.sample_tests[i].checked) {
                    selectedAssays.push(sample.sample_tests[i].id);
                }
            }
            
            
            // Check if all accessible panel assays are selected
            for (var i = 0; i < accessibleAssaysInPanel.length; i++) {
                if (selectedAssays.indexOf(accessibleAssaysInPanel[i]) === -1) {
                    allAssaysSelected = false;
                    break;
                }
            }
            
            
            if (!allAssaysSelected) {
                sample.sample_panel_selected = null;
                sample.sample_panel_type = null;
                sample.sample_current_panel_title = null;
                
                // Only remove panel association from tests that were part of this panel
                for (var i = 0; i < sample.sample_tests.length; i++) {
                    if (sample.sample_tests[i].panel_id === panelId) {
                        delete sample.sample_tests[i].panel_id;
                        delete sample.sample_tests[i].panel_name;
                    }
                }
                
                if (!$rootScope.$$phase) {
                    $rootScope.$apply();
                }
            } else {
                sample.sample_panel_selected = panelId;
                sample.sample_panel_type = sample.sample_panel_type || 'panel';
                sample.sample_current_panel_title = vm.food.panel_by_id_map[panelId][0];
                
                // Only set panel association on tests that are part of this panel
                // DO NOT modify tests that aren't part of this panel
                var panelAssayIds = accessibleAssaysInPanel;
                for (var i = 0; i < sample.sample_tests.length; i++) {
                    if (sample.sample_tests[i].checked && panelAssayIds.indexOf(sample.sample_tests[i].id) !== -1) {
                        sample.sample_tests[i].panel_id = panelId;
                        sample.sample_tests[i].panel_name = vm.food.panel_by_id_map[panelId][0];
                    } else if (sample.sample_tests[i].checked) {
                    }
                }
            }
            
            // Organize tests for display
            vm.food.organizeTests(sample);
            
            return allAssaysSelected;
        }

        vm.food.savePanel = function(sampleIndex, step) {
            if (step == 1) {
                vm.food.panels.current_panel_index = sampleIndex;
                $('#addPanelName').modal('show'); 
                return;
            }

            else if (step == 2) {
                var assays = [];
                Object.keys(vm.food.sampleArray[vm.food.panels.current_panel_index]).forEach( function(key) {
                    if (vm.food.sampleArray[vm.food.panels.current_panel_index][key]) {
                        assays.push({id: vm.food.assay_map_by_index[key].id})
                    }
                });

                if (vm.food.panels.new_panel_name && assays) {
                    CustomPanel.create({
                            title: vm.food.panels.new_panel_name,
                            assays: assays
                        },
                        function() {
                            vm.food.samples[vm.food.panels.current_panel_index].sample_has_tests = true;

                            food.getPanelsByCustomerAndSetPanel(vm.food.panels.current_panel_index);
                        },
                        function(e) {
                            console.log(e);
                        }
                    );
                }
                return;
            }
        }

        food.getPanelsByCustomerAndSetPanel = function(sampleIndex) {
            CustomPanel.query({},
                function(data) {
                    vm.food.customPanels = [];
                    var panel_id = null
                    data.forEach( function(panel) {
                        vm.food.customPanels.push({
                            title: panel.title,
                            assays:food.getPanels(panel),
                            id: panel.id,
                            type: 'custom_panel'
                        });
                    });
                    food.setPanelsByIdMap();
                    panel_id = vm.food.customPanels[vm.food.customPanels.length-1].id;
                    vm.food.setPanel(vm.food.samples[sampleIndex], panel_id, 'custom_panel');
                    vm.food.samples[sampleIndex].sample_panel_by_id = panel_id;
                    vm.food.samples[sampleIndex].sample_has_tests = false;
                    vm.food.panels.current_panel_index = null;
                    vm.food.panels.new_panel_name = null;

                },
                function(e){
                    console.log(e);
                }
            );
        }


        vm.food.updatePanel = function(sampleIndex, panelId) {
            var assays = [];
            Object.keys(vm.food.sampleArray[sampleIndex]).forEach( function(key) {
                if(vm.food.sampleArray[sampleIndex][key]) {
                    assays.push({id: vm.food.assay_map_by_index[key].id})
                }
            });
            CustomPanel.update({
                id: panelId,
                assays: assays
            },
                function() {
                    vm.food.samples[sampleIndex].sample_has_tests = false;
                    food.getPanelsByCustomer();
                },
                function(e) {
                    console.log(e);
                }
            );
            return;
        }

        vm.food.deletePanel = function(panelId) {
            vm.food.customPanels = [];

            CustomPanel.delete({id: panelId},
                function() {
                    food.getPanelsByCustomer();
                },
                function(e) {
                    console.log(e);
                }
            );

            return;
        }

        vm.showQbenchPanels = $localStorage.settings || {
            settings: {
                sample_submit:{
                    show_anresco_panels: true
                }
            }
        }

        vm.toggleQbenchPanelVisibility = function(){
            vm.showQbenchPanels.settings.sample_submit.show_anresco_panels = !vm.showQbenchPanels.settings.sample_submit.show_anresco_panels;
            $localStorage.settings = vm.showQbenchPanels;
        };

        food.isSample = function(object) {
            return object.sample_name == vm.food.current_sample_name;
        }

        vm.food.clearPanel = function() {
            vm.food.panels.current_panel_index = null;
            vm.food.current_sample_name = null;
            vm.food.panels.current_panel_index = null;
            vm.food.panels.new_panel_name = null;      
        }

        vm.food.uploadExcel = function() {
            $('#food_upload_excel').click();
        }

        vm.food.collapseAll = function() {
            vm.food.mainCollapse = !vm.food.mainCollapse;
            if (vm.food.samples.length != 0) {
                vm.food.samples.forEach( function(sample) {
                    sample.sample_expanded = vm.food.mainCollapse;
                });
            }
        }

        vm.food.downloadExcel = function() {
            food.generateBlob();
        }

        food.getWorkbook = function() {
            return new Promise(function (resolve, reject) {
                var req = new XMLHttpRequest();
                var url = 'content/files/public/food_analysis.xlsx';

                req.open("GET", url, true);
                req.responseType = "arraybuffer";
                req.onreadystatechange = function () {
                    if (req.readyState === 4){
                        if (req.status === 200) {
                            resolve(XlsxPopulate.fromDataAsync(req.response));
                        } else {
                            reject("Received a " + req.status + " HTTP code.");
                        }
                    }
                };
                req.send();
            });
        }

        food.generate = function(type) {
            return food.getWorkbook()
                .then(function (workbook) {
                    var r = workbook.sheet(0).range("A1:AY1");
                    
                    var lot_field_name = [3868, 8735, 8736, 8748].includes($rootScope.customer.customer_id) ? 'Lot Number*' : 'Lot/Batch #';
                    var header = ['Sample Description*', 'Sample Condition', lot_field_name,  'Expiration Date (MM/DD/YYYY)','Production Date (MM/DD/YYYY)','Date and Time Collected (MM/DD/YYYY HH:MM AM/PM)', 'UPC Number', '# of Units Submitted', 'Sample Matrix', 'Product Specifications', 'Comments', 'Supplier Name', 'Supplier Lot Code'];

                    var dropdownOptions = {}
                    var options = ['Yes', 'No']

                    vm.food.tests.forEach( function(test) {
                        test.display_name ? header.push(test.display_name) : header.push(test.reporting_title);
                        var headerName = test.display_name ? test.display_name : test.reporting_title
                        dropdownOptions[headerName] = options;
                    });
                    
                    header.forEach(function (headerName, index) {
                        var colLetter = getColumnLetter(index);
                        if (dropdownOptions[headerName]) {
                            applyDropdown(workbook.sheet(0), colLetter, dropdownOptions[headerName]);
                        }
                    });

                    r.value([header]);
                    workbook.sheet(0).row(1).style("bold", true);

                    return workbook.outputAsync({ type: type });
                });
        }

        food.generateBlob = function() {
            return food.generate()
                .then(function (blob) {
                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(blob, "Analysis Sample Submission.xlsx");
                    } else {
                        var url = window.URL.createObjectURL(blob);
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.href = url;
                        a.download = "Analysis Sample Submission.xlsx";
                        a.click();
                        window.URL.revokeObjectURL(url);
                        document.body.removeChild(a);
                    }
                })
                .catch(function (err) {
                    alert(err.message || err);
                    throw err;
                });
        }

        // Normalizes header text for consistent matching.
        // Converts to lowercase, trims whitespace, removes text in parentheses, and removes trailing asterisk.
        food.normalizeHeader = function(headerText) {
            var normalized;
            if (typeof headerText !== 'string') {
                return ''; // Return empty string if input is not a string
            }
            normalized = headerText.toLowerCase();
            normalized = normalized.trim();
            normalized = normalized.replace(/\(.*?\)/g, ''); // Remove text within parentheses
            normalized = normalized.replace(/\*$/, ''); // Remove trailing asterisk
            normalized = normalized.trim(); // Trim again after removals
            return normalized;
        };

        // Parses a date value from an Excel cell, handling various formats. (Corrected Version)
        food.parseDateFromCell = function(sheet, rowIndex, colIndex, rawValue) {
            var cell, date, cellFormat, isDateFormat, baseDate, trimmed, dateRegex1, dateRegex2, parsedDate;
            try {
                // Get the cell object using 1-based indices
                cell = sheet.cell(rowIndex, colIndex);

                // Check if the cell exists and has a value before accessing properties
                if (cell && cell.value !== null && cell.value !== undefined) {

                    // Check if it's explicitly a date type in Excel (using property access)
                    if (cell.type === 'd') {
                        // Create Date object from the cell's raw value (using property access)
                        date = new Date(cell.value);
                        // Check if the parsed date is valid
                        if (Object.prototype.toString.call(date) === "[object Date]" && !isNaN(date.getTime())) {
                            return date;
                        }
                    }

                    // Check if it's a number that might be a date based on format
                    // Use rawValue here as cell.value might already be a Date object if type was 'd'
                    if (typeof rawValue === 'number') {
                        // Get cell format (style IS a function)
                        cellFormat = (cell.style && typeof cell.style === 'function' && cell.style("numberFormat")) || '';
                        isDateFormat = cellFormat.toLowerCase().indexOf('yy') !== -1 ||
                                    cellFormat.toLowerCase().indexOf('mm') !== -1 ||
                                    cellFormat.toLowerCase().indexOf('dd') !== -1;

                        if (isDateFormat) {
                            // Handle both 1900 and 1904 date systems
                            baseDate = (sheet.workbook &&
                                        sheet.workbook.Workbook &&
                                        sheet.workbook.Workbook.WBProps &&
                                        sheet.workbook.Workbook.WBProps.date1904)
                                        ? 24107 : 25567;
                            // Adjust calculation slightly for potential Excel base date differences
                            // Use Math.round to avoid floating point issues with date serial numbers
                            date = new Date(Math.round((rawValue - baseDate - 1) * 86400 * 1000));

                            // Check if the parsed date is valid
                            if (Object.prototype.toString.call(date) === "[object Date]" && !isNaN(date.getTime())) {
                                // Basic sanity check for reasonable date range (e.g., year > 1900)
                                if (date.getFullYear() > 1900) {
                                    return date;
                                }
                            }
                        }
                    }
                } // End check for cell existence and value

                // Handle string dates with specific formats (MM/DD/YYYY, MM-DD-YYYY, YYYY/MM/DD, YYYY-MM-DD)
                // Use rawValue here as it might be a string even if the cell exists
                if (typeof rawValue === 'string') {
                    trimmed = rawValue.trim();
                    // Matches formats like MM/DD/YYYY, MM-DD-YYYY
                    dateRegex1 = /^\d{1,2}[\/\-]\d{1,2}[\/\-]\d{2,4}$/;
                    // Matches formats like YYYY/MM/DD, YYYY-MM-DD
                    dateRegex2 = /^\d{4}[\/\-]\d{1,2}[\/\-]\d{1,2}$/;

                    if (dateRegex1.test(trimmed) || dateRegex2.test(trimmed)) {
                        parsedDate = new Date(trimmed);
                        // Check if the parsed date is valid
                        if (Object.prototype.toString.call(parsedDate) === "[object Date]" && !isNaN(parsedDate.getTime())) {
                            return parsedDate;
                        }
                    }
                }

            } catch (e) {
                console.error("Error parsing date for cell (" + rowIndex + "," + colIndex + ") with value:", rawValue, e);
                // Fall through to return rawValue if any error occurs
            }

            // Return the original value if no valid date was parsed or if rawValue was null/undefined initially
            return rawValue;
        }; // End of food.parseDateFromCell

        // Parses a datetime value from an Excel cell, preserving time component
            food.parseDateTimeFromCell = function(sheet, rowIndex, colIndex, rawValue) {
                var cell, datetime, cellFormat, isDateFormat, baseDate, trimmed, datetimeRegex, parsedDate;
                try {
                    // Get the cell object using 1-based indices
                    cell = sheet.cell(rowIndex, colIndex);

                    // Check if the cell exists and has a value
                    if (cell && cell.value !== null && cell.value !== undefined) {

                        // Check if it's explicitly a date type in Excel
                        if (cell.type === 'd') {
                            // Create Date object from the cell's raw value (preserves time)
                            datetime = new Date(cell.value);
                            if (Object.prototype.toString.call(datetime) === "[object Date]" && !isNaN(datetime.getTime())) {
                                return datetime;
                            }
                        }

                        // Check if it's a number that might be a datetime based on format
                        if (typeof rawValue === 'number') {
                            cellFormat = (cell.style && typeof cell.style === 'function' && cell.style("numberFormat")) || '';
                            isDateFormat = cellFormat.toLowerCase().indexOf('yy') !== -1 ||
                                        cellFormat.toLowerCase().indexOf('mm') !== -1 ||
                                        cellFormat.toLowerCase().indexOf('dd') !== -1 ||
                                        cellFormat.toLowerCase().indexOf('hh') !== -1 ||
                                        cellFormat.toLowerCase().indexOf('h:') !== -1;

                            if (isDateFormat) {
                                baseDate = (sheet.workbook &&
                                            sheet.workbook.Workbook &&
                                            sheet.workbook.Workbook.WBProps &&
                                            sheet.workbook.Workbook.WBProps.date1904)
                                            ? 24107 : 25569;

                                // Extract date/time components from Excel serial to create local Date
                                var totalDays = rawValue - baseDate;
                                var wholeDays = Math.floor(totalDays);
                                var fractionalDay = totalDays - wholeDays;

                                // Get time components from fractional day
                                var totalSeconds = Math.round(fractionalDay * 86400);
                                var excelHours = Math.floor(totalSeconds / 3600);
                                var excelMinutes = Math.floor((totalSeconds % 3600) / 60);
                                var excelSeconds = totalSeconds % 60;

                                // Get date components via UTC temp date
                                var tempDate = new Date(wholeDays * 86400 * 1000);
                                datetime = new Date(
                                    tempDate.getUTCFullYear(),
                                    tempDate.getUTCMonth(),
                                    tempDate.getUTCDate(),
                                    excelHours,
                                    excelMinutes,
                                    excelSeconds
                                );

                                if (Object.prototype.toString.call(datetime) === "[object Date]" && !isNaN(datetime.getTime())) {
                                    if (datetime.getFullYear() > 1900) {
                                        return datetime;
                                    }
                                }
                            }
                        }
                    }

                    // Handle string datetimes with format MM/DD/YYYY HH:MM:SS or MM/DD/YYYY HH:MM
                    if (typeof rawValue === 'string') {
                        trimmed = rawValue.trim();
                        // Matches formats like "12/12/2025 18:30:00", "12/12/2025 18:30", or "12/12/2025 12:30 PM"
                        datetimeRegex = /^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{2,4})\s+(\d{1,2}):(\d{1,2})(?::(\d{1,2}))?\s*(AM|PM|am|pm)?$/i;

                        var match = datetimeRegex.exec(trimmed);
                        if (match) {
                            var month = parseInt(match[1]) - 1; // Month is 0-indexed
                            var day = parseInt(match[2]);
                            var year = parseInt(match[3]);
                            var hour = parseInt(match[4]);
                            var minute = parseInt(match[5]);
                            var second = match[6] ? parseInt(match[6]) : 0;
                            var ampm = match[7];

                            // Handle AM/PM conversion
                            if (ampm) {
                                if (ampm.toUpperCase() === 'PM' && hour < 12) hour += 12;
                                if (ampm.toUpperCase() === 'AM' && hour === 12) hour = 0;
                            }

                            parsedDate = new Date(year, month, day, hour, minute, second);
                            if (Object.prototype.toString.call(parsedDate) === "[object Date]" && !isNaN(parsedDate.getTime())) {
                                return parsedDate;
                            }
                        }
                    }

                    return null;
                } catch (error) {
                    console.error("Error parsing datetime from cell:", error);
                    return null;
                }
            };

        vm.food.handleExcel = function() {
            return handleExcelImport(vm.food, '#food_upload_excel', function(workbook) {
                    var sheet = workbook.sheet(0);
                    var values = sheet.usedRange().value();
                    return food.extractExcelValues(values, sheet);
            });
        }
        
        food.createExcelAssayMap = function(file) {
            for( var i = vm.food.excel_header_offset; i < file[0].length; i++) {
                if (file[0][i]) {
                    vm.food.excel_assay_index_map[i] = vm.food.assay_map[file[0][i]];
                }
                else {
                    break;
                }
            }
        }

        food.createNewSample = function() {
            return ({
                sample_checked: null,
                sample_delete: false,
                sample_name: null,
                sample_lot_batch_number: null,
                sample_time_of_collection: null,
                sample_time_of_collection_frontend: null,
                sample_time_of_collection_backend: null,
                sample_expiration_date: null,
                sample_expiration_date_open: false,
                sample_supplier_name: null,           // ADD THIS 
                sample_supplier_lot_code: null,       // ADD THIS 
                sample_tests: [],
                sample_other_analyses: {},
                sample_has_tests: null,
                sample_panel_by_id: null,
                sample_panel_type: null,
                sample_current_panel_title: null,
                focus: {
                    name: false,
                    lot_batch_number: false,
                    autofill: false
                },
                options: {
                    name: [],
                    lot_batch_number: [],
                    autofill: []
                }
            });
        }
        
// Extracts data from the Excel file based on headers.
food.extractExcelValues = function(file, sheet) {
    var headerRow, standardHeaderMapping, requiredSampleProperties,
        headerIndexMap, assayColumnMap, missingHeaders, i, dataRow,
        sampleNameIndex, sample, sampleProperty, testToAdd,
        originalAssayIndex, normalizedHeader, prop, originalHeaderKey;

    // --- Configuration ---
    standardHeaderMapping = {
        'sample description': 'sample_name',
        'sample condition': 'sample_condition',
        'lot/batch #': 'sample_lot_batch_number',
        'lot number': 'sample_lot_batch_number',  // Support both variations for all customers
        'expiration date': 'sample_expiration_date', // Requires special date parsing
        'production date': 'sample_production_date', // Requires special date parsing
      //  'date collected': 'sample_time_of_collection', // Requires special date parsing
        'date and time collected': 'sample_time_of_collection',
        'upc number': 'sample_upc_number',
        '# of units submitted': 'sample_number_of_units_submitted',
        'sample matrix': 'food_sample_matrix',
        'product specifications': 'sample_expected_potency',
        'comments': 'sample_comments',
        'supplier name': 'sample_supplier_name',
        'supplier lot code': 'sample_supplier_lot_code'
    };
    

    // Define which sample properties correspond to required headers
    requiredSampleProperties = ['sample_name']; // Add others if needed, e.g., 'sample_lot_batch_number'

    // --- Header Processing ---
    if (!file || file.length === 0) {
        AlertService.error("Upload failed. The Excel file is empty.");
        return false;
    }
    headerRow = file[0];
    headerIndexMap = {}; // { sample_property: colIndex }
    assayColumnMap = {}; // { colIndex: assayObject }
    var columnMap = {};   // { colIndex: {prop: 'sample_name'} | {assay: obj} }
    // Each column index is mapped individually so headers can appear in any order

    // Map headers to indices and assays
    angular.forEach(headerRow, function(header, colIndex) {
        var normalizedHeader = food.normalizeHeader(header);
        var sampleProperty = standardHeaderMapping[normalizedHeader];
        var matchedAssay = null;

        if (sampleProperty) {
            // Store mapping from internal property name to column index
            headerIndexMap[sampleProperty] = colIndex;
            columnMap[colIndex] = { prop: sampleProperty };
        } else if (normalizedHeader) { // Only check assays if header is not empty after normalization
            // Check assays - prioritize reporting_title, then display_name
            angular.forEach(vm.food.tests, function(test) {
                if (matchedAssay) return; // Already found a match
                if (test.reporting_title && food.normalizeHeader(test.reporting_title) === normalizedHeader) {
                    matchedAssay = test;
                }
            });
            if (!matchedAssay) {
                angular.forEach(vm.food.tests, function(test) {
                    if (matchedAssay) return; // Already found a match
                    if (food.normalizeHeader(test.display_name) === normalizedHeader) {
                        matchedAssay = test;
                    }
                });
            }

            if (matchedAssay) {
                assayColumnMap[colIndex] = matchedAssay;
                columnMap[colIndex] = { assay: matchedAssay };
            }
            // else: Header is unrecognized - ignore silently
        }
    });


    // --- Validate Required Headers ---
    missingHeaders = [];
    angular.forEach(requiredSampleProperties, function(prop) {
        if (!headerIndexMap.hasOwnProperty(prop)) {
            // Find the original-like header key for the error message
            originalHeaderKey = "Unknown Required Header"; // Default
            for (var key in standardHeaderMapping) {
                if (standardHeaderMapping[key] === prop) {
                    // Attempt to reconstruct a user-friendly header name (best effort)
                    originalHeaderKey = key.replace(/\b\w/g, function(l){ return l.toUpperCase() }); // Capitalize words
                    if (prop === 'sample_name') originalHeaderKey += '*'; // Add back asterisk if needed
                    // Add more specific reconstructions if necessary
                    break;
                }
            }
            missingHeaders.push(originalHeaderKey);
        }
    });

    if (missingHeaders.length > 0) {
        AlertService.error("Upload failed. Missing required column(s): " + missingHeaders.join(', '));
        return false; // Stop processing
    }

    // --- Data Row Processing ---
    vm.food.samples = []; // Clear existing samples before adding new ones from Excel
    vm.food.sampleArray = []; // Clear existing sample array

    for (i = 1; i < file.length; i++) {
        dataRow = file[i];
        sampleNameIndex = headerIndexMap['sample_name']; // Get index for sample name

        // Stop processing if the required sample name cell is empty for this row
        if (!dataRow || dataRow.length === 0 || allEmpty(dataRow[sampleNameIndex])) {
            break;
        }

        sample = food.createNewSample(); // Create a new sample structure
        vm.food.sampleArray[i - 1] = {}; // Initialize assay tracking for this sample

        // Process each column by its mapped specification
        angular.forEach(columnMap, function(spec, colIdx) {
            colIdx = parseInt(colIdx);
            var cellVal = (dataRow.length > colIdx) ? dataRow[colIdx] : null;

            if (cellVal === undefined || cellVal === '') {
                cellVal = null;
            }

            if (spec.prop) {
                if (spec.prop === 'sample_expiration_date' && cellVal !== null) {
                    sample.sample_expiration_date = food.parseDateFromCell(sheet, i + 1, colIdx + 1, cellVal);
                } else if (spec.prop === 'sample_production_date' && cellVal !== null) {
                    sample.sample_production_date = food.parseDateFromCell(sheet, i + 1, colIdx + 1, cellVal);
                } else if (spec.prop === 'sample_time_of_collection' && cellVal !== null) {
                    sample.sample_time_of_collection = food.parseDateTimeFromCell(sheet, i + 1, colIdx + 1, cellVal);
                } else if (spec.prop === 'sample_lot_batch_number' && typeof cellVal === 'number') {
                    // Handle case where lot batch number is read as a date serial number
                    // Check if this is likely an Excel date serial number
                    // Excel dates for 2018-2035: 43101 (1/1/2018) to 49673 (12/31/2035)
                    if (cellVal >= 43101 && cellVal <= 49673) {
                        // Convert Excel date serial number back to date string
                        var baseDate = 25567; // Excel base date for 1900 system
                        var date = new Date(Math.round((cellVal - baseDate - 1) * 86400 * 1000));
                        
                        // Format as MM/DD/YYYY
                        var month = (date.getMonth() + 1).toString().padStart(2, '0');
                        var day = date.getDate().toString().padStart(2, '0');
                        var year = date.getFullYear();
                        sample[spec.prop] = month + '/' + day + '/' + year;
                    } else {
                        // This is just a regular number, not a date
                        sample[spec.prop] = cellVal.toString();
                    }
                } else {
                    sample[spec.prop] = (spec.prop === 'sample_name' || spec.prop === 'sample_lot_batch_number')
                        ? stripInvalidQBChars(cellVal)
                        : cellVal;
                }
            } else if (spec.assay) {
                if (cellVal && typeof cellVal === 'string' && cellVal.trim().toLowerCase() === 'yes') {
                    testToAdd = angular.copy(spec.assay);
                    testToAdd.checked = true;
                    sample.sample_tests.push(testToAdd);
                    sample.sample_has_tests = true;

                    if (vm.food.assay_map && vm.food.assay_map[spec.assay.display_name]) {
                        originalAssayIndex = vm.food.assay_map[spec.assay.display_name][0];
                        vm.food.sampleArray[i - 1][originalAssayIndex] = true;
                    } else {
                        console.warn("Could not find assay '" + spec.assay.display_name + "' in vm.food.assay_map for UI update.");
                    }
                }
            }
        });

        vm.food.samples.push(sample); // Add the processed sample to the main list
    }

    // --- Finalization ---
    vm.food.checkPageOne(); // Validate page one based on newly added samples
    food.resetDeleteCheckboxes(); // Reset UI checkboxes
    if (!vm.food.samples.length) {
        AlertService.error('Upload failed. The Excel file does not contain any sample rows.');
        return false;
    }
    // vm.food.processingExcelUpload = false; // Flag is reset in vm.food.handleExcel's .then/.catch
    return true;
}; // End of food.extractExcelValues function


// **************************** END FOOD FUNCTIONS ****************************

        vm.comp.step = 1;
        vm.comp.pageOneValid = false;
        vm.comp.pageTwoValid = false;
        vm.comp.pageThreeValid = false;
        vm.comp.customer_type = $rootScope.customer ? ($rootScope.customer.customer_type ? $rootScope.customer.customer_type : 'Cannabis') : 'Cannabis';
        vm.comp.company_discount = $rootScope.customer ? ($rootScope.customer.company_discount ? $rootScope.customer.company_discount : null) :  null;
        vm.comp.file = null;
        vm.comp.specialInstructions = null;
        vm.comp.customerComments = null;
        vm.comp.turnaroundTime = '3 day (standard)';
        vm.comp.estimated_report_date = null;
        vm.comp.categories = null;
        vm.comp.sampleArray = [];
        vm.comp.all_types = null;
        vm.comp.manufacturing_address = null;
        vm.comp.deliveryPreference = 'ANRESCO_PICK_UP';
        vm.comp.orderPO = null;
        vm.comp.pickup_arrival_date = null;
        vm.comp.emails = '';
        vm.comp.samples = [];
        vm.comp.tests = [];
        vm.comp.testsRequested = [];
        vm.comp.testsRequestedCount = [];
        vm.comp.mainCollapse = false;
        vm.comp.total = 0;
        vm.comp.subtotal = null;
        vm.comp.total_discount = 0;
        vm.comp.panels = {};
        vm.order_type = vm.comp.customer_type == 'Cannabis' ? 'Compliance' : 'RnD';
        vm.comp.existing_user_added_assays = [];
        vm.comp.phases = [];
        vm.comp.phase_map_by_name = {};
        vm.comp.submitting = false;
        vm.comp.processingExcelUpload = false;
        vm.comp.uploadedFiles = [];
        vm.comp.importedExcelFiles = [];

        vm.comp.handleFileSelect = function(files) {
            if (files && files.length > 0) {
                var allowedTypes = ['application/pdf', 'image/png', 'image/jpeg'];
                
                var currentSize = getTotalFileSize(vm.comp.uploadedFiles);
                currentSize += getTotalFileSize(vm.comp.importedExcelFiles);
                
                var newFilesSize = 0;
                for (var i = 0; i < files.length; i++) {
                    newFilesSize += files[i].size;
                }
                
                if (currentSize + newFilesSize > MAX_ORDER_ATTACHMENT_SIZE) {
                    var totalMB = ((currentSize + newFilesSize) / (1024 * 1024)).toFixed(2);
                    alert('Total file size (' + totalMB + 'MB) exceeds 10MB limit.');
                    document.getElementById('comp-file-upload').value = '';
                    return;
                }
                
                for (var i = 0; i < files.length; i++) {
                    var file = files[i];
                    
                    if (allowedTypes.indexOf(file.type) === -1) {
                        alert('File type not allowed: ' + file.name + '. Only PDF, PNG, and JPEG files are accepted.');
                        continue;
                    }
                    
                    (function(f) {
                        var reader = new FileReader();
                        reader.onload = function(e) {
                            vm.comp.uploadedFiles.push({
                                name: f.name,
                                size: f.size,
                                type: f.type,
                                base64: e.target.result.split(',')[1]
                            });
                            $scope.$apply();
                        };
                        reader.readAsDataURL(f);
                    })(file);
                }
                
                document.getElementById('comp-file-upload').value = '';
            }
        };

        vm.comp.removeFile = function(index) {
            vm.comp.uploadedFiles.splice(index, 1);
        };


// **************************** START COMP FUNCTIONS ****************************

    vm.comp.cancelOrder = function() {
        location.reload(true);
    }

    vm.comp.uploadExcel = function() {
        $('#comp_upload_excel').click();
    }

    vm.comp.handleExcel = function() {
        return handleExcelImport(vm.comp, '#comp_upload_excel', function(workbook) {
            return comp.extractExcelValues(workbook.sheet(0).usedRange().value());
        });
    }

    comp.createPhaseMap = function() {
        vm.comp.phases.forEach( function(phase) {
            vm.comp.phase_map_by_name[phase.name] = phase;
        });
    }

    comp.createNewSample = function() {
        return ({
            sample_expanded: vm.comp.mainCollapse,
            sample_checked: null,
            sample_delete: false,
            sample_name: null,
            sample_lot_batch_number: null,
            sample_category: null,
            sample_type: null,
            sample_types: null,
            sample_inhalable: null,
            sample_metrc_id: null,
            sample_source_id: null,
            sample_strain_name: null,
            sample_strain_type: null,
            sample_label_claims: null,
            sample_expected_potency: null,
            sample_matrix: null,
            sample_product_harvest_batch: 'PRODUCT_BATCH',
            sample_product_batch_size: null,
            sample_manufacture_date_open: false,
            sample_manufacture_date: null,
            sample_harvest_date_open: false,
            sample_harvest_date: null,
            sample_unit_weight: null,
            sample_add_terpenoid_profile: false,
            sample_analyze_by_lcmsms: false,
            focus: {
                    name: false,
                    lot_batch_number: false,
                    autofill: false
                },
                options: {
                    name: [],
                    lot_batch_number: [],
                    autofill: []
                }
        });
    }

    comp.extractComplianceValues = function(row) {
        var sample = comp.createNewSample();

        if(!row.every(allEmpty)) {
            var sample_category = row[3] ? formatSampleCategory(row[3]) : null;
            sample.sample_matrix = row[0] ? vm.comp.phase_map_by_name[row[0]] : null;
            sample.sample_name = !allEmpty(row[1]) ? stripInvalidQBChars(row[1]) : null;
            // Handle lot batch number - check if it's a date serial number from Excel
            if (row[2]) {
                if (typeof row[2] === 'number') {
                    // Check if this is likely an Excel date serial number
                    // Excel dates for 2018-2035: 43101 (1/1/2018) to 49673 (12/31/2035)
                    if (row[2] >= 43101 && row[2] <= 49673) {
                        // Convert Excel date serial number back to date string
                        var baseDate = 25567; // Excel base date for 1900 system
                        var date = new Date(Math.round((row[2] - baseDate - 1) * 86400 * 1000));

                        // Format as MM/DD/YYYY
                        var month = (date.getMonth() + 1).toString().padStart(2, '0');
                        var day = date.getDate().toString().padStart(2, '0');
                        var year = date.getFullYear();
                        sample.sample_lot_batch_number = month + '/' + day + '/' + year;
                    } else {
                        // This is just a regular number, not a date
                        sample.sample_lot_batch_number = row[2].toString();
                    }
                } else {
                    sample.sample_lot_batch_number = stripInvalidQBChars(row[2]);
                }
            } else {
                sample.sample_lot_batch_number = null;
            }
            sample.sample_category = sample_category ? sample_category : null;
            sample.sample_types = sample_category ? sample_category.types : null;
            sample.sample_type = sample_category ? checkSampleType(sample_category.types, row[4]) : null;
            sample.sample_inhalable = row[5] ? formatInhalableFromImport(row[5]) : null;
            sample.sample_source_id = row[6] ? row[6] : null;
            sample.sample_strain_name = row[7] ? row[7] : null;
            sample.sample_strain_type = row[8] ? formatStrainType(row[8]) : null;
            sample.sample_label_claims = row[9] ? row[9] : null;
            sample.sample_expected_potency = row[10] ? row[10] : null;
            sample.sample_add_terpenoid_profile = row[11] ? (row[11] == 'Yes' ? true : false) : false;
            sample.sample_analyze_by_lcmsms = row[12] ? (row[12] == 'Yes' ? true : false) : false;
            sample.sample_product_harvest_batch = row[13] ? comp.formatBatchType(row[13]) : null;
            sample.sample_product_batch_size = row[14] ? row[14] : null;
            row[14] ? (sample.sample_product_harvest_batch == 'PRODUCT_BATCH' ? sample.sample_harvest_date = comp.formatExcelDate(row[15]) : sample.sample_manufacture_date = comp.formatExcelDate(row[15])) : angular.noop;
            sample.sample_product_harvest_batch ? angular.noop : sample.sample_product_harvest_batch = 'PRODUCT_BATCH';
            sample.sample_unit_weight = row[16] ? row[16] : null;
            sample.sample_expanded =  true;
            vm.comp.samples.push(sample);
        }
    }

   comp.extractExcelValues = function(file) {
        if (!file || !file.length || !file[0]) {
            AlertService.error('Upload failed. The Excel file is empty.');
            return false;
        }

        var sampleCountBefore = vm.comp.samples.length;
        comp.createPhaseMap();

        for( var i = 1; i < file.length; i++) {
            comp.extractComplianceValues(file[i]);
        }

        vm.comp.checkPageOne();
        comp.resetDeleteCheckboxes();
        if (vm.comp.samples.length === sampleCountBefore) {
            AlertService.error('Upload failed. The Excel file does not contain any sample rows.');
            return false;
        }
        return true;
    }

    comp.formatExcelDate = function(date) {
        var new_date = new Date(date);

        if (new_date != 'Invalid Date'){
            return new_date
        }
        else {
            return null;
        }
    }

    comp.formatBatchType = function(batchType) {
        if (batchType == 'Product Batch') {
            return 'PRODUCT_BATCH'
        }
        else {
            return 'HARVEST_BATCH'
        }
    }

    vm.comp.downloadExcel = function() {
        comp.generateBlob();
    }

    comp.generateBlob = function() {
        return comp.generate()
            .then(function (blob) {
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, "Compliance Sample Submission.xlsx");
                } else {
                    var url = window.URL.createObjectURL(blob);
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.href = url;
                    a.download = "Compliance Sample Submission.xlsx";
                    a.click();
                    window.URL.revokeObjectURL(url);
                    document.body.removeChild(a);
                }
            })
            .catch(function (err) {
                alert(err.message || err);
                throw err;
            });
    }

    comp.generate = function(type) {
        return comp.getWorkbook()
            .then(function (workbook) {
                var r = workbook.sheet(0).range("A1:P1");
                var header = ['Matrix*', 'Sample Name*', 'Lot/Batch #*', 'Product Category*', 'Product Type*', 'Inhalable/Non-Inhalable*', 'Source UID*', 'Strain Name', 'Strain Type', 'Label Claims', 'Product Specifications*', 'Add Terpene Profile', 'Analyze by LCMSMS', 'Batch Type*', 'Batch Size*', 'Batch Date', 'Unit Weight*'];

                r.value([header]);
                workbook.sheet(0).row(1).style("bold", true);
                workbook.sheet(1).hidden(true);

                return workbook.outputAsync({ type: type });
            });
    }

    comp.getWorkbook = function() {
        return new Promise(function (resolve, reject) {
            var req = new XMLHttpRequest();
            var url = 'content/files/public/compliance.xlsx';

            req.open("GET", url, true);
            req.responseType = "arraybuffer";
            req.onreadystatechange = function () {
                if (req.readyState === 4){
                    if (req.status === 200) {
                        resolve(XlsxPopulate.fromDataAsync(req.response));
                    } else {
                        reject("Received a " + req.status + " HTTP code.");
                    }
                }
            };
            req.send();
        });
    }

    vm.comp.collapseAll = function() {
        vm.comp.mainCollapse = !vm.comp.mainCollapse;
        if (vm.comp.samples.length != 0) {
            vm.comp.samples.forEach( function(sample) {
                sample.sample_expanded = vm.comp.mainCollapse;
            });
        }
    }

    function findWithAttr(array, attr, value) {
        for(var i = 0; i < array.length; i += 1) {
            if(typeof(array[i][attr]) == 'string' && typeof(value) == 'string'){
                if(array[i][attr].toLowerCase() === value.toLowerCase()) {
                    return i;
                }
            }
            else {
                if(array[i][attr] === value) {
                    return i;
                }
            }
        }
        return -1;
    }

    vm.comp.changeMatrix = function(index) {
        var category_index = null;
        var type_index = null;
        var inhalable_index = null;

        if (vm.comp.samples.length < 1) {
            vm.comp.pageOneValid = false;
            return;
        }

        if(vm.comp.samples[index].sample_matrix) {
            if(vm.comp.samples[index].sample_matrix.value == 'PLANT_COMPLIANCE_PHASE_3') {
                category_index = findWithAttr(vm.comp.categories, 'name', 'Plant');
                type_index = findWithAttr(vm.comp.categories[category_index].types, 'name', 'Flower')
                inhalable_index = findWithAttr(vm.comp.inhalable_edible_array, 'value', 'INHALABLE');

                vm.comp.samples[index].sample_category = vm.comp.categories[category_index];
                vm.comp.populateTypes(vm.comp.samples[index]);
                vm.comp.samples[index].sample_inhalable = vm.comp.inhalable_edible_array[inhalable_index];
                vm.comp.samples[index].sample_type = vm.comp.categories[category_index].types[type_index];
            }
            else if(vm.comp.samples[index].sample_matrix.value == 'PRE_ROLL_COMPLIANCE_PHASE_3') {
                category_index = findWithAttr(vm.comp.categories, 'name', 'Plant');
                type_index = findWithAttr(vm.comp.categories[category_index].types, 'name', 'Pre-Roll')
                inhalable_index = findWithAttr(vm.comp.inhalable_edible_array, 'value', 'INHALABLE');

                vm.comp.samples[index].sample_category = vm.comp.categories[category_index];
                vm.comp.populateTypes(vm.comp.samples[index]);
                vm.comp.samples[index].sample_inhalable = vm.comp.inhalable_edible_array[inhalable_index];
                vm.comp.samples[index].sample_type = vm.comp.categories[category_index].types[type_index];
            }
            else if(vm.comp.samples[index].sample_matrix.value == 'INHALABLE_EXTRACT_COMPLIANCE_PHASE_3') {
                category_index = findWithAttr(vm.comp.categories, 'name', 'Concentrate');
                inhalable_index = findWithAttr(vm.comp.inhalable_edible_array, 'value', 'INHALABLE');

                vm.comp.samples[index].sample_category = vm.comp.categories[category_index];
                vm.comp.samples[index].sample_inhalable = vm.comp.inhalable_edible_array[inhalable_index];
                vm.comp.samples[index].sample_type = null;
            }
            else if(vm.comp.samples[index].sample_matrix.value == 'EDIBLE_COMPLIANCE_PHASE_3') {
                inhalable_index = findWithAttr(vm.comp.inhalable_edible_array, 'value', 'NONINHALABLE');

                vm.comp.samples[index].sample_category = null;
                vm.comp.samples[index].sample_inhalable = vm.comp.inhalable_edible_array[inhalable_index];
                vm.comp.samples[index].sample_type = null;
            }
            else if(vm.comp.samples[index].sample_matrix.value == 'SOLID_EDIBLE_COMPLIANCE_PHASE_3') {
                category_index = findWithAttr(vm.comp.categories, 'name', 'Edible');
                inhalable_index = findWithAttr(vm.comp.inhalable_edible_array, 'value', 'NONINHALABLE');

                vm.comp.samples[index].sample_category = vm.comp.categories[category_index];
                vm.comp.samples[index].sample_inhalable = vm.comp.inhalable_edible_array[inhalable_index];
                vm.comp.samples[index].sample_type = null;
            }
            else if(vm.comp.samples[index].sample_matrix.value == 'INFUSED_PREROLL_COMPLIANCE') {
                category_index = findWithAttr(vm.comp.categories, 'name', 'Plant');
                type_index = findWithAttr(vm.comp.categories[category_index].types, 'name', 'Infused Pre-Roll')
                inhalable_index = findWithAttr(vm.comp.inhalable_edible_array, 'value', 'INHALABLE');

                vm.comp.samples[index].sample_category = vm.comp.categories[category_index];
                vm.comp.populateTypes(vm.comp.samples[index]);
                vm.comp.samples[index].sample_inhalable = vm.comp.inhalable_edible_array[inhalable_index];
                vm.comp.samples[index].sample_type = vm.comp.categories[category_index].types[type_index];
            }

            if(category_index) {
                vm.comp.populateTypes(vm.comp.samples[index]);
            }
        }

        vm.comp.checkPageOne();
    }

    vm.comp.checkPageOne = function() {
        if (vm.comp.samples.length < 1) {
            vm.comp.pageOneValid = false;
            return;
        }

        for(var i = 0; i < vm.comp.samples.length; i++){
            if (!vm.comp.samples[i].sample_product_harvest_batch) {
                vm.comp.pageOneValid = false;
                return;
            }
            else {
                if (vm.comp.samples[i].sample_product_harvest_batch == 'PRODUCT_BATCH') {
                    if (!vm.comp.samples[i].sample_matrix ||
                        !vm.comp.samples[i].sample_name ||
                        !vm.comp.samples[i].sample_lot_batch_number ||
                        !vm.comp.samples[i].sample_category ||
                        !vm.comp.samples[i].sample_type ||
                        !vm.comp.samples[i].sample_inhalable ||
                        !vm.comp.samples[i].sample_source_id ||
                        !vm.comp.samples[i].sample_product_batch_size ||
                        !vm.comp.samples[i].sample_unit_weight || 
                        !vm.comp.samples[i].sample_expected_potency) {
                            vm.comp.pageOneValid = false;
                            return;
                    }
                }
                else {
                    if (!vm.comp.samples[i].sample_matrix ||
                        !vm.comp.samples[i].sample_name ||
                        !vm.comp.samples[i].sample_lot_batch_number ||
                        !vm.comp.samples[i].sample_category ||
                        !vm.comp.samples[i].sample_type ||
                        !vm.comp.samples[i].sample_inhalable ||
                        !vm.comp.samples[i].sample_source_id ||
                        !vm.comp.samples[i].sample_product_batch_size) {
                            vm.comp.pageOneValid = false;
                            return;
                    }
                }
            }
        }

        vm.comp.pageOneValid = true;
        return;
    }

    vm.comp.checkPageTwo = function() {
        if (!vm.fullLocationManufactur ||
            !vm.fullLocationComp ||
            !vm.comp.pickup_arrival_date ||
            !vm.fullLocationPickup ||
            !($('#emailToCompliance').val().length > 0) ||
            vm.pickupOutOfStateError
        ) {
            vm.comp.pageTwoValid = false;
            return;
        }
        vm.comp.pageTwoValid = true;
        return;
    }

    vm.comp.submitOrder = function() {
        $rootScope.type = 'COMPLIANCE';
        CustomerOrder.save(comp.serializePayload(), onSaveSuccess, onSaveError);
    }

    comp.serializeSamples = function(samples) {
        var serializedSamples = [];
        if (samples) {
            samples.forEach( function(sample){
                serializedSamples.push({
                    id: null,
                    name: sample.sample_name,
                    lotBatchNumber: sample.sample_lot_batch_number,
                    productCategory: typeof(sample.sample_category) == 'string' ? formatNameDict(sample.sample_category) : sample.sample_category,
                    productType: typeof(sample.sample_type) == 'string' ? formatNameDict(sample.sample_type) : sample.sample_type,
                    strainName: typeof(sample.sample_strain_name) != 'object' ? formatNameDict(sample.sample_strain_name) : sample.sample_strain_name,
                    strainType: typeof(sample.sample_strain_type) == 'string' ? formatNameDict(sample.sample_strain_type) : sample.sample_strain_type,
                    otherAnalysis: null,
                    reportedUnits: null,
                    productBatchSize: sample.sample_product_harvest_batch == 'PRODUCT_BATCH' ? sample.sample_product_batch_size : null,
                    harvestBatchSize: sample.sample_product_harvest_batch == 'HARVEST_BATCH' ? sample.sample_product_batch_size : null,
                    batchType: sample.sample_product_harvest_batch,
                    inhalableEdible: typeof(sample.sample_inhalable) == 'object' ? sample.sample_inhalable.value : sample.sample_inhalable,
                    sourceId: sample.sample_source_id ? sample.sample_source_id : null,
                    sCode: sample.sample_metrc_id ? sample.sample_metrc_id : null,
                    labelClaims: sample.sample_label_claims,
                    expectedPotency: sample.sample_expected_potency,
                    addTerpenes: sample.sample_add_terpenoid_profile ? sample.sample_add_terpenoid_profile : null,
                    analyzeByLCMSMS: sample.sample_analyze_by_lcmsms ? sample.sample_analyze_by_lcmsms : null,
                    manufactureDate: formatDate(sample.sample_manufacture_date),
                    harvestDate: formatDate(sample.sample_harvest_date),
                    sampleWeightPerIncrement: sample.sample_unit_weight ? sample.sample_unit_weight : null,
                    sampleTests: null,
                    phase: sample.sample_matrix.value ? sample.sample_matrix.value : null,
                    medicinal_batch: sample.medicinal_batch

                });
            });
        }
        return serializedSamples;
    }

    comp.serializePayload = function() {
        vm.comp.submitting = true;
        $rootScope.comp_submitting = vm.comp.submitting
        var payload = {
            orderType: "COMPLIANCE",
            collection_type: null,
            customer_account_id: $localStorage.customerId,
            dateCreated: null,
            dateReceived: null,
            date_submitted: null,
            delivery_preference: vm.comp.deliveryPreference,
            estimated_arrival_date: formatDate(vm.comp.pickup_arrival_date),
            partially_complete: null,
            poNumber: vm.comp.orderPO,
            reporting_preference: null,
            sample_condition: null,
            sampledDate: formatDate(vm.comp.pickup_arrival_date),
            samplingAddress: vm.samplingAddress,
            manufacturingAddress: vm.manufacturingAddress ? vm.manufacturingAddress : null,
            invoicing_address: vm.invoicing_address ? vm.invoicing_address : vm.customerData.qbAddress,
            shipping_carrier: null,
            specialInstructions: vm.comp.specialInstructions,
            customerComments: vm.comp.customerComments,
            state: null,
            submitted_by: vm.comp.emailsArray.join(),
            dynamic_turnaround_time: vm.comp.turnaroundTime,
            id: null,
            samples: comp.serializeSamples(vm.comp.samples),
            tracking_number: vm.comp.tracking_number,
            uploaded_files: vm.comp.uploadedFiles,
            source_workbooks: vm.comp.importedExcelFiles
        }

        return payload;
    }

        vm.comp.openCalendar = function(sample, key) {
            sample[key] = true;
        }

        vm.comp.estimateReportDate = function(turnaround_time){
            var days = null;

            if (turnaround_time.includes('3')) {
                days = 3;
            }
            else if (turnaround_time.includes('2')) {
                days = 2;
            }
            else if (turnaround_time.includes('1')) {
                days = 1;
            }

            if (days && turnaround_time && vm.comp.pickup_arrival_date) {
                var tomorrow = new Date(vm.comp.pickup_arrival_date.getTime());
                for (var i = 0; i < days; i++) {
                    tomorrow.setDate(tomorrow.getDate() + 1)
                    if (tomorrow.getDay() == 0) {
                        tomorrow.setDate(tomorrow.getDate() + 1)
                    }
                    else if (tomorrow.getDay() == 6) {
                        tomorrow.setDate(tomorrow.getDate() + 2)
                    }
                }

                vm.comp.estimated_report_date = tomorrow;
            }

            if (tomorrow) {
                var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
                vm.comp.estimated_report_date.day = days[tomorrow.getDay()]
                vm.comp.estimated_report_date.month_day_year = tomorrow.toDateString().substring(4);
            }
            vm.comp.checkPageTwo();
        }

        vm.comp.deleteChecked = function() {
            for(var i = vm.comp.samples.length-1; i >= 0; i--) {
                if (vm.comp.samples[i].sample_delete) {
                    vm.comp.samples.splice(i, 1);
                }
            }
            comp.resetDeleteCheckboxes();
            vm.comp.checkPageOne();
        }

        vm.comp.clickCheckAllDelete = function() {
            vm.comp.samples.forEach( function(sample) {
                sample.sample_delete = $(':checkbox.comp-delete-checkbox-header')[0].checked;
            });
        }

        vm.comp.clickDelete = function(index) {
            vm.comp.samples[index].sample_delete = !vm.comp.samples[index].sample_delete;
            $(':checkbox.comp-delete-checkbox-header')[0].checked = false;
        }

        vm.comp.incrementPage = function() {
            vm.comp.step = vm.comp.step + 1;
            if(vm.comp.step == 3) {
                vm.comp.emailsArray = vm.comp.emails.split(',')
            }
        }

        vm.comp.decrementPage = function() {
            vm.comp.step = vm.comp.step - 1;
        }

        vm.comp.removeSample = function(index) {
            vm.comp.samples.splice(index, 1);
            vm.comp.sampleArray.splice(index, 1);
            comp.resetDeleteCheckboxes();
            vm.comp.checkPageOne();
        }

        vm.comp.cloneSample = function(index) {
            // Create a deep copy of the sample
            var clonedSample = angular.copy(vm.comp.samples[index]);
            
            // IMPORTANT: Reset the fields we want to explicitly set
            clonedSample.sample_category = null;
            clonedSample.sample_type = null;
            clonedSample.sample_types = null;
            clonedSample.sample_inhalable = null;
            
            // Now explicitly set them with the correct references
            
            // 1. Handle sample_category
            if (vm.comp.samples[index].sample_category && vm.comp.categories) {
                for (var i = 0; i < vm.comp.categories.length; i++) {
                    if (vm.comp.categories[i].id === vm.comp.samples[index].sample_category.id) {
                        clonedSample.sample_category = vm.comp.categories[i];
                        break;
                    }
                }
            }
            
            // 2. Handle sample_types and sample_type
            if (clonedSample.sample_category && clonedSample.sample_category.types) {
                clonedSample.sample_types = clonedSample.sample_category.types;
                
                if (vm.comp.samples[index].sample_type) {
                    for (var j = 0; j < clonedSample.sample_types.length; j++) {
                        if (clonedSample.sample_types[j].id === vm.comp.samples[index].sample_type.id) {
                            clonedSample.sample_type = clonedSample.sample_types[j];
                            break;
                        }
                    }
                }
            }
            
            // 3. Handle sample_inhalable
            if (vm.comp.samples[index].sample_inhalable) {
                // If it's a string value
                if (typeof vm.comp.samples[index].sample_inhalable === 'string') {
                    // For comp, we use vm.comp.inhalable_edible_array which exists
                    if (vm.comp.inhalable_edible_array && vm.comp.inhalable_edible_array.length > 0) {
                        var inhalableIndex = findWithAttr(vm.comp.inhalable_edible_array, 'value', vm.comp.samples[index].sample_inhalable);
                        if (inhalableIndex !== -1) {
                            clonedSample.sample_inhalable = vm.comp.inhalable_edible_array[inhalableIndex];
                        } else {
                            // If not found in the array, just use the string directly
                            clonedSample.sample_inhalable = vm.comp.samples[index].sample_inhalable;
                        }
                    } else {
                        // If no array exists, just use the string directly
                        clonedSample.sample_inhalable = vm.comp.samples[index].sample_inhalable;
                    }
                } 
                // If it's an object with a value property
                else if (vm.comp.samples[index].sample_inhalable.value) {
                    if (vm.comp.inhalable_edible_array && vm.comp.inhalable_edible_array.length > 0) {
                        var inhalableIndex = findWithAttr(vm.comp.inhalable_edible_array, 'value', vm.comp.samples[index].sample_inhalable.value);
                        if (inhalableIndex !== -1) {
                            clonedSample.sample_inhalable = vm.comp.inhalable_edible_array[inhalableIndex];
                        } else {
                            clonedSample.sample_inhalable = vm.comp.samples[index].sample_inhalable;
                        }
                    } else {
                        clonedSample.sample_inhalable = vm.comp.samples[index].sample_inhalable;
                    }
                }
                // Otherwise just copy it directly
                else {
                    clonedSample.sample_inhalable = vm.comp.samples[index].sample_inhalable;
                }
            }
                        
            // Add the cloned sample to the array
            vm.comp.samples.splice(index + 1, 0, clonedSample);
            if (vm.comp.sampleArray && vm.comp.sampleArray.length > index) {
                var clonedSampleArray = angular.copy(vm.comp.sampleArray[index]);
                vm.comp.sampleArray.splice(index + 1, 0, clonedSampleArray);
            }
            comp.resetDeleteCheckboxes();
            vm.comp.checkPageOne();
        };
        
        comp.onPageLoad = function() {
            comp.getPanels();
            comp.getCategories();
        }

        comp.getPanels = function() {
            Panel.query({}, function(data){
            if (data) {
                for (var i = 0; i < data.length; i++) {
                    if (data[i].portalIdentifier) {
                        vm.comp.panels[data[i].portalIdentifier] = data[i];
                    }
                }
                vm.comp.phases = [
                        /* Plant */
                        {
                            'id': vm.comp.panels['PLANT_COMPLIANCE_PHASE_3'].id,
                            'name': 'Plant',
                            'value':'PLANT_COMPLIANCE_PHASE_3'
                        },

                        /* Pre-Roll Compliance */
                        {
                            'id': vm.comp.panels['PRE_ROLL_COMPLIANCE_PHASE_3'].id,
                            'name': 'Pre-Roll',
                            'value': 'PRE_ROLL_COMPLIANCE_PHASE_3'
                        },

                        /* Inhalable Extract */
                        {
                            'id': vm.comp.panels['INHALABLE_EXTRACT_COMPLIANCE_PHASE_3'].id,
                            'name': 'Inhalable Extract',
                            'value':'INHALABLE_EXTRACT_COMPLIANCE_PHASE_3'
                        },

                        /* Infused Pre-Roll */
                        {
                            'id': vm.comp.panels['INFUSED_PREROLL_COMPLIANCE'].id,
                            'name': 'Infused Pre-Roll',
                            'value':'INFUSED_PREROLL_COMPLIANCE'
                        },

                        /* Non-Inhalable */
                        {
                            'id': vm.comp.panels['EDIBLE_COMPLIANCE_PHASE_3'].id,
                            'name': 'Liquid Edible/Topical',
                            'value':'EDIBLE_COMPLIANCE_PHASE_3'
                        },

                        /* Solid Edible */
                        {
                            'id': vm.comp.panels['SOLID_EDIBLE_COMPLIANCE_PHASE_3'].id,
                            'name': 'Solid/Semi-Solid Edible',
                            'value':'SOLID_EDIBLE_COMPLIANCE_PHASE_3'
                        },
                    ];
                }
            });
        }

        vm.comp.addSample = function() {
            vm.comp.samples.push({
                sample_order_type: 'comp',
                sample_expanded: true,
                sample_checked: null,
                sample_delete: false,
                sample_name: null,
                sample_lot_batch_number: null,
                sample_category: null,
                sample_type: null,
                sample_types: null,
                sample_inhalable: null,
                sample_source_id: null,
                sample_metrc_id: null,
                sample_strain_name: null,
                sample_strain_type: null,
                sample_label_claims: null,
                sample_expected_potency: null,
                sample_matrix: null,
                sample_product_harvest_batch: 'PRODUCT_BATCH',
                sample_product_batch_size: null,
                sample_manufacture_date_open: false,
                sample_manufacture_date: null,
                sample_harvest_date_open: false,
                sample_harvest_date: null,
                sample_unit_weight: null,
                sample_add_terpenoid_profile: false,
                sample_analyze_by_lcmsms: false,
                focus: {
                    name: false,
                    lot_batch_number: false,
                    autofill: false
                },
                options: {
                    name: [],
                    lot_batch_number: [],
                    autofill: []
                },
                medicinal_batch: false
            });
            vm.comp.checkPageOne();
        }

        vm.comp.strainTypes  = [{
            'id': 1,
            'name': 'Sativa'
          }, {
             'id': 2,
             'name': 'Indica'
          }, {
            'id': 3,
            'name': 'Hybrid'
          },
          {
            'id': 4,
            'name': 'CBD'
          }];

        vm.comp.inhalable_edible_array  = [
            {
                'id': 1,
                'name': 'Inhalable',
                'value':'INHALABLE'
            },
            {
                'id': 2,
                'name': 'Non-Inhalable',
                'value':'NONINHALABLE'
            }
        ];

        comp.getCategories = function() {
            ProductCategory.query({}, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.comp.categories = data;
                comp.getTypes();
                return;
            }

            function onError(e) {
                console.log(e);
                return;
            }
        }

        comp.getTypes = function() {
            ProductType.query({}, onSuccess, onError);

            function onSuccess(data, headers){
               // Filter out specific product types if language is Japanese
            if ($localStorage.language === 'Japanese') {
                vm.comp.all_types = data.filter(function(type) {
                    return !['Crystalline', 'Hash', 'Kief', 'Infused Products', 'Cones/Tubes', 'Paper/Wrap'].includes(type.name);
                });
            } else {
                vm.comp.all_types = data;
            }
                comp.processCatAndTypes();
                return;
            }

            function onError(e) {
                console.log(e);
                return;
            }
        }

        comp.processCatAndTypes = function() {
            for(var i = 0; i < vm.comp.all_types.length; i++){
                for(var j = 0; j < vm.comp.categories.length; j++){
                    if (!vm.comp.categories[j.toString()].types){
                        vm.comp.categories[j.toString()].types = [];
                    }
                    if (vm.comp.all_types[i.toString()].productCategory.id == vm.comp.categories[j.toString()].id){
                        vm.comp.categories[j.toString()].types.push(vm.comp.all_types[i.toString()]);
                    }
                }
            }
        }

        comp.resetDeleteCheckboxes = function() {
            $(':checkbox.comp-delete-checkbox-header')[0].checked = false;
            vm.comp.samples.forEach( function(sample) {
                sample.sample_delete = false;
            });
        }

        vm.comp.populateTypes = function(sample) {
            for(var i = 0; i < vm.comp.categories.length; i++) {
                if (sample.sample_category.name == vm.comp.categories[i.toString()].name) {
                    sample.sample_types = vm.comp.categories[i.toString()].types;
                    return;
                }
            }
        }

        comp.onPageLoad();

// ***************************** END COMP FUNCTIONS *****************************
// **************************** START FDA ****************************
        vm.fda = {payload:{}}
        vm.fda.isFdaDisabled = true
        vm.fda.uploadedFiles = [];

        vm.fda.handleFileSelect = function(files) {
            if (files && files.length > 0) {
                var maxTotalSize = 10 * 1024 * 1024; // 10MB total
                var allowedTypes = ['application/pdf', 'image/png', 'image/jpeg'];
                
                var currentSize = 0;
                for (var i = 0; i < vm.fda.uploadedFiles.length; i++) {
                    currentSize += vm.fda.uploadedFiles[i].size;
                }
                
                var newFilesSize = 0;
                for (var i = 0; i < files.length; i++) {
                    newFilesSize += files[i].size;
                }
                
                if (currentSize + newFilesSize > maxTotalSize) {
                    var totalMB = ((currentSize + newFilesSize) / (1024 * 1024)).toFixed(2);
                    alert('Total file size (' + totalMB + 'MB) exceeds 10MB limit.');
                    document.getElementById('fda-file-upload').value = '';
                    return;
                }
                
                for (var i = 0; i < files.length; i++) {
                    var file = files[i];
                    
                    if (allowedTypes.indexOf(file.type) === -1) {
                        alert('File type not allowed: ' + file.name + '. Only PDF, PNG, and JPEG files are accepted.');
                        continue;
                    }
                    
                    (function(f) {
                        var reader = new FileReader();
                        reader.onload = function(e) {
                            vm.fda.uploadedFiles.push({
                                name: f.name,
                                size: f.size,
                                type: f.type,
                                base64: e.target.result.split(',')[1]
                            });
                            $scope.$apply();
                        };
                        reader.readAsDataURL(f);
                    })(file);
                }
                
                document.getElementById('fda-file-upload').value = '';
            }
        };

        vm.fda.removeFile = function(index) {
            vm.fda.uploadedFiles.splice(index, 1);
        };

        vm.fda.location = function(address, city, zipCode, name, medicalLicence, fullLocation) {
            vm.fda.payload.warehouse_address = createAddress(address, city, zipCode, name, medicalLicence);
            vm.fda.payload.warehouse_address = fullLocation;
            distribution_list_toggle();
        }
        function checkLineArray(element) {
            return element.productdesc !== '' && element.lineItem !== ''
        }
        vm.fda.checkfdaform = function(){
            var validLineArray
            if(vm.fda.line.length > 0){
                validLineArray = vm.fda.line.every(checkLineArray)
            }
            if(!vm.fda.payload.entry || !vm.fda.payload.warehouse_address || validLineArray === false){
                vm.fda.isFdaDisabled = true
                return false
            }
            else{
                if(!vm.fda.payload.detention_notice || !vm.fda.payload.list_invoice_pack){
                    vm.fda.isFdaDisabled = true
                    return false
                }
                else{
                    vm.fda.isFdaDisabled = false
                }
            }
        }
        vm.fda.submitOrder = function() {
            $rootScope.type = 'FDA'
            vm.fda.checkfdaform()
            vm.fda.payload.order_type = 'FDA';
            vm.fda.payload.customer_account_id = $localStorage.customerId
            vm.fda.payload.samples = vm.fda.line
            vm.fda.payload.uploaded_files = vm.fda.uploadedFiles
            CustomerOrder.save(vm.fda.payload, onSaveSuccess, onSaveError);
            if(vm.fda.submitting){
                ProgressInterval = setInterval(() => {
                    if (vm.progressCount < 31) {
                        vm.progressCount = vm.progressCount - 1;
                        var percentage = (vm.progressCount * 100)/30
                        progressCircle.style.backgroundImage = 'conic-gradient('+ 'rgb(50, 168, 82) ' +  percentage + '%, rgb(183, 237, 197) 0 )';
                        if(vm.progressCount <= 0 ){
                            $('#submitProgressModal').modal('hide');
                        }
                    } else {
                        vm.progressCount = 30;
                    }
                }, 1000);
                $(document).on('click', '.progress-button', function() {
                    $('#submitProgressModal').modal('show');
                });
            }
        }
        vm.fda.line = [{
            productdesc : '',
            lineItem : '',
            batchNo : ''
        }]
        vm.fda.addLine = function (){
            vm.fda.line.push({
                productdesc : '',
                lineItem : '',
                batchNo : ''
            })
            vm.fda.checkfdaform()
        }
        vm.fda.removeLine = function(index){
            vm.fda.line.splice(index,1)
        }

        vm.onfileUpload = function(id) {
            var file = $(`#${id}`)[0].files[0];
            var base64 = DataUtils.toBase64(file, function(data){
                if (!vm.fda.payload[id]) {
                    vm.fda.payload[id] = {}; // Initialize if undefined
                }
                vm.fda.payload[id].name = file.name; 
                vm.fda.payload[id].base64 = data;
                if(id == 'detention_notice' || id == 'list_invoice_pack'){
                    vm.fda.isFdaDisabled = false
                }
            });
            vm.fda.checkfdaform()
        };
// ***************************** END FDA FUNCTIONS *****************************


// **************************** START RND ****************************

        // Helper function to organize tests into panel and non-panel groups for R&D
        vm.rd.organizeTests = function(sample) {
            if (!sample) return;
            
            // Create arrays to hold panel and non-panel tests
            sample.nonPanelTests = [];
            sample.panelTests = [];
            
            
            // Get the current panel ID if one is selected
            var currentPanelId = sample.sample_panel_selected;
            
            // Sort tests into panel and non-panel arrays
            for (var i = 0; i < sample.sample_tests.length; i++) {
                var test = sample.sample_tests[i];
                if (test.checked) {
                    // A test is part of the panel if:
                    // 1. It has a panel_id property AND
                    // 2. That panel_id matches the currently selected panel AND
                    // 3. A panel is actually selected
                    if (test.panel_id && currentPanelId && test.panel_id == currentPanelId) {
                        sample.panelTests.push(test);
                    } else {
                        // If the test has a panel_id but it doesn't match the current panel,
                        // or if it has no panel_id, it should be treated as a non-panel test
                        sample.nonPanelTests.push(test);
                    }
                }
            }
            
            // Debug the variables that control panel button visibility
            };

        vm.rd.step = 1;
        vm.rd.pageOneValid = false;
        vm.rd.pageTwoValid = false;
        vm.rd.pageThreeValid = false;
        vm.rd.customer_type = $rootScope.customer ? ($rootScope.customer.customer_type ? $rootScope.customer.customer_type : 'Cannabis') : 'Cannabis';
        vm.rd.company_discount = $rootScope.customer ? ($rootScope.customer.company_discount ? $rootScope.customer.company_discount : null) :  null;
        vm.rd.excel_header_offset =  vm.rd.customer_type.includes('Cannabis') || vm.rd.customer_type.includes('Hemp') ? 14 : 5;
        vm.rd.file = null;
        vm.rd.specialInstructions = null;
        vm.rd.customerComments = null;
        vm.rd.turnaroundTime = vm.rd.turnaroundTimeOptions ? '3 day (standard)' : '10 Days (standard)';
        vm.rd.estimated_report_date = null;
        vm.rd.categories = null;
        vm.rd.sampleArray = [];
        vm.rd.all_types = null;
        vm.rd.manufacturing_address = null;
        vm.rd.deliveryPreference = null;
        vm.rd.orderPO = null;
        vm.rd.pickup_arrival_date = null;
        vm.rd.emails = '';
        vm.rd.samples = [];
        vm.rd.tests = [];
        vm.rd.testsRequested = [];
        vm.rd.testsRequestedCount = [];
        vm.rd.mainCollapse = false;
        vm.rd.total = 0;
        vm.rd.subtotal = null;
        vm.rd.total_discount = 0;
        vm.rd.excel_assay_header = null;
        vm.rd.excel_assay_index_map = {};
        vm.rd.assay_map = {};
        vm.rd.assay_map_by_index = {};
        vm.rd.cannabinoid_assays = {}
        vm.rd.cannabinoid_assay_added = false;
        vm.rd.all_assay_map_by_id = {};
        vm.rd.all_tests = [];
        vm.rd.showTests = {};
        vm.rd.showTestsArray = [];
        vm.rd.showTestResults = null;
        vm.rd.panels = {};
        vm.rd.panels.current_panel_index = null;
        vm.rd.panels.new_panel_name = null;
        vm.rd.panel_by_id_map = {}
        vm.rd.current_sample_name = null;
        vm.rd.customPanels = [];
        vm.rd.qbenchPanels = [];
        vm.order_type = vm.rd.customer_type == 'Cannabis' ? 'Compliance' : 'RnD';
        vm.rd.test_to_search = '';
        vm.rd.other_analyses = [];
        vm.rd.user_added_assays = [];
        vm.rd.existing_user_added_assays = [];
        vm.rd.number_of_freq_assays = 0;
        vm.rd.submitting = false;
        vm.rd.processingExcelUpload = false;
        vm.rd.uploadedFiles = [];
        vm.rd.importedExcelFiles = [];

        vm.rd.handleFileSelect = function(files) {
            if (files && files.length > 0) {
                var allowedTypes = ['application/pdf', 'image/png', 'image/jpeg'];
                
                var currentSize = getTotalFileSize(vm.rd.uploadedFiles);
                currentSize += getTotalFileSize(vm.rd.importedExcelFiles);
                
                var newFilesSize = 0;
                for (var i = 0; i < files.length; i++) {
                    newFilesSize += files[i].size;
                }
                
                if (currentSize + newFilesSize > MAX_ORDER_ATTACHMENT_SIZE) {
                    var totalMB = ((currentSize + newFilesSize) / (1024 * 1024)).toFixed(2);
                    alert('Total file size (' + totalMB + 'MB) exceeds 10MB limit.');
                    document.getElementById('rd-file-upload').value = '';
                    return;
                }
                
                for (var i = 0; i < files.length; i++) {
                    var file = files[i];
                    
                    if (allowedTypes.indexOf(file.type) === -1) {
                        alert('File type not allowed: ' + file.name + '. Only PDF, PNG, and JPEG files are accepted.');
                        continue;
                    }
                    
                    (function(f) {
                        var reader = new FileReader();
                        reader.onload = function(e) {
                            vm.rd.uploadedFiles.push({
                                name: f.name,
                                size: f.size,
                                type: f.type,
                                base64: e.target.result.split(',')[1]
                            });
                            $scope.$apply();
                        };
                        reader.readAsDataURL(f);
                    })(file);
                }
                
                document.getElementById('rd-file-upload').value = '';
            }
        };

        vm.rd.removeFile = function(index) {
            vm.rd.uploadedFiles.splice(index, 1);
        };

        // **************************** START RND FUNCTIONS ****************************

        rd.showAllTests = function() {
            angular.forEach(vm.rd.showTests, function(value, key) {
                vm.rd.showTests[key] = true;
            });
            return;
        }

        rd.getTypes = function() {
            ProductType.query({}, onSuccess, onError);

            function onSuccess(data, headers){
                vm.rd.all_types = data;
                rd.processCatAndTypes();
                return;
            }

            function onError(e) {
                console.log(e);
                return;
            }
        }

        rd.processCatAndTypes = function() {
            for(var i = 0; i < vm.rd.all_types.length; i++){
                for(var j = 0; j < vm.rd.categories.length; j++){
                    if (!vm.rd.categories[j.toString()].types){
                        vm.rd.categories[j.toString()].types = [];
                    }
                    if (vm.rd.all_types[i.toString()].productCategory.id == vm.rd.categories[j.toString()].id){
                        vm.rd.categories[j.toString()].types.push(vm.rd.all_types[i.toString()]);
                    }
                }
            }
        }

        rd.resetDeleteCheckboxes = function() {
            $(':checkbox.delete-checkbox-header')[0].checked = false;
            vm.rd.samples.forEach( function(sample) {
                sample.sample_delete = false;
            });
        }

        vm.rd.filterAssays = function() {
            vm.rd.showTestsArray = Object.keys(vm.rd.showTests);
            vm.rd.showTestResults = $filter('filter')(vm.rd.showTestsArray, vm.rd.test_to_search);
            angular.forEach(vm.rd.showTests, function(value, key) {
                vm.rd.showTests[key] = false;
            });
            vm.rd.showTestResults.forEach( function(test) {
                vm.rd.showTests[test] = true;
            });
            // rd.setInfoBoxCoordinates();
        }
        //filtertering with the ID
        vm.rd.customFilter = function(item) {
            var searchText = vm.rd.test_to_search;
            if (/^\d+$/.test(searchText)) {
                var idMatches = (item.id.toString().indexOf(searchText) !== -1);
                var assayIdMatches = (item.assay_id && item.assay_id.toString().indexOf(searchText) !== -1);
                return idMatches || assayIdMatches;
            } else {
                return item.display_name.toLowerCase().includes(searchText.toLowerCase());
            }
        };
             
        // not currently being used
        function getExistingAssays() {
            if (vm.customerData.added_assays) {
                vm.customerData.added_assays.forEach( function(id) {
                    vm.rd.addExistingAssay(id);
                });
            }
        }

        // not currently being used
        vm.rd.addExistingAssay = function(id) {
            var test = vm.rd.all_assay_map_by_id[id];

            test.index = vm.rd.tests.length;
            vm.rd.assay_map[test.display_name] = [test.index, test];
            vm.rd.assay_map_by_index[test.index] = test;
            vm.rd.tests.push(test)

            vm.rd.existing_user_added_assays.push(id);

            vm.rd.test_to_search = '';
        }

        vm.rd.clear_test_to_search = function() {
            vm.rd.test_to_search = '';
            vm.rd.filterAssays();
            // rd.setInfoBoxCoordinates();
        }

        vm.rd.select_test_to_search = function(name) {
            vm.rd.test_to_search = name;
            vm.rd.filterAssays();
            // rd.setInfoBoxCoordinates();
        }

        vm.rd.clickCheckAllAddedTest = function(test, index) {
            var selector = ':checkbox.added-assay-col-header-' + index;
            vm.rd.samples.forEach( function(sample) {
                sample.sample_other_analyses[test] = $(selector)[0].checked
            });

            vm.rd.checkPageTwo();
        }

        vm.rd.addOtherAnalysis = function() {
            vm.rd.other_analyses.push(vm.rd.test_to_search);
            vm.rd.test_to_search = '';
            rd.showAllTests()

            return;
        }

        vm.rd.clearOtherAnalysis = function() {
            rd.showAllTests();
            vm.rd.other_analyses = [];
            vm.rd.test_to_search = '';

            return;
        }

        vm.rd.savePanel = function(sampleIndex, step) {
            if (step == 1) {
                vm.rd.panels.current_panel_index = sampleIndex;
                $('#addPanelName').modal('show'); 
                return;
            }

            else if (step == 2) {
                var assays = [];
                Object.keys(vm.rd.sampleArray[vm.rd.panels.current_panel_index]).forEach( function(key) {
                    if (vm.rd.sampleArray[vm.rd.panels.current_panel_index][key]) {
                        assays.push({id: vm.rd.assay_map_by_index[key].id})
                    }
                });

                if (vm.rd.panels.new_panel_name && assays) {
                    CustomPanel.create({
                            title: vm.rd.panels.new_panel_name,
                            assays: assays
                        },
                        function() {
                            vm.rd.samples[vm.rd.panels.current_panel_index].sample_has_tests = true;

                            rd.getPanelsByCustomerAndSetPanel(vm.rd.panels.current_panel_index);
                        },
                        function(e) {
                            console.log(e);
                        }
                    );
                }
                return;
            }
        }

        rd.getPanelsByCustomerAndSetPanel = function(sampleIndex) {
            CustomPanel.query({},
                function(data) {
                    vm.rd.customPanels = [];
                    var panel_id = null
                    data.forEach( function(panel) {
                        vm.rd.customPanels.push({
                            title: panel.title,
                            assays:rd.getPanels(panel),
                            id: panel.id,
                            type: 'custom_panel'
                        });
                    });
                    rd.setPanelsByIdMap();
                    panel_id = vm.rd.customPanels[vm.rd.customPanels.length-1].id;
                    vm.rd.setPanel(vm.rd.samples[sampleIndex], panel_id, 'custom_panel');
                    vm.rd.samples[sampleIndex].sample_panel_by_id = panel_id;
                    vm.rd.samples[sampleIndex].sample_has_tests = false;
                    vm.rd.panels.current_panel_index = null;
                    vm.rd.panels.new_panel_name = null;
                },
                function(e){
                    console.log(e);
                }
            );
        }


        vm.rd.updatePanel = function(sampleIndex, panelId) {
            var assays = [];
            Object.keys(vm.rd.sampleArray[sampleIndex]).forEach( function(key) {
                if(vm.rd.sampleArray[sampleIndex][key]) {
                    assays.push({id: vm.rd.assay_map_by_index[key].id})
                }
            });
            CustomPanel.update({
                id: panelId,
                assays: assays
            },
                function() {
                    vm.rd.samples[sampleIndex].sample_has_tests = false;
                    rd.getPanelsByCustomer();
                },
                function(e) {
                    console.log(e);
                }
            );
            return;
        }

        vm.rd.deletePanel = function(panelId) {
            vm.rd.customPanels = [];

            CustomPanel.delete({id: panelId},
                function() {
                    rd.getPanelsByCustomer();
                },
                function(e) {
                    console.log(e);
                }
            );

            return;
        }

        rd.isSample = function(object) {
            return object.sample_name == vm.rd.current_sample_name;
        }

        rd.isBasicPotencyAssay = function(test) {
            if(test.portal_identifier && [vm.const.PLANT, vm.const.NON_PLANT].includes(test.portal_identifier)) {
                return true;
            }
            else {
                return false
            }
        }

        rd.potencyAssayByCategory = function(category) {
            if(['Plant'].includes(category.name)) {
                return vm.rd.cannabinoid_assays[vm.const.PLANT]
            }
            else if(['Concentrate', 'Edible', 'Topical', 'Environmental', 'Other'].includes(category.name)) {
                return vm.rd.cannabinoid_assays[vm.const.NON_PLANT]
            }
        }

        vm.rd.removePanelFromSample = function(sampleIndex) {
            Object.keys(vm.rd.sampleArray[sampleIndex]).forEach( function(key) {
                vm.rd.sampleArray[sampleIndex][key] = false;
            });

            vm.rd.tests.forEach( function(test, index) {
                $(':checkbox.assay-col-header-' + index)[0].checked = false;
            })

            vm.rd.current_sample_name = false;
            vm.rd.samples[sampleIndex].sample_current_panel_title = null;
            vm.rd.samples[sampleIndex].sample_panel_selected = null;
            vm.rd.samples[sampleIndex].sample_panel_by_id = null;
            vm.rd.samples[sampleIndex].sample_panel_type = null;
            vm.rd.samples[sampleIndex].sample_has_tests = null;
            vm.rd.samples[sampleIndex].sample_tests = [];

            vm.rd.checkPageTwo();
        }

        vm.rd.setPanel = function(sample, panelId, panel_type) {
            // Find the actual sample index by object reference, not by name
            var sampleIndex = vm.rd.samples.indexOf(sample);
            
            if (sampleIndex === -1) {
                console.error('Sample not found in samples array');
                return;
            }
            
            vm.rd.current_sample_name = sample.sample_name;

            var temp = null;
            if (vm.rd.sampleArray[sampleIndex]) {
                delete vm.rd.sampleArray[sampleIndex];
            }
            vm.rd.sampleArray[sampleIndex] = {};

            // Store existing tests that are not part of the panel
            var existingTests = [];
            if (vm.rd.samples[sampleIndex].sample_tests) {
                // Save any manually added tests that are checked
                existingTests = vm.rd.samples[sampleIndex].sample_tests.filter(function(test) {
                    return test.checked && !test.panel_id;
                });
                
                
                // Clear the tests array to rebuild it
                vm.rd.samples[sampleIndex].sample_tests = [];
                
                // Add back the preserved tests first
                existingTests.forEach(function(test) {
                    // Ensure these tests are marked as non-panel tests
                    if (test.panel_id) {
                        delete test.panel_id;
                        delete test.panel_name;
                    }
                    vm.rd.samples[sampleIndex].sample_tests.push(test);
                });
            }
            
            // Track assays that customer doesn't have access to
            var inaccessibleAssays = [];
            var accessibleAssays = [];
            
            // Process each assay in the panel
            vm.rd.panel_by_id_map[panelId][1].forEach(function (assay) {
                // IMPORTANT: For panels, we grant access to ALL assays in the panel
                // regardless of customer's normal access rights
                
                // First ensure the assay is in showTests/showTestsArray if it's from a panel
                if (vm.rd.showTestsArray.indexOf(assay.display_name) === -1) {
                    // This is a panel assay the customer doesn't normally have access to
                    // Add it to the accessible lists
                    vm.rd.showTests[assay.display_name] = true;
                    vm.rd.showTestsArray.push(assay.display_name);
                    // Granting access to R&D panel assay
                }
                
                // Check if the assay exists in the assay map
                if (vm.rd.assay_map[assay.display_name]) {
                    // Now the customer has access (we just granted it above if needed)
                    // Add accessible assays to the sample
                    temp = Object.assign({}, vm.rd.assay_map[assay.display_name][1]);
                    temp.checked = true;
                    
                    // Set panel association on the test
                    temp.panel_id = panelId;
                    temp.panel_name = vm.rd.panel_by_id_map[panelId][0];
                    
                    // Handle source_uid vs source_id mapping
                    if (temp.source_id && !temp.source_uid) {
                        temp.source_uid = temp.source_id;
                    }
                    
                    vm.rd.samples[sampleIndex].sample_tests.push(temp);
                    vm.rd.sampleArray[sampleIndex][vm.rd.assay_map[assay.display_name][1].index] = true;
                    accessibleAssays.push(assay.display_name);
                } else {
                    // Assay not in assay_map - this shouldn't happen with our previous fixes
                    console.warn('R&D Panel assay not in assay_map:', assay.display_name);
                    inaccessibleAssays.push(assay.display_name);
                }
            });
            

            vm.rd.samples[sampleIndex].sample_panel_selected = panelId;
            vm.rd.samples[sampleIndex].sample_panel_type = panel_type;
            vm.rd.samples[sampleIndex].sample_current_panel_title = vm.rd.panel_by_id_map[panelId][0];
            vm.rd.current_sample_name = null;
            vm.rd.checkPageTwo();
            
            // Organize tests for display
            vm.rd.organizeTests(vm.rd.samples[sampleIndex]);

            return;
        }

        vm.rd.applyPanelToAll = function(panelId, panelType) {
            vm.rd.samples.forEach(function(sample) {
                vm.rd.setPanel(sample, panelId, panelType);
                sample.sample_panel_by_id = panelId;
            });
        };

        vm.rd.clearPanelFromAll = function() {
            vm.rd.samples.forEach(function(sample, index) {
                vm.rd.removePanelFromSample(index);
            });
        };
        
        // Check if all tests in a panel are selected for a sample
        vm.rd.checkPanelTestsSelection = function(sampleIndex) {
            var sample = vm.rd.samples[sampleIndex];
            
            // If no panel is selected, nothing to check
            if (!sample.sample_panel_selected) {
                return;
            }
            
            var panelId = sample.sample_panel_selected;
            if (!vm.rd.panel_by_id_map || !vm.rd.panel_by_id_map[panelId] || !vm.rd.panel_by_id_map[panelId][1]) {
                return;
            }
            
            var panelAssays = vm.rd.panel_by_id_map[panelId][1];
            var allAssaysSelected = true;
            var accessibleAssaysInPanel = [];
            var inaccessibleAssaysInPanel = [];
            var selectedAssays = [];
            
            // First, collect all accessible assays that should be in the panel
            panelAssays.forEach(function(assay) {
                if (vm.rd.assay_map[assay.display_name]) {
                    var assayId = vm.rd.assay_map[assay.display_name][1].id;
                    var customerHasAccess = vm.rd.showTestsArray.indexOf(assay.display_name) !== -1;
                    
                    if (customerHasAccess) {
                        accessibleAssaysInPanel.push(assayId);
                    } else {
                        inaccessibleAssaysInPanel.push(assay.display_name);
                    }
                }
            });
            
            // Then, collect all selected assays
            for (var i = 0; i < sample.sample_tests.length; i++) {
                if (sample.sample_tests[i].checked) {
                    selectedAssays.push(sample.sample_tests[i].id);
                }
            }
            
            // Check if all accessible panel assays are selected
            for (var i = 0; i < accessibleAssaysInPanel.length; i++) {
                if (selectedAssays.indexOf(accessibleAssaysInPanel[i]) === -1) {
                    allAssaysSelected = false;
                    break;
                }
            }
                        
            // If not all accessible assays are selected, remove panel association
            if (!allAssaysSelected) {
                // Keep the tests but remove panel association
                sample.sample_panel_selected = null;
                sample.sample_panel_type = null;
                sample.sample_current_panel_title = null;
                
                // Only remove panel association from tests that were part of this panel
                // This preserves any manually added tests that aren't part of the panel
                for (var i = 0; i < sample.sample_tests.length; i++) {
                    if (sample.sample_tests[i].panel_id === panelId) {
                        delete sample.sample_tests[i].panel_id;
                        delete sample.sample_tests[i].panel_name;
                    }
                }
                
                // For R&D samples, we need to update the UI to reflect individual assays
                // rather than panel assays
                vm.rd.sampleArray[sampleIndex] = {};
                
                // Update the sampleArray to reflect only the checked tests
                for (var i = 0; i < sample.sample_tests.length; i++) {
                    if (sample.sample_tests[i].checked && sample.sample_tests[i].index) {
                        vm.rd.sampleArray[sampleIndex][sample.sample_tests[i].index] = true;
                    }
                }
            } else {
                // Make sure panel association is properly set
                sample.sample_panel_selected = panelId;
                sample.sample_panel_type = sample.sample_panel_type || 'panel';
                sample.sample_current_panel_title = vm.rd.panel_by_id_map[panelId][0];
                
                // Only set panel association on tests that are part of this panel
                // DO NOT modify tests that aren't part of this panel
                var panelAssayIds = accessibleAssaysInPanel;
                for (var i = 0; i < sample.sample_tests.length; i++) {
                    if (sample.sample_tests[i].checked && panelAssayIds.indexOf(sample.sample_tests[i].id) !== -1) {
                        sample.sample_tests[i].panel_id = panelId;
                        sample.sample_tests[i].panel_name = vm.rd.panel_by_id_map[panelId][0];
                    }
                }
            }
            
            // Organize tests for display
            vm.rd.organizeTests(sample);
            
            return allAssaysSelected;
        }

        vm.rd.strainTypes = [{
            'id': 1,
            'name': 'Sativa'
          }, {
             'id': 2,
             'name': 'Indica'
          }, {
            'id': 3,
            'name': 'Hybrid'
          },
           {
            'id': 4,
            'name': 'CBD'
           }];

        vm.rd.inhalable = [
            {
                'id': 1,
                'name': 'Inhalable',
                'value': 'INHALABLE'
            },
            {
                'id': 2,
                'name': 'Non-Inhalable',
                'value': 'NONINHALABLE'
            }
        ]

        vm.rd.mhlwProductTypes = ['Oil', 'Powder', 'Aqueous Solution', 'Other'];

        vm.rd.cancelOrder = function() {
            vm.rd.step = 1;
            vm.rd.pageOneValid = false;
            vm.rd.pageTwoValid = false;
            vm.rd.pageThreeValid = false;
            vm.rd.specialInstructions = null;
            vm.rd.estimated_report_date = null;
            vm.rd.manufacturing_address = null;
            vm.rd.deliveryPreference = null;
            vm.rd.orderPO = null;
            vm.rd.pickup_arrival_date = null;
            vm.rd.emails = '';
            vm.rd.samples = [];
            vm.fullLocationManufactur = null;
            vm.rd.sampleArray = [];
            vm.rd.mainCollapse = false;
            vm.rd.other_analyses = [];
            vm.rd.user_added_assays = [];
            vm.rd.panels = {};
            vm.rd.panels.current_panel_index = null;
            vm.rd.panels.new_panel_name = null;
            vm.rd.turnaroundTime = '3 day (standard)';
            CustomerOrder.getCustomerEmails({}, onCustomerEmailSuccess, onCustomerEmailError);
        }

         rd.getOrderTotal = function() {
            vm.rd.total = 0;
            vm.rd.subtotal = null;
            vm.rd.total_discount = 0;
            vm.rd.testsRequestedCount.forEach( function(test) {
                // set list price of test
                if (test.assay_customer) {
                    if (test.assay_customer.basePrice) {
                        test.list_price = test.assay_customer.basePrice;
                    }
                    else {
                        if (test.base_price) {
                           test.list_price = test.base_price;
                        }
                        else {
                            test.list_price = null;
                        }
                    }
                }
                else if (test.base_price){
                    test.list_price = test.base_price;
                }
                else {
                    test.list_price = null;
                }
                // set discount of test
                if (test.assay_customer) {
                    if (test.assay_customer.discount) {
                        test.discount = test.assay_customer.discount;
                    }
                    else {
                        if (vm.rd.company_discount) {
                            test.discount = vm.rd.company_discount;
                        }
                        else {
                            test.discount = null;
                        }
                    }
                }
                else if (vm.rd.company_discount){
                    test.discount = vm.rd.company_discount;
                }
                else {
                    test.discount = null;
                }
                // set amount for test and get order subtotal/discount/total
                if (test.list_price && test.count) {
                    if (test.discount) {
                        vm.rd.total_discount = vm.rd.total_discount + (test.list_price * (test.discount / 100));
                        test.amount = (test.list_price * test.count) * (1 - (test.discount / 100));
                        vm.rd.total = vm.rd.total + test.amount
                    }
                    else {
                        test.amount = test.list_price * test.count;
                        vm.rd.total = vm.rd.total + test.amount
                    }
                }
                else {
                    test.amount = null;
                }
            });

            if (vm.rd.total && vm.rd.total_discount) {
                vm.rd.subtotal = vm.rd.total + vm.rd.total_discount;
            }
            else {
                vm.rd.subtotal = vm.rd.total;
            }
        }

        rd.processAllSampleTests = function() {
            vm.rd.testsRequested.length = 0;
            vm.rd.testsRequestedCount.length = 0;
            vm.rd.testsRequested = [];
            vm.rd.testsRequestedCount = [];
            var added = [];
            var to_add = null;

            for(var i = 0; i < vm.rd.samples.length; i++) {
                for(var j = vm.rd.samples[i].sample_tests.length-1; j >= 0; j--) {
                    if(rd.isBasicPotencyAssay(vm.rd.samples[i].sample_tests[j])) {
                        to_add = rd.potencyAssayByCategory(vm.rd.samples[i].sample_category);
                        to_add.checked = true;
                        vm.rd.samples[i].sample_tests[j] = jQuery.extend({}, to_add);
                        vm.rd.testsRequested.push(to_add);
                    }
                    else {
                        vm.rd.testsRequested.push(vm.rd.samples[i].sample_tests[j]);
                    }
                }
            }
            // rd.getOrderTotal();
        }

        vm.rd.estimateReportDate = function(turnaround_time) {
            var days_length = turnaround_time.split(' days')[0];
            var days = null;

            if(days_length.includes('-')) {
                days = days_length.split('-')[1];
            }
            else {
                days = days_length;
            }

            days = parseInt(days);

            if (days && turnaround_time && vm.rd.pickup_arrival_date) {
                var tomorrow = new Date(vm.rd.pickup_arrival_date.getTime());
                for (var i = 0; i < days; i++) {
                    tomorrow.setDate(tomorrow.getDate() + 1)
                    if (tomorrow.getDay() == 0) {
                        tomorrow.setDate(tomorrow.getDate() + 1)
                    }
                    else if (tomorrow.getDay() == 6) {
                        tomorrow.setDate(tomorrow.getDate() + 2)
                    }
                }

                vm.rd.estimated_report_date = tomorrow;
            }
            if (tomorrow) {
                var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
                vm.rd.estimated_report_date.day = days[tomorrow.getDay()]
                vm.rd.estimated_report_date.month_day_year = tomorrow.toDateString().substring(4);
            }
            vm.rd.checkPageThree();
        }

        vm.rd.openCalendar = function(sample, key) {
            sample[key] = true;
        }

        vm.rd.populateTypes = function(sample) {
            for(var i = 0; i < vm.rd.categories.length; i++) {
                if (sample.sample_category.name == vm.rd.categories[i.toString()].name) {
                    sample.sample_types = vm.rd.categories[i.toString()].types;
                    return;
                }
            }
        }

        vm.rd.clearPanel = function() {
            vm.rd.panels.current_panel_index = null;
            vm.rd.current_sample_name = null;
            vm.rd.panels.current_panel_index = null;
            vm.rd.panels.new_panel_name = null;        
        }

        vm.rd.uploadExcel = function() {
            $('#rd_upload_excel').click();
        }

        vm.rd.downloadExcel = function() {
            rd.generateBlob();
        }

        rd.getWorkbook = function() {
            return new Promise(function (resolve, reject) {
                var req = new XMLHttpRequest();
                var url = 'content/files/public/cannabis.xlsx';

                req.open("GET", url, true);
                req.responseType = "arraybuffer";
                req.onreadystatechange = function () {
                    if (req.readyState === 4){
                        if (req.status === 200) {
                            resolve(XlsxPopulate.fromDataAsync(req.response));
                        } else {
                            reject("Received a " + req.status + " HTTP code.");
                        }
                    }
                };
                req.send();
            });
        }

        // Function to convert column index to Excel column letter
        function getColumnLetter(index) {
            var letter = '';
            while (index >= 0) {
                letter = String.fromCharCode(index % 26 + 65) + letter;
                index = Math.floor(index / 26) - 1;
            }
            return letter;
        }
        // Function to apply dropdown to a column
        function applyDropdown(sheet, col, options) {
            var range = sheet.range(col + "2:" + col + "1048576"); // Apply dropdown to entire column starting from row 2
            range.dataValidation({
                type: 'list',
                showErrorMessage: true,
                formula1: '"' + options.join(',') + '"'
            });
        }

        rd.generate = function(type) {
            return rd.getWorkbook()
                .then(function (workbook) {
                    var r = workbook.sheet(0).range("A1:AY1");
                    var header = null;

                    if (vm.rd.customer_type.includes('Cannabis') || vm.rd.customer_type.includes('Hemp')) {
                        header = ['Sample Name*', 'Lot/Batch #*', 'Product Category*', 'Product Type*', 'Inhalable/Non-Inhalable*', 'Source UID', 'Strain Name', 'Strain Type', 'Label Claims', 'Product Specifications*', 'Expiration Date', 'Best By Date','Production Date (MM/DD/YYYY)', 'Date Collected (MM/DD/YYYY HH:MM AM/PM)'];
                    }
                    else {
                       header = ['Sample Name*', 'Lot/Batch #*', 'Product Category', 'Product Type', 'Inhalable/Non-Inhalable'];
                    }
                    var dropdownOptions = {}
                    var options = ['Yes', 'No']

                    vm.rd.tests.forEach( function(test) {
                        test.display_name ? header.push(test.display_name) : header.push(test.reporting_title);
                        var headerName = test.display_name ? test.display_name : test.reporting_title
                        dropdownOptions[headerName] = options;
                    });

                    header.forEach(function (headerName, index) {
                        var colLetter = getColumnLetter(index);
                        if (dropdownOptions[headerName]) {
                            applyDropdown(workbook.sheet(0), colLetter, dropdownOptions[headerName]);
                        }
                    });
                    r.value([header]);
                    workbook.sheet(0).row(1).style("bold", true);
                    workbook.sheet(1).hidden(true);
                    return workbook.outputAsync({ type: type });
                });
        }

        rd.generateBlob = function() {
            return rd.generate()
                .then(function (blob) {
                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(blob, "QA_RND Sample Submission.xlsx");
                    } else {
                        var url = window.URL.createObjectURL(blob);
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.href = url;
                        a.download = "QA_RND Sample Submission.xlsx";
                        a.click();
                        window.URL.revokeObjectURL(url);
                        document.body.removeChild(a);
                    }
                })
                .catch(function (err) {
                    alert(err.message || err);
                    throw err;
                });
        }

        vm.rd.handleExcel = function() {
            return handleExcelImport(vm.rd, '#rd_upload_excel', function(workbook) {
                return rd.extractExcelValues(workbook.sheet(0).usedRange().value());
            });
        }

        rd.createExcelAssayMap = function(file) {
            for( var i = vm.rd.excel_header_offset; i < file[0].length; i++) {
                if(file[0][i]) {
                    vm.rd.excel_assay_index_map[i] = vm.rd.assay_map[file[0][i]];
                }
                else {
                    break;
                }
            }
        }

        // Sample columns 0-9 have been identical in every template generation, so they stay
        // positional. Date and assay columns moved between template versions (10 cols before
        // Jun 2025, 12 until Nov 2025, 14 today), so they are located by header name — a stale
        // template must not silently shift "Yes" cells into date columns.
        var RD_DATE_HEADER_MAP = {
            'expiration date': 'expiration_date',
            'best by date': 'best_buy_date',
            'best buy date': 'best_buy_date',
            'production date': 'production_date',
            'date collected': 'date_collected',
            'date and time collected': 'date_collected'
        };
        var RD_DATE_COLUMN_LABELS = {
            expiration_date: 'Expiration Date',
            best_buy_date: 'Best By Date',
            production_date: 'Production Date',
            date_collected: 'Date Collected'
        };
        var RD_BASE_COLUMN_COUNT = 10;

        function normalizeRdHeader(headerText) {
            if (typeof headerText !== 'string') return '';
            return headerText.toLowerCase()
                .trim()
                .replace(/\(.*?\)/g, '')
                .replace(/\*$/, '')
                .trim();
        }

        rd.mapCannabisImportColumns = function(headerRow) {
            var colInfo = { dateCols: {}, assayCols: {}, unknownHeaders: [], missingDateColumns: [] };

            for (var i = RD_BASE_COLUMN_COUNT; i < headerRow.length; i++) {
                var header = headerRow[i];
                if (header === null || header === undefined || header === '') continue;
                var dateProp = RD_DATE_HEADER_MAP[normalizeRdHeader(header)];
                var assayEntry = vm.rd.assay_map[header] || vm.rd.assay_map[String(header).trim()];
                if (dateProp) {
                    colInfo.dateCols[dateProp] = i;
                }
                else if (assayEntry) {
                    colInfo.assayCols[i] = assayEntry;
                }
                else {
                    colInfo.unknownHeaders.push(header);
                }
            }

            for (var prop in RD_DATE_COLUMN_LABELS) {
                if (colInfo.dateCols[prop] === undefined) colInfo.missingDateColumns.push(RD_DATE_COLUMN_LABELS[prop]);
            }

            return colInfo;
        }

        // Import warnings render through AlertService, which trusts HTML — spreadsheet
        // content must be escaped before it is interpolated into a message.
        function escapeImportText(text) {
            return String(text)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;');
        }

        // Parses a spreadsheet date cell. Excel date cells arrive as serial numbers; they are
        // converted via UTC calendar components so the date does not shift a day in western
        // timezones. Unreadable values are reported back instead of being dropped.
        function parseImportDateCell(value) {
            if (value === null || value === undefined || value === '') return { empty: true };

            if (value instanceof Date) {
                return isNaN(value.getTime()) ? { ok: false, raw: String(value) } : { ok: true, date: value };
            }

            if (typeof value === 'number' && value <= 0) return { empty: true };

            if (typeof value === 'number' && isFinite(value)) {
                var utc = new Date(Math.round((value - 25569) * 86400 * 1000));
                return { ok: true, date: new Date(utc.getUTCFullYear(), utc.getUTCMonth(), utc.getUTCDate(), utc.getUTCHours(), utc.getUTCMinutes()) };
            }

            if (typeof value === 'string') {
                var text = value.trim();
                var match = text.match(/^(\d{1,2})\/(\d{1,2})\/(\d{2}|\d{4})(\s+(\d{1,2}):(\d{2})\s*(AM|PM)?)?$/i);
                if (match) {
                    var year = parseInt(match[3], 10);
                    if (match[3].length === 2) year += 2000;
                    var hours = match[5] ? parseInt(match[5], 10) : 0;
                    if (match[7] && match[7].toUpperCase() === 'PM' && hours < 12) hours += 12;
                    if (match[7] && match[7].toUpperCase() === 'AM' && hours === 12) hours = 0;
                    var minutes = match[6] ? parseInt(match[6], 10) : 0;
                    var parsed = new Date(year, parseInt(match[1], 10) - 1, parseInt(match[2], 10), hours, minutes);
                    return isNaN(parsed.getTime()) ? { ok: false, raw: text } : { ok: true, date: parsed };
                }
                match = text.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
                if (match) {
                    return { ok: true, date: new Date(parseInt(match[1], 10), parseInt(match[2], 10) - 1, parseInt(match[3], 10)) };
                }
                return { ok: false, raw: text };
            }

            return { ok: false, raw: String(value) };
        }

        rd.createNewSample = function() {
            return ({
                sample_expanded: vm.rd.mainCollapse,
                sample_checked: null,
                sample_delete: false,
                sample_name: null,
                sample_lot_batch_number: null,
                sample_category: null,
                sample_type: null,
                sample_types: null,
                sample_inhalable: null,
                sample_source_id: null,
                sample_tests: [],
                sample_other_analyses: {},
                sample_strain_name: null,
                sample_strain_type: null,
                sample_label_claims: null,
                sample_expected_potency: null,
                sample_has_tests: null,
                sample_panel_by_id: null,
                sample_panel_type: null,
                sample_current_panel_title: null,
                sample_expiration_date: null,
                sample_best_buy_date: null,
                sample_product_ingredients: null,
                sample_product_ingredients_tags: [],
                ingredient_input: '',
                expiration_date: null,
                best_buy_date: null,
                production_date: null,
                production_date_open: false,
                time_of_collection: null,
                time_of_collection_open: false,
                focus: {
                    name: false,
                    lot_batch_number: false,
                    autofill: false,
                    ingredients: false
                },
                options: {
                    name: [],
                    lot_batch_number: [],
                    autofill: [],
                    ingredients: []
                }
            });
        }

        rd.extractCannabisValues = function(row, index, colInfo, importWarnings) {
            vm.rd.sampleArray[index] = {}
            var test = null;
            var sample = rd.createNewSample();

            function readDateCol(prop) {
                var col = colInfo.dateCols[prop];
                if (col === undefined) return null;
                var parsed = parseImportDateCell(row[col]);
                if (parsed.empty) return null;
                if (!parsed.ok) {
                    importWarnings.push('Row ' + (index + 2) + ': could not read ' + RD_DATE_COLUMN_LABELS[prop] +
                        ' value "' + escapeImportText(parsed.raw) + '" — expected a date like MM/DD/YYYY');
                    return null;
                }
                return parsed.date;
            }

            if(!row.every(allEmpty)) {
                var sample_category = row[2] ? formatSampleCategory(row[2]) : null;
                sample.sample_name = !allEmpty(row[0]) ? stripInvalidQBChars(row[0]) : null;
                // Handle lot batch number - check if it's a date serial number from Excel
                if (row[1]) {
                    if (typeof row[1] === 'number') {
                        // Check if this is likely an Excel date serial number
                        // Excel dates for 2018-2035: 43101 (1/1/2018) to 49673 (12/31/2035)
                        if (row[1] >= 43101 && row[1] <= 49673) {
                            // Convert Excel date serial number back to date string
                            var baseDate = 25567; // Excel base date for 1900 system
                            var date = new Date(Math.round((row[1] - baseDate - 1) * 86400 * 1000));

                            // Format as MM/DD/YYYY
                            var month = (date.getMonth() + 1).toString().padStart(2, '0');
                            var day = date.getDate().toString().padStart(2, '0');
                            var year = date.getFullYear();
                            sample.sample_lot_batch_number = month + '/' + day + '/' + year;
                        } else {
                            // This is just a regular number, not a date
                            sample.sample_lot_batch_number = row[1].toString();
                        }
                    } else {
                        sample.sample_lot_batch_number = stripInvalidQBChars(row[1]);
                    }
                } else {
                    sample.sample_lot_batch_number = null;
                }
                sample.sample_category = sample_category ? sample_category : null;
                sample.sample_types = sample_category ? sample_category.types : null;
                sample.sample_type = sample_category ? checkSampleType(sample_category.types, row[3]) : null;
                sample.sample_inhalable = row[4] ? formatInhalableFromImport(row[4]) : null;
                sample.sample_source_id = row[5] ? row[5] : null;
                sample.sample_strain_name = row[6] ? row[6] : null;
                sample.sample_strain_type = row[7] ? formatStrainType(row[7]) : null;
                sample.sample_label_claims = row[8] ? row[8] : null;
                sample.sample_expected_potency = row[9] ? row[9] : null;
              
                // Dates are located by header name (template layouts changed over time)
                var expirationJsDate = readDateCol('expiration_date');
                var bestBuyJsDate = readDateCol('best_buy_date');
                var productionJsDate = readDateCol('production_date');
                var collectionJsDate = readDateCol('date_collected');

                // Store both the formatted string (for display) and the Date object (for datepicker)
                sample.sample_expiration_date = expirationJsDate ? formatDate(expirationJsDate) : null;
                sample.sample_best_buy_date = bestBuyJsDate ? formatDate(bestBuyJsDate) : null;
                sample.sample_production_date = productionJsDate ? formatDate(productionJsDate) : null;
                sample.sample_time_of_collection = collectionJsDate;

                // For the datepicker, we need to store the actual Date objects
                sample.expiration_date = expirationJsDate;
                sample.best_buy_date = bestBuyJsDate;   
                sample.production_date = productionJsDate;
                sample.time_of_collection = collectionJsDate;
                
                for (var j in colInfo.assayCols) {
                    if (row[j] == 'Yes') {
                        test = Object.assign({}, colInfo.assayCols[j]);

                        if (test[1] && vm.rd.assay_map[test[1].display_name]) {
                            test[1].checked = true;
                            sample.sample_tests.push(test[1])
                            sample.sample_has_tests = true;
                            vm.rd.sampleArray[index][vm.rd.assay_map[test[1].display_name][0]] = true;
                        }
                        test = null;
                    }
                }
                vm.rd.samples.push(sample)
            }
        }

        rd.extractFoodValues = function(row, index) {
            vm.rd.sampleArray[index] = {}
            var test = null;
            var sample = rd.createNewSample();

            if(!row.every(allEmpty)) {
                var sample_category = row[2] ? formatSampleCategory(row[2]) : null;
                sample.sample_name = !allEmpty(row[0]) ? stripInvalidQBChars(row[0]) : null;
                // Handle lot batch number - check if it's a date serial number from Excel
                if (row[1]) {
                    if (typeof row[1] === 'number') {
                        // Check if this is likely an Excel date serial number
                        // Excel dates for 2018-2035: 43101 (1/1/2018) to 49673 (12/31/2035)
                        if (row[1] >= 43101 && row[1] <= 49673) {
                            // Convert Excel date serial number back to date string
                            var baseDate = 25567; // Excel base date for 1900 system
                            var date = new Date(Math.round((row[1] - baseDate - 1) * 86400 * 1000));

                            // Format as MM/DD/YYYY
                            var month = (date.getMonth() + 1).toString().padStart(2, '0');
                            var day = date.getDate().toString().padStart(2, '0');
                            var year = date.getFullYear();
                            sample.sample_lot_batch_number = month + '/' + day + '/' + year;
                        } else {
                            // This is just a regular number, not a date
                            sample.sample_lot_batch_number = row[1].toString();
                        }
                    } else {
                        sample.sample_lot_batch_number = stripInvalidQBChars(row[1]);
                    }
                } else {
                    sample.sample_lot_batch_number = null;
                }
                sample.sample_category = sample_category ? sample_category : null;
                sample.sample_types = sample_category ? sample_category.types : null;
                sample.sample_type = sample_category ? checkSampleType(sample_category.types, row[3]) : null;
                sample.sample_inhalable = row[4] ? formatInhalableFromImport(row[4]) : null;
                for( var j = vm.rd.excel_header_offset; j < row.length; j++) {
                    if (row[j] == 'Yes') {
                        test = Object.assign({}, vm.rd.excel_assay_index_map[j]);
                        // check if that assay exists for the customer
                        if (test[1] && vm.rd.assay_map[test[1].display_name]) {
                            test[1].checked = true;
                            sample.sample_tests.push(test[1])
                            sample.sample_has_tests = true;
                            vm.rd.sampleArray[index][vm.rd.assay_map[test[1].display_name][0]] = true;
                        }
                        test = null;
                    }
                }
                vm.rd.samples.push(sample)
            }
        }

       rd.extractExcelValues = function(file) {
            if (!file || !file.length || !file[0]) {
                AlertService.error('Upload failed. The Excel file is empty.');
                return false;
            }

            var sampleCountBefore = vm.rd.samples.length;
            if (vm.rd.customer_type.includes('Cannabis') || vm.rd.customer_type.includes('Hemp')) {
                var colInfo = rd.mapCannabisImportColumns(file[0]);
                var importWarnings = [];

                vm.rd.excel_assay_index_map = colInfo.assayCols;

                for( var i = 1; i < file.length; i++) {
                    rd.extractCannabisValues(file[i], i-1, colInfo, importWarnings);
                }

                if (colInfo.unknownHeaders.length) {
                    importWarnings.unshift('Ignored unrecognized column(s): ' + colInfo.unknownHeaders.map(escapeImportText).join(', '));
                }
                if (colInfo.missingDateColumns.length) {
                    importWarnings.unshift('This spreadsheet is missing the ' + colInfo.missingDateColumns.join(', ') +
                        ' column(s), so those values were not imported. Please download the latest template.');
                }
                if (importWarnings.length) {
                    AlertService.warning(importWarnings.slice(0, 6).join('\n'));
                }
            }
            else {
                rd.createExcelAssayMap(file)
                for( var i = 1; i < file.length; i++) {
                    rd.extractFoodValues(file[i], i-1);
                }
            }

            vm.rd.checkPageOne();
            rd.resetDeleteCheckboxes();
            if (vm.rd.samples.length === sampleCountBefore) {
                AlertService.error('Upload failed. The Excel file does not contain any sample rows.');
                return false;
            }
            return true;
        }


        function allEmpty(value) {
            return value === '' || value === null || value === undefined;
        }

        vm.rd.deleteChecked = function() {
            for(var i = vm.rd.samples.length-1; i >= 0; i--) {
                if (vm.rd.samples[i].sample_delete) {
                    vm.rd.samples.splice(i, 1);
                }
            }
            rd.resetDeleteCheckboxes();
            vm.rd.checkPageOne();
        }

        vm.rd.clickCheckAllDelete = function() {
            vm.rd.samples.forEach( function(sample) {
                sample.sample_delete = $(':checkbox.delete-checkbox-header')[0].checked;
            });
        }

        vm.rd.clickDelete = function(index) {
            vm.rd.samples[index].sample_delete = !vm.rd.samples[index].sample_delete;
            $(':checkbox.delete-checkbox-header')[0].checked = false;
        }

        vm.rd.clickCheckAllTest = function(col) {
            var testToAdd = vm.rd.assay_map_by_index[col];
            var found = false;
            var selector = ':checkbox.assay-col-header-' + col;
            var test = {};

            vm.rd.samples.forEach( function(sample, sample_index) {
                sample.sample_tests.forEach( function(test, test_index) {
                    if (test.id == testToAdd.id) {
                        found = true;
                        sample.sample_tests[test_index].checked = $(selector)[0].checked;
                        vm.rd.sampleArray[sample_index][col] = $(selector)[0].checked;
                        
                        // Check if this sample has a panel selected and update panel status if needed
                        if (sample.sample_panel_selected && !$(selector)[0].checked) {
                            vm.rd.checkPanelTestsSelection(sample_index);
                        }
                    }
                });
                if (!found) {
                    if (!vm.rd.sampleArray[sample_index]) {
                        vm.rd.sampleArray[sample_index] = {};
                        vm.rd.sampleArray[sample_index][col] = $(selector)[0].checked;
                    }
                    test = Object.assign({}, testToAdd)
                    vm.rd.sampleArray[sample_index][col] = $(selector)[0].checked;
                    test.checked = $(selector)[0].checked;
                    
                    // Check if this sample has a panel selected and update panel status if needed
                    if (sample.sample_panel_selected && !$(selector)[0].checked) {
                        vm.rd.checkPanelTestsSelection(sample_index);
                    }
                    sample.sample_tests.push(test);
                }
                found = false;
               rd.checkSampleContainsTrueTests(sample_index);
            });
            vm.rd.checkPageTwo();
        }

        // add/remove test from sample when checkbox clicked
        vm.rd.checkClick = function (sample, testToAdd, row, col) {
            var found = false;
            var test = null;
            $(':checkbox.assay-col-header-' + col)[0].checked = false;
            // check if test exists, if yes then checked = !checked
            for(var i = 0; i < sample.sample_tests.length; i++) {
                if (sample.sample_tests[i].id == testToAdd.id) {
                    found = true;
                    sample.sample_tests[i].checked = vm.rd.sampleArray[row][col];
                    break;
                }
            }
            // if no, add that test
            if (!found) {
                test = Object.assign({}, testToAdd);
                test.checked = true;
                
                // Ensure manually added tests have panel_id and panel_name set to null
                test.panel_id = null;
                test.panel_name = null;
                
                // Handle source_uid vs source_id mapping as mentioned in memories
                if (test.source_id && !test.source_uid) {
                    test.source_uid = test.source_id;
                }
                
                sample.sample_tests.push(test);
            }
            
            // Check if this sample has a panel selected and update panel status if needed
            if (sample.sample_panel_selected) {
                vm.rd.checkPanelTestsSelection(row);
            }

            rd.checkSampleContainsTrueTests(row);
            vm.rd.checkPageTwo();
            
            // Organize tests for display
            vm.rd.organizeTests(sample);
        }

        vm.rd.collapseAll = function() {
            vm.rd.mainCollapse = !vm.rd.mainCollapse;
            if (vm.rd.samples.length != 0) {
                vm.rd.samples.forEach( function(sample) {
                    sample.sample_expanded = vm.rd.mainCollapse;
                });
            }
        }

        rd.addAssay = function(test) {
            if (!shouldShowAssayForLanguage(test)) {
                return;
            }
            if(test.id != 13) {
                // Prevent duplicates in showTestsArray
                if (vm.rd.showTestsArray.indexOf(test.display_name) === -1) {
                    vm.rd.showTests[test.display_name] = true;
                    vm.rd.showTestsArray.push(test.display_name);
                    
                    // Set the index for the new test
                    test.index = vm.rd.tests.length;
                    vm.rd.tests.push(test);
                    
                    // CRITICAL: Update assay_map so setPanel can find this assay
                    vm.rd.assay_map[test.display_name] = [test.index, test];
                    vm.rd.assay_map_by_index[test.index] = test;
                }
            }

        }

        rd.createAssayMaps = function() {
            vm.rd.tests.forEach( function(test, index) {
                test.index = index;
                vm.rd.assay_map[test.display_name] = [index, test]
                if(test.reporting_title) {
                    vm.rd.assay_map[test.reporting_title] = [index, test];
                }

                vm.rd.assay_map_by_index[index] = test;
            });
        }

        rd.getAssaysAddedByAnrescoBillingTab = function() {
            vm.customerData.assay_customer.forEach( function(assay_customer) {

                vm.rd.all_tests.forEach( function(assay) {
                    if (assay.id == assay_customer.assay_id) {
                        // Check if this assay is already in vm.rd.tests (added via portal_client_type_list or portal_client_type)
                        var existingTestIndex = findWithAttr(vm.rd.tests, 'id', assay.id);
                        
                        if (existingTestIndex != -1) {
                            // Assay already exists in tests (added via precedence 1 or 2)
                            // Update its assay_customer data to include count for frequent tests
                            vm.rd.tests[existingTestIndex].assay_customer = assay_customer;
                        } else if (assay_customer.active) {
                            // Only add new assays if they're active
                            rd.addAssay(assay);
                        }
                    }
                });
            });
        }

         rd.getAssayData = function() {
            // Use GraphQL for lightweight payload (~150KB vs 1.6MB from REST)
            GraphQLService.query(ASSAYS_LIST_QUERY, { enabled: true }).then(function(result) {
                var data = result.assaysList;
                if (data) {
                    var index = 0;
                    var test = null;
                    var add_assay = true;

                    var assayCustomerMap = {};
                    if (vm.customerData && vm.customerData.assay_customer) {
                        vm.customerData.assay_customer.forEach(function(ac) {
                            assayCustomerMap[ac.assay_id] = ac;
                        });
                    }

                    data.forEach( function(assay) {
                        // Language eligibility must be checked before business-type or legacy matching.
                        if (!shouldShowAssayForLanguage(assay)) {
                            return;
                        }
                        if (add_assay) {
                            // O(1) lookup instead of O(n) loop
                            assay.assay_customer = assayCustomerMap[assay.id] || null;

                            test = {
                                info_modal: parseAssayInfoModalData(assay),
                                portal_identifier: assay.portalIdentifier ? assay.portalIdentifier : null,
                                portal_client_type: assay.portal_client_type ? assay.portal_client_type : null,
                                portal_client_type_list: assay.portal_client_type_list ? assay.portal_client_type_list : null,
                                display_name: assay.title,
                                reporting_title: assay.reporting_title ? assay.reporting_title : assay.title,
                                base_price: assay.basePrice,
                                assay_customer: assay.assay_customer ? assay.assay_customer : null,
                                analysis_description: assay.analysis_description ? assay.analysis_description : null,
                                id: assay.id,
                                index: index
                            }

                            // Initialize a flag to track if the assay has been added
                            let assayAdded = false;

                            // Skip logging for assays without portal_client_type - too verbose for production
                            if(!assay.portal_client_type_list && !assay.portal_client_type) {
                                // These are legacy assays without client type configuration
                            }

                            // Check portal_client_type_list first (new primary method)
                            if(assay.portal_client_type_list && !assayAdded) {
                                // Parse the portal_client_type_list if it's a string
                                let clientTypeList = assay.portal_client_type_list;
                                if (typeof clientTypeList === 'string') {
                                    try {
                                        clientTypeList = JSON.parse(clientTypeList);
                                    } catch (e) {
                                        console.error('Error parsing portal_client_type_list for assay', assay.id, e);
                                        clientTypeList = [];
                                    }
                                }
                                
                                if(Array.isArray(clientTypeList)) {
                                    // Check for 'General' type in the list
                                    if(clientTypeList.includes('General')) {
                                        rd.addAssay(test);
                                        index++;
                                        assayAdded = true;
                                    } else {
                                        // Convert customer type to lowercase for case-insensitive comparison
                                        var customerTypeLower = vm.rd.customer_type.toLowerCase();
                                        
                                        // Check if any client type in the list matches the customer type
                                        for(let clientType of clientTypeList) {
                                            var lowerClientType = clientType.toLowerCase();
                                            
                                            // Check if customer type matches any of the conditions
                                            if(customerTypeLower.includes('cannabis') && lowerClientType.includes('cannabis') ||
                                               customerTypeLower.includes('hemp') && lowerClientType.includes('hemp') ||
                                               customerTypeLower.includes('food') && lowerClientType.includes('food') ||
                                               customerTypeLower.includes('kratom') && lowerClientType.includes('kratom') ||
                                               lowerClientType.includes('non-cannabis') ||
                                               customerTypeLower === lowerClientType) {
                                                
                                                // Special handling for cannabis cannabinoid assays
                                                if(customerTypeLower.includes('cannabis') && lowerClientType.includes('cannabis') && rd.isBasicPotencyAssay(test)) {
                                                    vm.rd.cannabinoid_assays[test.portal_identifier] = jQuery.extend({}, test);
                                                    if(!vm.rd.cannabinoid_assay_added) {
                                                        rd.addAssay(test);
                                                        index++;
                                                        vm.rd.cannabinoid_assay_added = true;
                                                    }
                                                } else {
                                                    rd.addAssay(test);
                                                    index++;
                                                }
                                                assayAdded = true;
                                                break;
                                            }
                                        }
                                    }

                                    // Special handling for Japanese language and Japanese assays
                                        if ($localStorage.language === 'Japanese') {
                                        // If customer language is Japanese, only show Japanese assays
                                        if (clientTypeList.includes('Japanese')) {
                                            rd.addAssay(test);
                                            index++;
                                            assayAdded = true;
                                        }
                                    } else {
                                        // For non-Japanese customers, don't show Japanese-only assays
                                        if (clientTypeList.includes('Japanese') && !clientTypeList.includes('General') && !assayAdded) {
                                            assayAdded = false; // Skip this assay for non-Japanese customers
                                        }
}
                                }
                            }

                            // Fall back to portal_client_type if not added yet (legacy method)
                            if(assay.portal_client_type && !assayAdded) {
                                if(assay.portal_client_type == 'General') {
                                    rd.addAssay(test);
                                    index++
                                }
                                else if ((vm.rd.customer_type.toLowerCase().includes('cannabis') && assay.portal_client_type.toLowerCase().includes('cannabis'))) {
                                    if(rd.isBasicPotencyAssay(test)) {
                                        vm.rd.cannabinoid_assays[test.portal_identifier] = jQuery.extend({}, test);
                                        if(!vm.rd.cannabinoid_assay_added) {
                                            rd.addAssay(test);
                                            index++
                                            vm.rd.cannabinoid_assay_added = true;
                                        }
                                    }
                                    else {
                                        rd.addAssay(test);
                                        index++;
                                    }
                                }
                                else if ((vm.rd.customer_type.toLowerCase().includes('hemp') && assay.portal_client_type.toLowerCase().includes('hemp'))) {
                                    rd.addAssay(test);
                                    index++;
                                }
                                else if ((vm.rd.customer_type.toLowerCase().includes('food') && assay.portal_client_type.toLowerCase().includes('food'))) {
                                    rd.addAssay(test);
                                    index++;
                                }
                                else if ((vm.rd.customer_type.toLowerCase().includes('kratom') && assay.portal_client_type.toLowerCase().includes('kratom'))) {
                                    rd.addAssay(test);
                                    index++;
                                }
                            }
                            vm.rd.all_assay_map_by_id[assay.id] = test;
                            vm.rd.all_tests.push(test)
                        }
                        add_assay = true;
                    });
                }
                // getExistingAssays()
                rd.getAssaysAddedByAnrescoBillingTab();

                
                // sorts tests arrray by how many times each test has been ordered
                vm.rd.tests.sort( function(test_a ,test_b) {
                    // Get counts, defaulting to 0 if not present
                    var count_a = (test_a.assay_customer && test_a.assay_customer.count) ? test_a.assay_customer.count : 0;
                    var count_b = (test_b.assay_customer && test_b.assay_customer.count) ? test_b.assay_customer.count : 0;
                    
                    // Sort by count descending (highest first)
                    return count_b - count_a;
                });
                

                // Calculate number of frequent assays (up to 5 tests with counts > 0)
                vm.rd.number_of_freq_assays = 0;
                for (var i = 0; i < Math.min(5, vm.rd.tests.length); i++) {
                    if (vm.rd.tests[i]) {
                        // Count tests that have a positive count
                        if (vm.rd.tests[i].assay_customer && vm.rd.tests[i].assay_customer.count > 0) {
                            vm.rd.number_of_freq_assays++;
                        }
                    }
                }

                if (vm.rd.number_of_freq_assays != vm.rd.tests.length) {
                    var tests_sorted_by_name = vm.rd.tests.splice(vm.rd.number_of_freq_assays, vm.rd.tests.length).sort( function(name_a, name_b) {
                        var comparison = 0;
                        name_a = name_a.display_name ? name_a.display_name : name_a.reporting_title;
                        name_b = name_b.display_name ? name_b.display_name : name_b.reporting_title;

                        if(name_a > name_b) {
                            comparison = 1
                        }
                        else if(name_b > name_a) {
                            comparison = -1
                        }

                        return comparison
                    });
                    vm.rd.tests = vm.rd.tests.concat(tests_sorted_by_name);
                }

                rd.createAssayMaps();

                // Load QBench panels after assay data is ready
                rd.getQbenchPanels();
                // Load customer-specific panels after assay data is ready
                rd.getCustomerPanels();
            }).catch(function(error) {
                console.error('Failed to load assays via GraphQL:', error);
                AlertService.error('Failed to load available tests. Please refresh the page.');
            });

            // rd.setInfoBoxCoordinates();
        }

         rd.checkSampleContainsTrueTests = function(index) {
            if (Object.values(vm.rd.sampleArray[index]).indexOf(true) == -1) {
                vm.rd.samples[index].sample_has_tests = false;
                vm.rd.samples[index].sample_panel_selected = false;
                vm.rd.samples[index].sample_panel_type = false;
                vm.rd.samples[index].sample_panel_by_id = false;
                vm.rd.samples[index].sample_current_panel_title = false;

                return;
            }
            vm.rd.samples[index].sample_has_tests = true;
            return;
        }

        // removes tests with checked: false
        // necessary for table on page 4
        rd.cleanUncheckedTests = function() {
            if (vm.rd.samples.length > 0) {
                vm.rd.samples.forEach (function(sample) {
                    if (sample.sample_tests.length > 0) {
                        for(var i = sample.sample_tests.length - 1; i >= 0; i--){
                            if (!sample.sample_tests[i].checked){
                                sample.sample_tests.splice(i, 1);
                            }
                        }
                    }
                    angular.forEach(sample.sample_other_analyses, function(value, key) {
                        if (!value) {
                            delete sample.sample_other_analyses[key];
                        }
                    });
                });
            }
        }

        vm.rd.checkPageOne = function() {
            if (vm.rd.samples.length < 1) {
                vm.rd.pageOneValid = false;
                return;
            }

            for(var i = 0; i < vm.rd.samples.length; i++) {
                if (!vm.rd.samples[i].sample_name ||
                    !vm.rd.samples[i].sample_category ||
                    !vm.rd.samples[i].sample_type ||
                    !vm.rd.samples[i].sample_inhalable ||
                    !vm.rd.samples[i].sample_expected_potency ) {
                        vm.rd.pageOneValid = false;
                        return;
                }
            }

            vm.rd.pageOneValid = true;
            return;
        }

        vm.rd.checkPageTwo = function() {
            var other_analysis_is_empty = null;
            var sample_array_is_empty = null;

            for(var i = 0; i < vm.rd.samples.length; i++) {
                other_analysis_is_empty = Object.keys(vm.rd.samples[i].sample_other_analyses).length == 0;
                sample_array_is_empty = vm.rd.sampleArray[i] ? Object.keys(vm.rd.sampleArray[i]).length == 0 : true;

                if (sample_array_is_empty && other_analysis_is_empty){
                    vm.rd.pageTwoValid = false;
                    return;
                }
                else {
                    if (sample_array_is_empty) {
                        if (Object.values(vm.rd.samples[i].sample_other_analyses).indexOf(true) == -1) {
                            vm.rd.pageTwoValid = false;
                            return
                        }
                    }
                    else if (other_analysis_is_empty) {
                        if (Object.values(vm.rd.sampleArray[i]).indexOf(true) == -1) {
                            vm.rd.pageTwoValid = false;
                            return;
                        }
                    }
                    else {
                        if ((Object.values(vm.rd.samples[i].sample_other_analyses).indexOf(true) == -1) && (Object.values(vm.rd.sampleArray[i]).indexOf(true) == -1)) {
                            vm.rd.pageTwoValid = false;
                            return;
                        }
                    }
                }
            }
            vm.rd.pageTwoValid = true;
            return;
        }

        vm.rd.checkPageThree = function() {
            if (
                !vm.rd.pickup_arrival_date ||
                !vm.rd.deliveryPreference ||
                !($('#rdEmailRecepients').val().length > 0) ||
                (vm.rd.deliveryPreference === 'Anresco Pick-Up' && !vm.fullLocationPickup) ||
                (vm.fullLocationPickup && !vm.contact.phone) ||
                vm.pickupOutOfStateError
            ) {
                vm.rd.pageThreeValid = false;
                return;
            }
            vm.rd.pageThreeValid = true;
            return;
        }

        function setHeightOfFirstTable() {
                var rightTableTrHeight = $('.rdTestsTableRight.varHeight thead').height();
                $('.rdTestsTableLeft thead').css('height', rightTableTrHeight);
        }

        vm.generateTurnaroundTimes = function(orderVersion) {
            var durations = [];

            orderVersion.samples.forEach( function(sample) {
                sample.sample_tests.forEach( function(test) {
                    if(test.info_modal && test.info_modal.duration) durations.push(test.info_modal.duration);
                });
            });

            // Replaced this line:
            // if(!durations.length) return;
    
            // With this code:
            if(!durations.length) {
                // For requested assays, set specific options
                var options = [];
                options.push("10 days (standard)");
                
                // Specific rush options: 7, 5, 3, 2, and 1 day
                var rushOptions = [7, 5, 3, 2, 1];
                rushOptions.forEach(function(duration) {
                    options.push(`${duration} days (rush)`);
                });
                
                // Set the options and return early
                orderVersion.turnaroundTimeOptions = options;
                orderVersion.turnaroundTime = options[0];
                return;
            }

            var longest_duration = Math.max(...durations);
            var shortest_duration = Math.min(...durations);
            var options = [];


            if(longest_duration == shortest_duration) {
                options.push(`${longest_duration} days (standard)`);
            }
            else {
                options.push(`${shortest_duration}-${longest_duration} days (standard)`);
            }

            for(var duration = shortest_duration-1; duration > 0; duration--) {
                options.push(`${duration} days (rush)`);
            }

            orderVersion.turnaroundTimeOptions = options;
            orderVersion.turnaroundTime = options[0];

        }

        vm.rd.incrementPage = function() {
            vm.rd.step = vm.rd.step + 1;
            rd.cleanUncheckedTests()
            if (vm.rd.step == 2) {
                vm.rd.checkPageTwo();
                setTimeout( function() {
                    // rd.setInfoBoxCoordinates();
                    setHeightOfFirstTable();
                }, 100);
            }
            else if (vm.rd.step == 3) {
                vm.generateTurnaroundTimes(vm.rd);
                vm.rd.checkPageThree();
                rd.processAllSampleTests();
                
                // Figure out which tests will be submitted for step 4 display
                vm.rd.samples.forEach(function(sample) {
                    var rawTests = formatSampleTests(sample, 'rd');
                    
                    // Reorganize: individual tests first, then grouped by panel
                    var individualTests = [];
                    var panelTests = {};
                    
                    rawTests.forEach(function(test) {
                        if (test.panel && test.panel.id) {
                            // Group by panel ID
                            if (!panelTests[test.panel.id]) {
                                panelTests[test.panel.id] = {
                                    panelName: vm.getPanelDisplayNameById(test.panel.id, 'rd'),
                                    tests: []
                                };
                            }
                            panelTests[test.panel.id].tests.push(test);
                        } else {
                            // Individual test
                            individualTests.push(test);
                        }
                    });
                    
                    // Build final organized array
                    sample.actualFormattedTests = individualTests;
                    
                    // Add each panel group
                    Object.keys(panelTests).forEach(function(panelId) {
                        var panel = panelTests[panelId];
                        // Add a panel header marker
                        sample.actualFormattedTests.push({
                            isPanelHeader: true,
                            panelName: panel.panelName
                        });
                        // Add all tests for this panel
                        panel.tests.forEach(function(test) {
                            sample.actualFormattedTests.push(test);
                        });
                    });
                });
            }
            else if (vm.rd.step == 4) {
                vm.rd.emailsArray = vm.rd.emails.split(',');
                // Organize tests for each sample to populate nonPanelTests and panelTests arrays
                vm.rd.samples.forEach(function(sample) {
                    vm.rd.organizeTests(sample);
                });
            }
        }

        vm.rd.decrementPage = function() {
            vm.rd.step = vm.rd.step - 1;
            rd.cleanUncheckedTests()
            if (vm.rd.step == 2) {
                vm.rd.checkPageTwo();
                setTimeout( function() {
                    // rd.setInfoBoxCoordinates();
                }, 100);
            }
            else if (vm.rd.step == 3) {
                vm.rd.checkPageThree();
                rd.processAllSampleTests();
            }
        }

        vm.rd.removeSample = function(index) {
            vm.rd.samples.splice(index, 1);
            vm.rd.sampleArray.splice(index, 1);
            rd.resetDeleteCheckboxes();
            vm.rd.checkPageOne();
        }

        vm.rd.cloneSample = function(index) {
            // Create a deep copy of the sample
            var clonedSample = angular.copy(vm.rd.samples[index]);
            
            // IMPORTANT: Reset the fields we want to explicitly set
            clonedSample.sample_category = null;
            clonedSample.sample_type = null;
            clonedSample.sample_types = null;
            clonedSample.sample_inhalable = null;
            
            // Now explicitly set them with the correct references
            
            // 1. Handle sample_category
            if (vm.rd.samples[index].sample_category && vm.rd.categories) {
                for (var i = 0; i < vm.rd.categories.length; i++) {
                    if (vm.rd.categories[i].id === vm.rd.samples[index].sample_category.id) {
                        clonedSample.sample_category = vm.rd.categories[i];
                        break;
                    }
                }
            }
            
            // 2. Handle sample_types and sample_type
            if (clonedSample.sample_category && clonedSample.sample_category.types) {
                clonedSample.sample_types = clonedSample.sample_category.types;
                
                if (vm.rd.samples[index].sample_type) {
                    for (var j = 0; j < clonedSample.sample_types.length; j++) {
                        if (clonedSample.sample_types[j].id === vm.rd.samples[index].sample_type.id) {
                            clonedSample.sample_type = clonedSample.sample_types[j];
                            break;
                        }
                    }
                }
            }
            

               // 3. Handle sample_inhalable
            if (vm.rd.samples[index].sample_inhalable) {
                // If it's a string value (which it is in your case - "INHALABLE")
                if (typeof vm.rd.samples[index].sample_inhalable === 'string') {
                    // Use the global inhalable_edible_array instead of vm.rd.inhalable_edible_array
                    if (vm.inhalable_edible_array && vm.inhalable_edible_array.length > 0) {
                        var inhalableIndex = findWithAttr(vm.inhalable_edible_array, 'value', vm.rd.samples[index].sample_inhalable);
                        if (inhalableIndex !== -1) {
                            clonedSample.sample_inhalable = vm.inhalable_edible_array[inhalableIndex];
                        } else {
                            // If not found in the array, just use the string directly
                            clonedSample.sample_inhalable = vm.rd.samples[index].sample_inhalable;
                        }
                    } else {
                        // If no array exists, just use the string directly
                        clonedSample.sample_inhalable = vm.rd.samples[index].sample_inhalable;
                    }
                } 
                        // If it's an object with a value property
                        else if (vm.rd.samples[index].sample_inhalable.value) {
                            if (vm.inhalable_edible_array && vm.inhalable_edible_array.length > 0) {
                                var inhalableIndex = findWithAttr(vm.inhalable_edible_array, 'value', vm.rd.samples[index].sample_inhalable.value);
                                if (inhalableIndex !== -1) {
                                    clonedSample.sample_inhalable = vm.inhalable_edible_array[inhalableIndex];
                                } else {
                                    clonedSample.sample_inhalable = vm.rd.samples[index].sample_inhalable;
                                }
                            } else {
                                clonedSample.sample_inhalable = vm.rd.samples[index].sample_inhalable;
                            }
                        }
                        // Otherwise just copy it directly
                        else {
                            clonedSample.sample_inhalable = vm.rd.samples[index].sample_inhalable;
                        }
                    }
            
            // Add the cloned sample to the array
            vm.rd.samples.splice(index + 1, 0, clonedSample);
            if (vm.rd.sampleArray && vm.rd.sampleArray.length > index) {
                var clonedSampleArray = angular.copy(vm.rd.sampleArray[index]);
                vm.rd.sampleArray.splice(index + 1, 0, clonedSampleArray);
            }
            rd.resetDeleteCheckboxes();
            vm.rd.checkPageOne();
        };

      
        function formatDeliveryPreference(delivery_preference) {
            $rootScope.deliveryPreference = delivery_preference;

            if (delivery_preference == 'Anresco Pick-Up') {
                return 'ANRESCO_PICK_UP';
            }
            else if (delivery_preference == 'Client Drop-Off') {
                return 'CLIENT_DROP_OFF';
            }
            else if (delivery_preference == 'Mail') {
                return 'MAIL';
            }
            else {
                return null;
            }
        }

        function formatNameDict(name) {
            return name ? {name: name} : null;
        }

        function formatDate(date) {
            if (!date) return null;
            
            // If it's already a string in MM/DD/YYYY format, return as is
            if (typeof date === 'string' && /^\d{1,2}\/\d{1,2}\/\d{4}$/.test(date)) {
                return date;
            }
            
            // Convert to Date object if it isn't already
            var dateObj = date instanceof Date ? date : new Date(date);
            
            // Check for invalid date
            if (isNaN(dateObj.getTime())) {
                return null;
            }
            
            // Format as MM/DD/YYYY with manual padding
            var month = (dateObj.getMonth() + 1).toString();
            month = month.length === 1 ? '0' + month : month;
            
            var day = dateObj.getDate().toString();
            day = day.length === 1 ? '0' + day : day;
            
            var year = dateObj.getFullYear();
            
            return month + '/' + day + '/' + year;
        }

        // Helper function to get test display name by ID
        vm.getTestDisplayNameById = function(testId, orderType) {
            var assayMap = (orderType === 'rd') ? vm.rd.all_assay_map_by_id : vm.food.all_assay_map_by_id;
            if (assayMap && assayMap[testId]) {
                return assayMap[testId].display_name || assayMap[testId].reporting_title;
            }
            // Fallback: check the other type's map
            var otherMap = (orderType === 'rd') ? vm.food.all_assay_map_by_id : vm.rd.all_assay_map_by_id;
            if (otherMap && otherMap[testId]) {
                return otherMap[testId].display_name || otherMap[testId].reporting_title;
            }
            return 'Test #' + testId;
        };
        
        // Helper function to get panel display name by ID
        vm.getPanelDisplayNameById = function(panelId, orderType) {
            var panelMap = (orderType === 'rd') ? vm.rd.panel_by_id_map : vm.food.panel_by_id_map;
            if (panelMap && panelMap[panelId]) {
                return panelMap[panelId][0]; // Panel name is at index 0
            }
            // Fallback: check the other type's map
            var otherMap = (orderType === 'rd') ? vm.food.panel_by_id_map : vm.rd.panel_by_id_map;
            if (otherMap && otherMap[panelId]) {
                return otherMap[panelId][0];
            }
            return 'Panel #' + panelId;
        };

        function formatSampleTests(sample, orderType) {
            var sampleTests = [];
            if (!sample) return sampleTests;
            
            var panelId = sample.sample_panel_selected;
            
            if (panelId) {
                // Use the appropriate maps based on order type
                var panelMap = (orderType === 'rd') ? vm.rd.panel_by_id_map : vm.food.panel_by_id_map;
                var assayMap = (orderType === 'rd') ? vm.rd.assay_map : vm.food.assay_map;
                
                if (panelMap && panelMap[panelId]) {
                    var panelAssays = panelMap[panelId][1];
                    var sendAsPanel = true;
                    
                    // CRITICAL VALIDATION: Check if ALL panel tests are still selected
                    // If ANY panel test is unchecked, the panel must "break" and all tests
                    // should be sent as individual tests (per billing requirements)
                    if (panelAssays && assayMap) {
                        for (var i = 0; i < panelAssays.length; i++) {
                            var assay = panelAssays[i];
                            if (assayMap[assay.display_name]) {
                                var assayId = assayMap[assay.display_name][1].id;
                                var isSelected = false;
                                
                                // Check if this panel test is selected in sample_tests
                                for (var j = 0; j < sample.sample_tests.length; j++) {
                                    if (sample.sample_tests[j].id === assayId && 
                                        sample.sample_tests[j].checked) {
                                        isSelected = true;
                                        break;
                                    }
                                }
                                
                                // If any panel test is not selected, break the panel
                                if (!isSelected) {
                                    sendAsPanel = false;
                                    break;
                                }
                            }
                        }
                    }
                    
                    if (sendAsPanel) {
                        // All panel tests are selected - send with panel association
                        // Add each panel assay WITH panel_id
                        panelAssays.forEach(function(assay) {
                            if (assayMap[assay.display_name]) {
                                var assayId = assayMap[assay.display_name][1].id;
                                var testPayload = {
                                    assay: {id: assayId}
                                };

                                // Only add the panel object if it's NOT a custom panel
                                if (sample.sample_panel_type !== 'custom_panel') {
                                    testPayload.panel = {id: panelId};
                                    testPayload.panel_type = sample.sample_panel_type || 'panel';
                                }
                                sampleTests.push(testPayload);
                            }
                        });
                        
                        // Collect panel assay IDs to identify non-panel tests
                        var panelAssayIds = [];
                        panelAssays.forEach(function(assay) {
                            if (assayMap[assay.display_name]) {
                                panelAssayIds.push(assayMap[assay.display_name][1].id);
                            }
                        });
                        
                        // Add any additional tests that are NOT part of the panel (without panel_id)
                        for (var i = 0; i < sample.sample_tests.length; i++) {
                            var test = sample.sample_tests[i];
                            if (test.checked && panelAssayIds.indexOf(test.id) === -1) {
                                sampleTests.push({
                                    assay: {id: test.id}
                                });
                            }
                        }
                    } else {
                        // Panel is "broken" - at least one panel test was unchecked
                        // Send ALL tests as individual (no panel association)
                        for (var i = 0; i < sample.sample_tests.length; i++) {
                            var test = sample.sample_tests[i];
                            if (test.checked) {
                                sampleTests.push({
                                    assay: {id: test.id}
                                });
                            }
                        }
                    }
                }
            } else {
                // No panel selected - send all as individual tests
                sample.sample_tests.forEach(function(test) {
                    if (test.checked) {
                        sampleTests.push({
                            assay: {id: test.id}
                        });
                    }
                });
            }
            if (sample.sample_other_analyses) {
                if (Object.values(sample.sample_other_analyses).indexOf(true) != -1) {
                    sampleTests.push({
                        // consulting assay
                        assay: {id: 13}
                    });
                }
            }

            return sampleTests;
        }

        
        function formatInhalableFromImport(value) {
            return (value.toUpperCase().includes('NON') || value.toUpperCase().includes('-')) ? vm.rd.inhalable[1] : vm.rd.inhalable[0];
        }


        function formatSampleCategory(cat) {
            if (cat.length > 1){
                for(var i = 0; i < vm.rd.categories.length; i++) {
                    if ((cat.charAt(0).toUpperCase() + cat.substring(1)) == vm.rd.categories[i.toString()].name) {
                        return vm.rd.categories[i.toString()]
                    }
                }
            }
            return  null;
        }

        function checkSampleType(types, type) {
            if (type) {
                type = type.charAt(0).toUpperCase() + type.toLowerCase().substring(1);
                for(var i = 0; i < types.length; i++) {
                    if (type.toLowerCase() == types[i.toString()].name.toLowerCase()) {
                        return types[i.toString()];
                    }
                }
            }
            return null;
        }

        function formatStrainType(name) {
            if (name) {
                name.toUpperCase() == "CBD" ? name = "CBD" : name = name.charAt(0).toUpperCase() + name.toLowerCase().substring(1);
                for(var i = 0; i < vm.rd.strainTypes.length; i++) {
                    if (name == vm.rd.strainTypes[i].name){
                        return vm.rd.strainTypes[i];
                    }
                }
            }
            return null;
        }

        rd.serializeSamples = function(samples) {
            var serializedSamples = [];
            if (samples) {
                samples.forEach( function(sample, sampleIndex){
                    var sampleTestsResult = null;
                    
                    try {
                        sampleTestsResult = formatSampleTests(sample, 'rd');
                    } catch (e) {
                        sampleTestsResult = [];
                    }
                    
                    serializedSamples.push({
                        id: null,
                        name: sample.sample_name,
                        lotBatchNumber: sample.sample_lot_batch_number,
                        productCategory: typeof(sample.sample_category) == 'string' ? formatNameDict(sample.sample_category) : sample.sample_category,
                        productType: typeof(sample.sample_type) == 'string' ? formatNameDict(sample.sample_type) : sample.sample_type,
                        strainName: typeof(sample.sample_strain_name) != 'object' ? formatNameDict(sample.sample_strain_name) : sample.sample_strain_name,
                        strainType: typeof(sample.sample_strain_type) == 'string' ? formatNameDict(sample.sample_strain_type) : sample.sample_strain_type,
                        otherAnalysis: sample.sample_other_analyses ? formatOtherAnalyses(sample.sample_other_analyses) : null,
                        reportedUnits: null,
                        productBatchSize: null,
                        harvestBatchSize: null,
                        batchType: null,
                        inhalableEdible: typeof(sample.sample_inhalable) == 'object' ? sample.sample_inhalable.value : sample.sample_inhalable,
                        sCode: sample.sample_metrc_id ? sample.sample_metrc_id : null,
                        sourceId: sample.sample_source_id ? sample.sample_source_id : null,
                        labelClaims: sample.sample_label_claims,
                        expectedPotency: sample.sample_expected_potency,
                        manufactureDate: formatDate(sample.sample_manufacture_date),
                        harvestDate: formatDate(sample.sample_harvest_date),
                        sampleWeightPerIncrement: null,
                        sampleTests: sampleTestsResult,
                        medicinal_batch: sample.medicinal_batch,
                        mhlw_product_type: sample.mhlw_product_type, 
                        expiration_date: formatDate(sample.expiration_date), 
                        best_buy_date: formatDate(sample.best_buy_date), 
                        production_date: formatDate(sample.production_date),
                        date_collected: sample.time_of_collection ? formatDateTimeForOrder(sample.time_of_collection) : null,
                        product_ingredients: sample.sample_product_ingredients ? sample.sample_product_ingredients : null,
                    });
                });
            }
            return serializedSamples;
        }

        rd.serializePayload = function() {
            vm.rd.submitting = true;
            var payload = {
                orderType: "RD",
                collection_type: null,
                customer_account_id: $localStorage.customerId,
                dateCreated: null,
                dateReceived: null,
                date_submitted: null,
                delivery_preference: formatDeliveryPreference(vm.rd.deliveryPreference),
                estimated_arrival_date: formatDate(vm.rd.pickup_arrival_date),
                partially_complete: null,
                poNumber: vm.rd.orderPO,
                reporting_preference: null,
                sample_condition: null,
                sampledDate: formatDate(vm.rd.pickup_arrival_date),
                manufacturingAddress: vm.manufacturingAddress ? vm.manufacturingAddress : null,
                samplingAddress: vm.samplingAddress ? vm.samplingAddress : null,
                invoicing_address: vm.invoicing_address ? vm.invoicing_address : vm.customerData.qbAddress,
                pickup_address: vm.pickup_address ? vm.pickup_address : null,
                phone_number: vm.contact.phone ? vm.contact.phone : null,
                shipping_carrier: null,
                specialInstructions: vm.rd.specialInstructions,
                customerComments: vm.rd.customerComments,
                state: null,
                submitted_by: vm.rd.emailsArray.join(),
                dynamic_turnaround_time: vm.rd.turnaroundTime.includes('10') ? '10 day (standard)' : vm.rd.turnaroundTime,
                id: null,
                samples: rd.serializeSamples(vm.rd.samples),
                tracking_number: vm.rd.tracking_number,
                uploaded_files: vm.rd.uploadedFiles,
                source_workbooks: vm.rd.importedExcelFiles
            }

            return payload;
        }
        

        vm.rd.submitOrder = function() {
            $rootScope.type = 'R&D'
            CustomerOrder.save(rd.serializePayload(), onSaveSuccess, onSaveError);
        };
        // Function to process a single test asynchronously
        function processTest(sample) {
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve(sample);
                }, 1000); 
            });
        }
        
            // },10000)
            // if(vm.rd.submitting){
            //     setInterval(() => {
            //         SweetAlert.swal({
            //             title: "Submitting your order",
            //             text: `Please remain on this page. The order is processing in the background and should submit in a few moments.`,
            //             type: "info"
            //         });
            //     },5000)
            // }
        

        vm.rd.addSample = function() {
            vm.rd.samples.push({
                sample_order_type: 'rd',
                sample_expanded: vm.rd.mainCollapse,
                sample_checked: null,
                sample_delete: false,
                sample_name: null,
                sample_lot_batch_number: null,
                sample_category: null,
                sample_type: null,
                sample_types: null,
                sample_inhalable: null,
                sample_source_id: null,
                sample_tests: [],
                sample_other_analyses: {},
                sample_strain_name: null,
                sample_strain_type: null,
                sample_label_claims: null,
                sample_expected_potency: null,
                sample_has_tests: null,
                sample_panel_by_id: null,
                sample_panel_type: null,
                sample_current_panel_title: null,
                focus: {
                    name: false,
                    lot_batch_number: false,
                    autofill: false
                },
                options: {
                    name: [],
                    lot_batch_number: [],
                    autofill: []
                },
                medicinal_batch: false
            });
            vm.rd.checkPageOne();
        }

        rd.getPanels = function(panel) {
            var assays_dict = [];

            if (panel) {
                // Keep panels intact: do not offer a partial panel when an assay is ineligible.
                if (panel.assays.some(function(assay) {
                    return !shouldShowAssayForLanguage(vm.rd.all_assay_map_by_id[assay.id] || assay);
                })) {
                    return assays_dict;
                }
                panel.assays.forEach(function(assay) {
                    // Simplified assay object with just the essential properties
                    var assayObj = {
                        display_name: assay.title,
                        id: assay.id
                    };
                    
                    // Always include all assays in the panel
                    assays_dict.push(assayObj);
                });
            }

            return assays_dict;
        }

        rd.setPanelsByIdMap = function() {
            vm.rd.qbenchPanels.forEach( function(panel) {
                vm.rd.panel_by_id_map[panel.id] = [panel.title, panel.assays];
            });
            vm.rd.customPanels.forEach( function(panel) {
                vm.rd.panel_by_id_map[panel.id] = [panel.title, panel.assays];
            });
        }

        // Internal helper to standardize pushing a panel with assays (RD)
        rd._processPanel = function(panel, panelType) {
            var assays_dict = rd.getPanels(panel);
          
            // Add ALL assays from the panel to the accessible tests
            assays_dict.forEach(function(assay) {
                if (!assay.in_customer_tests) {
                    // FIRST check if this assay is already in vm.rd.tests
                    var existingTestIndex = findWithAttr(vm.rd.tests, 'id', assay.id);
                    
                    if (existingTestIndex !== -1) {
                        // Test already exists with proper info_modal from getAssayData()
                        // Just mark it as from_panel, don't replace it
                        vm.rd.tests[existingTestIndex].from_panel = true;
                        return; // Skip to next assay
                    }
                    
                    // Now check if we have full assay data
                    var fullAssay = vm.rd.all_assay_map_by_id[assay.id];
                    if (fullAssay && vm.rd.showTestsArray.indexOf(fullAssay.display_name) === -1) {
                        rd.addAssay(fullAssay);
                        fullAssay.from_panel = true;
                    } 
                    else if (!fullAssay) {                        
                        // Fetch the specific assay data
                        Assay.get({id: assay.id}, function(assayData) {
                            if (assayData) {
                                // Filter assay_customer data for current customer if it exists
                                if (assayData.assay_customer && Array.isArray(assayData.assay_customer)) {
                                    for (var i = 0; i < assayData.assay_customer.length; i++) {
                                        if (assayData.assay_customer[i].customer_id === vm.customerData.id) {
                                            assayData.assay_customer = assayData.assay_customer[i];
                                            break;
                                        }
                                    }
                                    // If no match found, set to null
                                    if (Array.isArray(assayData.assay_customer)) {
                                        assayData.assay_customer = null;
                                    }
                                }
                                
                                // Create a proper test object with full data
                                var test = {
                                    info_modal: parseAssayInfoModalData(assayData),
                                    portal_identifier: assayData.portalIdentifier ? assayData.portalIdentifier : null,
                                    portal_client_type: assayData.portal_client_type ? assayData.portal_client_type : null,
                                    portal_client_type_list: assayData.portal_client_type_list ? assayData.portal_client_type_list : null,
                                    display_name: assayData.title,
                                    reporting_title: assayData.reporting_title ? assayData.reporting_title : assayData.title,
                                    base_price: assayData.basePrice,
                                    assay_customer: assayData.assay_customer,
                                    analysis_description: assayData.analysis_description ? assayData.analysis_description : null,
                                    id: assayData.id,
                                    index: vm.rd.tests.length,
                                    from_panel: true
                                };
                                
                                // Add to cache for future use
                                vm.rd.all_assay_map_by_id[assayData.id] = test;
                                vm.rd.all_tests.push(test);
                                
                                // Add to accessible tests if not already there
                                if (vm.rd.showTestsArray.indexOf(test.display_name) === -1) {
                                    rd.addAssay(test);
                                }
                            }
                        }, function(error) {
                            console.error('Failed to fetch assay', assay.id, error);
                        });
                    }
                }
            });

            // Re-create the assay dict now that all panel assays are accessible
            assays_dict = rd.getPanels(panel);

            if (assays_dict.length > 0) {
                vm.rd.qbenchPanels.push({
                    title: panel.title,
                    assays: assays_dict,
                    id: panel.id,
                    type: panelType || 'qbench_panel',
                    description: panel.description,
                    duration: panel.duration,
                    minimum_quantity_required: panel.minimum_quantity_required,
                    turnaround_time: panel.turnaround_time,
                    min_sample_size: panel.min_sample_size,
                    price: panel.price
                });
            }
        };

        rd.pushPanel = function(panel, panelType) {
            if (!panel || !panel.assays || panel.assays.length === 0) {
                if (!panel || !panel.id) {
                    console.warn('RD Panel missing id or assays:', panel);
                    return;
                }
                Panel.get({ id: panel.id }, function(fullPanel) {
                    if (fullPanel && fullPanel.assays && fullPanel.assays.length) {
                        rd._processPanel(fullPanel, panelType);
                    } else {
                        console.warn('RD Panel has no assays after fetch:', panel.id);
                    }
                }, function(e) {
                    console.error('Error fetching RD panel details', e);
                });
                return;
            }

            rd._processPanel(panel, panelType);
        }

        rd.allPanelAssaysPresent = function(assays_dict) {
            // Always return true to show all panels regardless of assay accessibility
            // This matches the behavior in the Food section

            return true;
        }
        
        // Flag to track if customer panels have been loaded
        var customerPanelsLoaded = false;
        
        rd.getCustomerPanels = function() {
            // If customer panels have already been loaded, don't load them again
            if (customerPanelsLoaded) {
                return;
            }
            
            // Get the customer ID from the customerData object
            var customerId = vm.customerData && vm.customerData.id ? vm.customerData.id : null;
            
            if (!customerId) {
                // No customer ID available, skipping customer panels
                return;
            }
            
            // Fetching customer panels
            
            Customer.getPanels({id: customerId},
                function(data) {
         
                    // Set the flag to indicate customer panels have been loaded
                    customerPanelsLoaded = true;
                    
                    // Process each panel
                    data.forEach(function(panel) {
                        rd.pushPanel(panel, 'customer_panel');
                    });
                    
                    // Update the panel_by_id_map to include the customer panels
                    rd.setPanelsByIdMap();
                },
                function(error) {
                    console.error('Error fetching customer panels:', error);
                }
            );
        }
        
        rd.getQbenchPanels = function() {
            // Clear existing panels before loading new ones
            vm.rd.qbenchPanels = [];
            
            // Starting to fetch QBench panels
            
            Panel.query({},
                function(data) {
                    // Processing panels from QBench API
                    
                    data.forEach(function(panel) {
                        if (panel.portalIdentifier) {
                            // Determine customer type for matching
                            var customerType = 'Cannabis'; // default
                            if (vm.rd.customer_type.toLowerCase().indexOf('food') !== -1 || 
                                vm.rd.customer_type.toLowerCase().indexOf('kratom') !== -1 || 
                                vm.rd.customer_type.toLowerCase().indexOf('other') !== -1) {
                                customerType = 'Food';
                            } else if (vm.rd.customer_type.toLowerCase().indexOf('hemp') !== -1) {
                                customerType = 'Hemp';
                            }
                            
                            if (shouldShowPanel(panel, customerType, $localStorage.language)) {
                                rd.pushPanel(panel, 'qbench_panel');
                            }
                        }
                    });
                    
                    rd.getCustomerPanels();
                    rd.getPanelsByCustomer();

                    return;
                },
                function(e) {
                    console.error('Error fetching qbench panels:', e);
                    return;
                }
            );
        }

        rd.getPanelsByCustomer = function() {
            CustomPanel.query({},
                function(data) {
                    vm.rd.customPanels = [];
                    
                    data.forEach(function(panel) {
                        var panelAssays = rd.getPanels(panel);
                        if ($localStorage.language === 'Japanese' && panelAssays.length === 0) {
                            return;
                        }
                        
                        vm.rd.customPanels.push({
                            title: panel.title,
                            assays: panelAssays,
                            id: panel.id,
                            type: 'custom_panel'
                        });
                    });
                    
                    rd.setPanelsByIdMap();
                },
                function(e){
                    console.error('Error fetching custom panels:', e);
                }
            );
        }

        // ***************************** END RND FUNCTIONS *****************************

        $scope.$watch('vm.fullLocationManufactur', function() {
            vm.comp.checkPageTwo();
            vm.rd.checkPageThree();
        })

        $scope.$watch('vm.fullLocationComp', function() {
            vm.comp.checkPageTwo();
        });

        $scope.$watch('vm.fullLocationPickup', function() {
            vm.comp.checkPageTwo();
        });



        setPageTitle();

        function setPageTitle() {
            $rootScope.pageTitle = "Submit";
        }

        vm.error = null;
        vm.pickupOutOfStateError = false;
        vm.orderId = $state.params.id;

        //fix sidebar menu state
        vm.showsidebar = true;

        // changing the sequence of calling of apis
        // getCurrentContact();

        getDataList();

        vm.customers = [];
        $scope.$root.samplesComp = [];
        vm.samplesComp = $scope.$root.samplesComp;

        $scope.$root.samplesRnD = [];
        vm.samplesRnD = $scope.$root.samplesRnD;// samplovi su iz root koji su postavljeni u tom kontroleru iz dijaloga


        vm.orderComp = {
            orderType: "COMPLIANCE",
            collection_type: null,
            customer_account_id: $localStorage.customerId,
            dateCreated: null,
            dateReceived: null,
            date_submitted: null,
            delivery_preference: null,
            estimated_arrival_date: null,
            partially_complete: null,
            poNumber: null,
            reporting_preference: null,
            sample_condition: null,
            sampledDate: null,
            samplingAddress: null,
            invoicing_address: null,
            shipping_carrier: null,
            state: null,
            submitted_by: null,
            turnaround_time: '4-5 day (standard)',

            id: null,
            samples: []

        };

        vm.orderRnD = {
            orderType: "RD",
            collection_type: null,
            customer_account_id: $localStorage.customerId,
            dateCreated: null,
            dateReceived: null,
            date_submitted: null,
            delivery_preference: null,
            estimated_arrival_date: null,
            partially_complete: null,
            poNumber: null,
            reporting_preference: null,
            sample_condition: null,
            sampledDate: null,
            samplingAddress: null,
            invoicing_address: null,
            shipping_carrier: null,
            state: null,
            submitted_by: null,
            turnaround_time: '4-5 day (standard)',

            id: null,
            samples: []

        };

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;
        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.login = login;
        vm.logout = logout;

        if (!vm.isAuthenticated()) {
            $state.go('login');
        }

        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;

        vm.removeAddressId;
        vm.removeAddressElement;
        vm.newAddressList;

        distribution_list_toggle();
        manufacturing_list_toggle();
        invoicing_list_toggle();
        pickup_list_toggle();

        function createAddress(address, city, zipCode, name, medicalLicence, licenceList) {
            var full_address = name + '\n' + address + '\n' + city + ' ' + zipCode;
            var licences = licenceList || medicalLicence;

            if(licences) {
                var parts = licences.split(',');
                for (var i = 0; i < parts.length; i++) {
                    var trimmed = parts[i].trim();
                    if (trimmed) {
                        full_address += '\n' + trimmed;
                    }
                }
            }

            return full_address;
        }

        function createInvoicingAddress(address, city, zipCode, name, state) {
            return name + '\n' + address + '\n' + city + ' ' + zipCode + ' ' + state;
        }

        $scope.copyDistributionData = function(address, city, zipCode, name, medicalLicence, fullLocation, licenceList) {
            vm.samplingAddress = createAddress(address, city, zipCode, name, medicalLicence, licenceList);
            vm.fullLocationComp = fullLocation;
            distribution_list_toggle();
            if(vm.active_tab.comp) {
                vm.distributionAddressDict  = {
                    name: name,
                    address: address,
                    city: city,
                    zipCode: zipCode,
                    medicalLicence: medicalLicence,
                    licenceList: licenceList
                }
            }

        }

        $scope.copyManufacturingData = function(address, city,  zipCode, name, medicalLicence, fullLocation, licenceList) {
            vm.manufacturingAddress =  createAddress(address, city, zipCode, name, medicalLicence, licenceList);
            vm.fullLocationManufactur = fullLocation;
            if(vm.active_tab.comp) {
                vm.comp.cultivationLocation  = {
                    name: name,
                    address: address,
                    city: city,
                    zipCode: zipCode,
                    medicalLicence: medicalLicence,
                    licenceList: licenceList
                }
            }
            else {
                vm.reportingAddressDict = {
                    name: name,
                    address: address,
                    city: city,
                    zipCode: zipCode,
                    medicalLicence: medicalLicence,
                    licenceList: licenceList
                }
            }

            manufacturing_list_toggle();
        }

        $scope.copyInvoicingData = function(address, city, zipCode, name, state) {
            var invoicing_address = createInvoicingAddress(address, city, zipCode, name, state);
            vm.invoicing_address = invoicing_address;
            vm.fullLocationInvoicing = invoicing_address;
            invoicing_list_toggle();
            vm.invoicingAddressDict  = {
                name: name,
                address: address,
                city: city,
                zipCode: zipCode,
                state: state
            }
        }

        $scope.copyPickupData = function(address, city, zipCode, name, state) {

            // Check if pickup address state is California
            if (state && state.toUpperCase() !== 'CA' && state.toUpperCase() !== 'CALIFORNIA') {
                vm.pickupOutOfStateError = true;
                vm.pickup_address = null;
                vm.fullLocationPickup = null;
                pickup_list_toggle();
                return;
            }
            
            vm.pickupOutOfStateError = false;

            var pickup_address = createInvoicingAddress(address, city, zipCode, name, state);
            vm.pickup_address = pickup_address;
            vm.fullLocationPickup = pickup_address;
            pickup_list_toggle();
            vm.pickupAddressDict  = {
                name: name,
                address: address,
                city: city,
                zipCode: zipCode,
                state: state
            }
        }

        $scope.removeAddressData = function(address, addressId, element, input) {
            vm.removeAddressData = address;
            vm.removeAddressId = addressId;
            vm.removeAddressElement = element;

            setTimeout(function() {
                if ('DISTRIBUTION' === input)
                    vm.samplingAddress = "";
                else if ('MANUFACTURING' === input) {
                    vm.manufacturingAddress = "";
                }
                else if ('INVOICING' === input) {
                    vm.invoicingAddress = "";
                }
                else if ('PICKUP' === input) {
                    vm.pickupAddress = "";
                }
            }, 200);
        }

        function distribution_list_toggle() {
            $scope.DistributionList = "Distribution_close";
            $scope.openDistributionList = function() {
                if ($scope.DistributionList === "Distribution_close")
                    $scope.DistributionList = "Distribution_open";
                else
                    $scope.DistributionList = "Distribution_close";
            };
        }

        function manufacturing_list_toggle() {
            $scope.ManufacturingList = "Manufacturing_close";
            $scope.openManufacturingList = function() {
                if ($scope.ManufacturingList === "Manufacturing_close")
                    $scope.ManufacturingList = "Manufacturing_open";
                else
                    $scope.ManufacturingList = "Manufacturing_close";
            };
        }

        function invoicing_list_toggle() {
            $scope.InvoicingList = "Invoicing_close";
            $scope.openInvoicingList = function() {
                if ($scope.InvoicingList === "Invoicing_close")
                    $scope.InvoicingList = "Invoicing_open";
                else
                    $scope.InvoicingList = "Invoicing_close";
            };
        }

        function pickup_list_toggle() {
            $scope.PickupList = "Pickup_close";
            $scope.openpickupList = function() {
                if ($scope.PickupList === "Pickup_close")
                    $scope.PickupList = "Pickup_open";
                else
                    $scope.PickupList = "Pickup_close";
            };
        }

        $scope.newInvoicingAddress = function() {
            vm.InvoicingAddress.locationType = "INVOICING_LOCATION";
            AddressList.save(vm.InvoicingAddress, onSuccessCustomer, function() {

            });

            function onSuccessCustomer(data, headers) {
                getDataList();
            }
        }

        $scope.newPickupAddress = function() {
            vm.PickupAddress.locationType = "PICKUP_LOCATION";
            AddressList.save(vm.PickupAddress, onSuccessCustomer, function() {

            });

            function onSuccessCustomer(data, headers) {
                getDataList();
            }
        }

        $scope.newManufacturingAddress = function() {
            vm.ManufacturingAddress.locationType = "CULTIVATION_LOCATION";
            AddressList.save(vm.ManufacturingAddress, onSuccessCustomer, function() {

            });

            function onSuccessCustomer(data, headers) {
                getDataList();
            }
        }

        $scope.newDistributionAddress = function() {
            vm.DistributionAddress.locationType = "DISTRIBUTION_LOCATION";
            AddressList.save(vm.DistributionAddress, onSuccessCustomer, null);

            function onSuccessCustomer(data, headers) {
                getDataList();
            }
        }

        $scope.removeAddressQuery = function() {
            AddressList.remove({
                id: vm.removeAddressId
            }, onSuccessCustomer, function() {
            });

            function onSuccessCustomer(data, headers) {
                vm.removeAddressElement.currentTarget.parentElement.style.display = "none";
            }
        }


        /* Autocomplate cities */

        var showCityListAllowed = false;
        var showZipListAllowed = false;

        $scope.toggleCity = function () {
          if (showCityListAllowed)
             $scope.showCityList = !$scope.showCityList;
        };

        $scope.toggleZip = function () {
          if (showZipListAllowed)
             $scope.showZipList = !$scope.showZipList;
        };

        $scope.loadCity = function(value) {
          if(typeof value == 'undefined')
            return;

          CityList.get({searchString: value}, function(data) {
            if (data.length == 0) {
              $scope.showCityList = false;
              showCityListAllowed = false;
              return;
            } else {
              $scope.showCityList = true;
              showCityListAllowed = true;
            }

            $scope.cityRecords = data;
          }, null);
        }

        $scope.loadZip = function(value) {
          if(typeof value == 'undefined')
            return;

          ZipList.get({searchString: value}, function(data) {
            if (data.length == 0) {
              $scope.showZipList = false;
              showZipListAllowed = false;
              return;
            } else {
              $scope.showZipList = true;
              showZipListAllowed = true;
            }
            $scope.cityRecordsZips = data;
          }, null);
        }

        $scope.clearCityZipListDataOnClose = function() {
          $scope.cityRecordsZips = [];
          $scope.cityRecords = [];
        }


        $scope.cityClick = function(city, zip, whereTo) {
          if (whereTo === 'MANUFACTURING') {
            vm.ManufacturingAddress.city = city;
            vm.ManufacturingAddress.zipCode = zip;
          } else {
            vm.DistributionAddress.city = city;
            vm.DistributionAddress.zipCode = zip;
          }
          $scope.toggleCity();
        }


        $scope.zipClick = function(value, whereTo) {
          if (whereTo === 'MANUFACTURING') {
            vm.ManufacturingAddress.zipCode = value;
          } else {
            vm.DistributionAddress.zipCode = value;
          }
          $scope.toggleZip();
        }


        /********************************************************************/

        function login() {
            collapseNavbar();
            //LoginService.open();
            $state.go('login');
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('login');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }

        function getDataList() {
            AddressList.get({}, onSuccessCustomer, onErrorCustomer);

            function onSuccessCustomer(data, headers) {
                $scope.records = data;
            }

            function onErrorCustomer(e) {
                console.log(e);
            }
        }

        function getCurrentContact() {
            Contact2ForUser.get({}, onSuccessCustomer, onErrorCustomer);

            function onSuccessCustomer(data, headers) {
                vm.contact = data;
                if (vm.contact.phone === 'null') vm.contact.phone = null;
                // Load panels here to ensure assays are ready

                // Annie commented these to remove duplicate call
                // rd.getQbenchPanels();
                // food.getQbenchPanels();
            }

            function onErrorCustomer(e) {
                console.log(e);
            }
        }

        $scope.submitOrder = function() {
        	vm.isSaving = true;

            vm.orderComp.samples = vm.samplesComp;
            vm.error = null;

            $rootScope.type = vm.orderComp.orderType;

            var date = vm.orderComp.sampledDate;
            date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
            vm.orderComp.sampledDate = date;

            // vm.orderComp.submitted_by = $('#emailToCompliance').val();
            CustomerOrder.save(vm.orderComp, onSaveSuccess, onSaveError);
        }

        $scope.submitorderRnD = function() {
        	vm.isSaving = true;


            var date = vm.orderRnD.estimated_arrival_date;
            date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
            vm.orderComp.estimated_arrival_date = date;

            vm.orderRnD.samples = vm.samplesRnD;

            vm.orderRnD.submitted_by = $('#emailToRD').val();

            $rootScope.type = vm.orderRnD.orderType;
            vm.error = null;

            CustomerOrder.save(vm.orderRnD, onSaveSuccess, onSaveError);
        }


        vm.datePickerOpenStatus.dateReceived = false;
        vm.datePickerOpenStatus.estimated_arrival_date = false;
        vm.datePickerOpenStatus.pickup_arrival_date = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function onSaveSuccess(result) {
            vm.submitData == true;
            if(vm.rd.submitting) vm.rd.submitting = false;
            if(vm.food.submitting) vm.food.submitting = false;
            if(vm.comp.submitting) vm.comp.submitting = false;
            
            vm.isSaving = false;
            vm.orderId = result.id;
            $state.params.id = result.id;
            $state.go('samplesubmit.notify', {
                id: result.id
            });
        }

        function onSaveError(e) {
            console.log(e);
            var error_string = JSON.stringify(e);
            vm.error_string = error_string;

            var request_id = e && e.data && e.data.error ? e.data.error.request_id : undefined;

            
        	vm.isSaving = false;
            vm.error = "ERROR";
            if(vm.food.submitting) vm.food.submitting = false;
            if(vm.comp.submitting) vm.comp.submitting = false;
            if(vm.rd.submitting) vm.rd.submitting = false;
    
            $scope.errorText = '';
            $scope.errorFormPath = '';
            if(e.status == 500 || e.status == 504 || e.status == 400){
                if(vm.customerData.businessType.id == 2){
                    $scope.errorText = `Unfortunately there was an error with your portal submission and your order could not be processed by our LIMS. Our developers have been notified of the error and will look into patching it ASAP.<br /><br />   

                    For this order, please complete a PDF R&D Submission Form instead and include it with your samples. We sincerely apologize for the inconvenience.`;
                    $scope.errorFormPath = 'content/images/Cannabis_Submission_Form.pdf';
                }else{
                    $scope.errorText = `Unfortunately there was an error with your portal submission and your order could not be processed by our LIMS. Our developers have been notified of the error and will look into patching it ASAP.<br /><br />

                    For this order, please complete a PDF Submission Form instead and include it with your samples. We sincerely apologize for the inconvenience.`;
                    $scope.errorFormPath = 'content/images/Anresco-Submission-Form.pdf';
                }
                
            }else{
                $scope.errorText = `Unfortunately there was an error with your portal submission and your order could not be processed by our LIMS. Our developers have been notified of the error and will look into patching it ASAP.<br /><br />

                    For this order, please complete a PDF <a href="content/files/pdf/sample-submit/Anresco-Submission-Form.pdf" download>Submission Form</a> instead and include it with your samples. We sincerely apologize for the inconvenience.`;
            }

            if (request_id)
                $scope.errorText = $scope.errorText + "<br /><br />" + "Request ID: " + request_id;

            SweetAlert.swal({
                title: "Order Submission Error",
                html: true,
                text: $scope.errorText,
                type: "error",
                showCancelButton: true,
                confirmButtonColor: "#4f8fcc",
                confirmButtonText: 'Submission Form',
                closeOnConfirm: true
            }, function(confirm) {
                if(confirm) {
                    if(vm.food.submitting) vm.food.submitting = false;
                    // var a = document.createElement('a');
                    // a.download = `Anresco Error Submit Error.log - ${new Date().toLocaleDateString()}`;
                    // var blob = new Blob([vm.error_string], {type: 'text/plain'});
                    // a.href = window.URL.createObjectURL(blob);
                    // a.click();
                    // a.remove();                   
                    var aAdditionalPDF = document.createElement('a');
                    aAdditionalPDF.download = "SubmissionForm.pdf"; 
                    fetch($scope.errorFormPath) 
                        .then(response => response.arrayBuffer())
                        .then(pdfBuffer => {
                            var pdfBlob = new Blob([pdfBuffer], { type: 'application/pdf' });
                            aAdditionalPDF.href = window.URL.createObjectURL(pdfBlob);
                            aAdditionalPDF.click();
                            aAdditionalPDF.remove();
                        })
                    .catch(error => {
                        console.error("Error fetching additional PDF file:", error);
            });
                }
                else{
                    if(vm.food.submitting) vm.food.submitting = false;
                }
            });
        }

        vm.openShippingGuide = function() {
            // Use different URL for Japanese language
            if ($localStorage.language === 'Japanese') {
                window.open("https://hubs.ly/Q03cmzhp0", "_blank");
            } else {
                window.open("content/files/public/Packaging_and_Shipping_Guidelines_.pdf", "_blank");
            }
        }

        vm.downloadOrderPdf = function() {
            var orderId = $state.params.id;
                        if (orderId) {
                if ($rootScope.type === 'COMPLIANCE') {
                    var fileName = "Compliance Order " + orderId + ".pdf";
                }
                else if ($rootScope.type === 'R&D' || $rootScope.type === 'RD') {
                    var fileName = "R&D Order " + orderId + ".pdf";
                }
                else if ($rootScope.type === 'FOOD') {
                    var fileName = "Analysis Order " + orderId + ".pdf";
                }
                else if ($rootScope.type === 'FDA'){
                    var fileName = "FDA Order " + orderId + ".pdf";
                }

                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                CustomerOrderPdfService.downloadPdf(orderId).then(function(result) {
                    var file = new Blob([result.data], {
                        type: 'application/pdf'
                    });
                    a.href = window.URL.createObjectURL(file);
                    a.download = fileName;
                    a.click();
                });
            }
        }

        rd.setInfoBoxCoordinates = function() {
            var viewBox = $('#wrap');
            var relativeTo = null;
            var target = null;
            var left = null;
            var bottom = null;

            for(var i = 0; i < vm.rd.tests.length; i++) {
                if(vm.rd.tests[i].info_modal) {
                    relativeTo = '#info-modal-icon-' + i.toString();
                    target = '.info-modal-' + i.toString();

                    left = $(relativeTo).offset().left - 218;
                    bottom = viewBox.outerHeight() - $(relativeTo).offset().top - 25;

                    if(viewBox.outerWidth() - left < 350) {
                        left = left - 302;
                        vm.rd.tests[i].left = true;
                    }
                    else {
                        vm.rd.tests[i].left = false;
                    }

                    left = left.toString() + 'px';
                    bottom = bottom.toString() + 'px';

                    $(target).css({ left: left, bottom: bottom })
                }
            }
        }

        food.setInfoBoxCoordinates = function() {
            var viewBox = $('#wrap');
            var relativeTo = null;
            var target = null;
            var left = null;
            var bottom = null;

            for(var i = 0; i < vm.food.tests.length; i++) {
                if(vm.food.tests[i].info_modal) {
                    relativeTo = '#info-modal-icon-' + i.toString();
                    target = '.info-modal-' + i.toString();

                    left = $(relativeTo).offset().left - 218;
                    bottom = viewBox.outerHeight() - $(relativeTo).offset().top - 25;

                    if(viewBox.outerWidth() - left < 350) {
                        left = left - 302;
                        vm.food.tests[i].left = true;
                    }
                    else {
                        vm.food.tests[i].left = false;
                    }

                    left = left.toString() + 'px';
                    bottom = bottom.toString() + 'px';

                    $(target).css({ left: left, bottom: bottom })
                }
            }
        }

        getCustomerData();
        angular.element(document).ready(function() {

            // Scroll is now handled by parent container - no sync needed

            // getCustomerData();

            setTimeout(function() {

                $("#table tr:first > th").each(function(index, element) {
                    index++;
                    var addLi = "<li class='tbl-dot-" + index + "'><span class='tbl-dot'></span></li>";
                    $("ul.tbl-dots").append(addLi);
                });

                var num_col = $("#table tr:first > th").length;
                var constant = 2;
                var constant2 = constant + 1;

                var col_width = 100 / num_col;
                $("#table tr:first > th").css("width", col_width + "%");

                $("#col-prev").click(function() {
                    constant -= 1;
                    constant2 -= 1;
                    if (constant == 2 || constant2 == 2) {
                        $("#col-prev").attr('disabled', 'disabled');
                        $("#col-next").prop("disabled", false);
                    }
                    $('.tbl-col-' + constant).show();
                    $('.tbl-col-' + constant2).show();
                    $('.tbl-dot-' + constant).removeClass('disabled').addClass('active');
                    var x = constant2 + 1;
                    $('.tbl-col-' + x).hide();
                    $('.tbl-dot-' + x).removeClass('active').addClass('disabled');
                    if (constant == 2 || constant2 >= 2) {
                        $("#col-next").prop("disabled", false);
                    }
                });

                $("#col-next").click(function() {
                    constant += 1;
                    constant2 += 1;
                    $('.tbl-col-' + constant).show();
                    $('.tbl-col-' + constant2).show();
                    $('.tbl-dot-' + constant).removeClass('disabled').addClass('active');
                    $('.tbl-dot-' + constant2).removeClass('disabled').addClass('active');
                    var x = constant - 1;
                    var x2 = constant2 - 1;
                    $('.tbl-col-' + x).hide();
                    $('.tbl-dot-' + x).removeClass('active').addClass('disabled');
                    if (constant >= num_col || constant2 >= num_col) {
                        $("#col-next").attr('disabled', 'disabled');
                        $("#col-prev").prop("disabled", false);
                    }
                    $("#col-prev").prop("disabled", false);
                });

            }, 1000);
        });


        $('#emailToCompliance').tagsinput({
            tagClass: function(item) {
                return 'custom-label label-email'
    		}
    	});

        $('#rdEmailRecepients').tagsinput({
            tagClass: function(item) {
                return 'custom-label label-email rdColumnRightLabel'
            },
        });

        $('#foodEmailRecepients').tagsinput({
            tagClass: function(item) {
                return 'custom-label label-email rdColumnRightLabel'
            },
        });

        function getUserEmails() {
            CustomerOrder.getCustomerEmails({},
                function(data) {
                    $('#emailToCompliance').tagsinput({
                        tagClass: function(item) {
                            return 'custom-label label-email'
                        }
                    });

                    $('#rdEmailRecepients').tagsinput({
                        tagClass: function(item) {
                            return 'custom-label label-email rdColumnRightLabel'
                        },
                    });

                    $('#foodEmailRecepients').tagsinput({
                        tagClass: function(item) {
                            return 'custom-label label-email rdColumnRightLabel'
                        },
                    });

                    $('#emailToCompliance').tagsinput('add', data.emails);
                    $('#rdEmailRecepients').tagsinput('add', data.emails);
                    $('#foodEmailRecepients').tagsinput('add', data.emails);

                    $('#emailToCompliance').tagsinput('refresh');
                    $('#rdEmailRecepients').tagsinput('refresh');
                    $('#foodEmailRecepients').tagsinput('refresh');

                    $('input').on('itemAdded', function(event) {
                        !vm.customer_type.includes('food') ? vm.rd.checkPageThree() :  vm.food.checkPageThree();
                    });

                    $('input').on('itemRemoved', function(event) {
                        !vm.customer_type.includes('food') ? vm.rd.checkPageThree() :  vm.food.checkPageThree();
                    });
                    },
                function(e) {
                    console.log(e);
                }
            );
        }

        // leave for now, anresco may want this filter instead of the default angularjs filter
        // $scope.startWith = function(actual, expected) {
        //     var lowerStr = (actual + "").toLowerCase();
        //     return lowerStr.indexOf(expected.toLowerCase()) === 0;
        //   }

    }

})();
